import i18n from "i18next";
import ChainedBackend from "i18next-chained-backend";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next";
import { BASE_URL } from "./api/base";
import { CaseType } from "./views/cases/data/schema";
import { Role } from "./views/users/data/schema";

export let cabinet_case_type: CaseType[] = []
export let cabinet_role: Role[] = []

const local_resources = {
  ar: {
    translation: {
      appname: "AvocatPro",
      common: {
        cancel: "إلغاء",
        creating: "جاري الإنشاء...",
        saving: "جاري الحفظ...",
        delete: "حذف",
        edit: "تعديل",
        add: "إضافة",
        view: "عرض",
      },
      guides: {
        "page_title": "الأدلة والموارد",
        "page_desc": "فيديوهات تعليمية وأفضل الممارسات للاستفادة القصوى من AvocatPro",
        "search_placeholder": "ابحث عن دليل...",
        "all": "الكل",
        "best_practices": "أفضل الممارسات",
        "empty": "لم يتم العثور على أي دليل.",
        "modules": {
          "general_overview": "نظرة عامة",
          "home_dashboard": "لوحة القيادة",
          "appointments": "جدول المواعيد",
          "cases": "القضايا",
          "clients": "الموكلون",
          "adversaries": "الخصوم",
          "invoicing": "الفوترة",
          "expenses": "المصاريف",
          "fees": "الأتعاب",
          "lawyer_assignment": "تعيين المحامين",
          "external_lawyers": "المحامون الخارجيون",
          "team_permissions": "الفريق والصلاحيات",
          "ai_assistant": "المساعد الذكي",
          "settings": "الإعدادات",
          "dossier_mobile": "تطبيق الهاتف",
          "other": "أخرى"
        },
        "tips": {
          "general_overview": [
            "ابدأ بفيديو التعريف ثم تابع الأدلة بالترتيب المقترح.",
            "أعدّ مكتبك أولاً (الملف، الفريق، الأدوار) قبل إدخال القضايا."
          ],
          "home_dashboard": [
            "اطّلع على لوحة القيادة كل صباح: الجلسات، المواعيد ومهام اليوم.",
            "سجّل مهامك فور ظهورها حتى لا تنسى شيئاً."
          ],
          "appointments": [
            "اربط كل موعد أو جلسة بالقضية المعنية دائماً.",
            "حدّد المكان (المكتب أو المحكمة) ووقت النهاية لتفادي التعارض.",
            "راجع أجندة الأسبوع كل يوم جمعة."
          ],
          "cases": [
            "اعتمد ترقيماً موحداً (الرقم، الرمز، السنة) لتجد الملف بسرعة.",
            "أدخل الموكل والمحكمة ومبلغ الأتعاب عند إنشاء القضية.",
            "حدّث حالة القضية بعد كل جلسة."
          ],
          "clients": [
            "ميّز بين الشخص الذاتي والشركة.",
            "أدخل الهاتف والبريد الإلكتروني فهما يستعملان للتذكير والفوترة.",
            "تجنّب التكرار: ابحث عن الموكل قبل إضافته."
          ],
          "adversaries": [
            "سجّل الطرف الآخر منذ فتح القضية.",
            "احتفظ ببياناته كاملة للإشعارات والإجراءات."
          ],
          "invoicing": [
            "تحقق من TVA والاقتطاع من المصدر (RAS TVA / RAS IR) قبل إصدار الفاتورة.",
            "حدّد دائماً تاريخ استحقاق لمتابعة المتأخرات.",
            "فصّل البنود (الوصف، الكمية، الثمن) لتفادي النزاعات."
          ],
          "expenses": [
            "سجّل كل مصروف في يومه مع فئته.",
            "اربط مصاريف الموكل بقضيته لإعادة فوترتها.",
            "افصل مصاريف المكتب عن مصاريف القضايا."
          ],
          "fees": [
            "تابع باستمرار المبلغ المدفوع والمتبقي لكل قضية.",
            "صدّر الملخص لمراجعاتك الشهرية للسيولة."
          ],
          "lawyer_assignment": [
            "حدّد المحاكم وأنواع الملفات لكل محامٍ.",
            "أبقِ ملفاً نشطاً لكل محامٍ لتوزيع عادل."
          ],
          "external_lawyers": [
            "سجّل زملاءك الشركاء بالاسم والبريد المحدّث.",
            "تأكد من اتفاق السرية قبل مشاركة أي ملف."
          ],
          "team_permissions": [
            "طبّق مبدأ أقل صلاحية: امنح كل شخص الدور الضروري فقط.",
            "عطّل فوراً حساب أي متعاون يغادر المكتب."
          ],
          "ai_assistant": [
            "اطرح أسئلة دقيقة وحدّد القضية المعنية.",
            "تحقق دائماً من المراجع القانونية قبل استعمالها.",
            "لا تشارك بيانات حساسة دون حاجة."
          ],
          "settings": [
            "أكمل ملف المكتب: يظهر في فواتيرك ووثائقك.",
            "راقب اشتراكك واستهلاكك بانتظام."
          ],
          "dossier_mobile": [
            "ثبّت التطبيق لمتابعة جلساتك أثناء التنقل.",
            "فعّل الإشعارات حتى لا يفوتك أي تذكير."
          ]
        },
        proposal_message: "هل ترغب في مشاهدة دليل سريع حول \"{{title}}\"؟",
        watch_video: "شاهد الفيديو الآن",
        no_thanks: "لا، شكراً",
        close: "إغلاق",
        video_error: "تعذر تحميل الفيديو، يرجى المحاولة لاحقاً.",
      },
      last_week: "الأسبوع الماضي",
      last_month: "الشهر الماضي",
      last_year: "العام الماضي",
      custom: "مخصص",
      filter_by_period: "تصفية حسب الفترة",
      pick_date_range: "اختر نطاق التاريخ",
      filter_by_date: "تصفية حسب التاريخ",
      min_amount: "المبلغ الأدنى",
      max_amount: "المبلغ الأقصى",
      reset_filters: "إعادة ضبط الفلاتر",
      login: "تسجيل الدخول",
      user: "إسم المستخدم",
      pass: "كلمة المرور",
      log_ins: "المرجو إدخال إسم المستخدم و كلمة المرور.",
      forgot_pass: "فقدت كلمة المرور؟",
      remember_me: "تذكرني",
      notifications: "الإشعارات",
      no_notifications: "لا توجد إشعارات",
      all_caught_up: "أنت على اطلاع بكل شيء",
      unread: "غير مقروء",
      mark_as_read_and_continue: "قرأت وفهمت",
      dir: "rtl",
      forgot_password_title: "هل نسيت كلمة المرور؟",
      forgot_password_desc: "أدخل اسم المستخدم والبريد الإلكتروني لإرسال رابط إعادة تعيين كلمة المرور.",
      send_reset_link: "إرسال رابط إعادة التعيين",
      sending: "جارٍ الإرسال...",
      reset_link_sent_title: "تم إرسال رابط إعادة تعيين كلمة المرور",
      reset_link_sent_desc: "لقد أرسلنا رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني.",
      reset_link_sent_message: "يرجى التحقق من بريدك الإلكتروني للحصول على رابط إعادة تعيين كلمة المرور. إذا لم تستلم البريد الإلكتروني، يرجى التحقق من مجلد الرسائل غير المرغوب فيها أو المحاولة مرة أخرى.",
      back_to_login: "العودة إلى تسجيل الدخول",
      verify_email_title: "تحقق من بريدك الإلكتروني",
      verify_email_desc: "يتطلب حسابك التحقق من البريد الإلكتروني. لقد أرسلنا بريدًا يحتوي على رابط.",
      user_placeholder: "الإسم",
      enter_user: "المرجو إدخال إسم المستخدم",
      enter_pass: "المرجو إدخال كلمة المرور",
      tos: "من خلال النقر على تسجيل الدخول، فإنك توافق على شروط الخدمة وسياسة الخصوصية الخاصة بنا.",
      privacy_policy: 'سياسة الخصوصية الخاصة بنا',
      signup: "إنشاء حساب",
      signup_subtitle: "إنشاء حساب مكتب جديد.",
      have_account: "لديك حساب بالفعل؟",
      dont_have_account: "ليس لديك حساب؟",
      agree_privacy: "بتسجيلك، فإنك توافق على ",
      step: "الخطوة",
      back: "رجوع",
      next: "التالي",
      actions: "إجراءات",
      signup_step_account: "معلومات الحساب",
      signup_step_cabinet: "معلومات المكتب",
      signup_step_preferences: "التفضيلات",
      preferred_language: "اللغة المفضلة",
      arabic: "العربية",
      french: "الفرنسية",
      step_of_total: "الخطوة {{current}} / {{total}}",
      username_placeholder: "اختر اسم المستخدم",
      password_hint: "على الأقل 8 أحرف",
      password_min_8: "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل",
      cabinet_name_required: "اسم المكتب مطلوب",
      billing_name_required: "الاسم للفوترة مطلوب",
      billing_email_required: "البريد الإلكتروني للفوترة مطلوب",
      signup_review_message: "سنقوم بتعيين اللغة والمنطقة الزمنية تلقائيًا. راجع التفاصيل ثم أرسل.",
      availability_intro: "تتم مراجعة حسابك من قبل فريقنا قبل التفعيل. أخبرنا بالوقت المناسب للتواصل معك (أيام العمل).",
      availability_days: "الأيام المتاحة",
      availability_slot: "الوقت المفضل",
      availability_slot_placeholder: "صباحًا أو مساءً",
      availability_days_required: "اختر يومًا واحدًا على الأقل",
      availability_slot_required: "اختر فترة زمنية",
      day_mon: "الإثنين",
      day_tue: "الثلاثاء",
      day_wed: "الأربعاء",
      day_thu: "الخميس",
      day_fri: "الجمعة",
      slot_morning: "صباحًا",
      slot_afternoon: "مساءً",
      signup_pending_title: "حسابك قيد المراجعة",
      signup_pending_desc: "يقوم فريقنا بمراجعة كل مكتب جديد. سنتواصل معك خلال الوقت الذي حددته.",
      signup_rejected_title: "تم رفض الطلب",
      signup_rejected_desc: "يرجى التواصل مع الدعم للحصول على مزيد من المعلومات.",
      creating_account: "جاري إنشاء الحساب...",
      cabinet_name: "اسم المكتب",
      billing_name: "الاسم للفوترة",
      billing_email: "البريد الإلكتروني للفوترة",
      cabinet_name_placeholder: "اسم مكتبك",
      billing_name_placeholder: "الاسم القانوني للفوترة",
      billing_email_placeholder: "البريد الإلكتروني للفوترة",
      serv_error: "لا يمكن الاتصال بالخادم",
      serv_wrong_resp: "الخادم يرسل استجابة خاطئة",
      email: "البريد الإلكتروني",
      invalid_email: "بريد إلكتروني خاطئ",
      email_placeholder: "البريد الإلكتروني",
      confirm_new_pass: "المرجو تأكيد كلمة المرور الجديدة",
      new_pass_placeholder: "كلمة المرور الجديدة",
      confirm_new_pass_placeholder: "تأكيد كلمة المرور الجديدة",
      passwords_do_not_match: "كلمتا المرور غير متطابقتين",
      reset_password_title: "إعادة تعيين كلمة المرور",
      reset_password_desc: "أدخل كلمة المرور الجديدة وأكدها.",
      resetting_password: "تتم إعادة تعيين كلمة المرور...",
      reset_password: "إعادة تعيين كلمة المرور",
      password_reset_success_title: "تمت إعادة تعيين كلمة المرور بنجاح",
      password_reset_success_desc: "يمكنك الآن تسجيل الدخول باستخدام كلمة المرور الجديدة.",

      // Dashboard
      dashboard: "لوحة القيادة",
      add_new_file: "إضافة ملف جديد",

      upcoming_sessions: "الجلسات القادمة",
      active_files: "ملفات نشطة",
      todays_appointments: "مواعيد اليوم",
      pending_tasks: "مهام معلقة",
      todays_agenda: "جدول أعمال اليوم",
      good_morning: "صباح الخير",
      good_evening: "مساء الخير",
      agenda_time_morning: "صباحاً",
      agenda_time_evening: "مساءً",
      upcoming_appointments_this_month: "{{count}} مواعيد متبقية لهذا الشهر",
      // Dashboard Refinements
      dashboard_recent_files: "أحدث الملفات",
      next_appointment: "الموعد التالي",
      no_upcoming_appointments: "لا توجد مواعيد قادمة",
      professor_title: "أستاذ",
      dashboard_subtitle: "إليك ملخص لأعمال مكتبك لهذا اليوم.",
      view_full_schedule: "عرض الجدول الكامل",
      today_in_trend: "اليوم",
      new_files_this_week: "ملفات جديدة هذا الأسبوع",
      active_tasks_count_label: "مهام نشطة",
      quick_tasks: "المهام السريعة",
      no_active_tasks: "لا توجد مهام نشطة. أضف مهمة جديدة للبدء!",
      add_new_task_placeholder: "أضف مهمة جديدة...",
      task_added: "تم إضافة المهمة",
      task_added_desc: "تمت إضافة المهمة بنجاح",
      task_limit_reached: "لقد وصلت إلى الحد الأقصى من 10 مهام نشطة. يرجى إكمال بعض المهام أولاً.",
      task_add_failed: "فشل في إضافة المهمة. يرجى المحاولة مرة أخرى.",
      task_update_failed: "فشل في تحديث المهمة. يرجى المحاولة مرة أخرى.",
      task_deleted: "تم الحذف",
      task_deleted_desc: "تم حذف المهمة بنجاح",
      task_delete_failed: "فشل في حذف المهمة. يرجى المحاولة مرة أخرى.",
      // Agenda List
      session: "جلسة",
      office_meeting: "مكتب",
      done: "تم الإنجاز",
      no_appointments_today: "لا توجد مواعيد اليوم",
      // Recent Files Table
      file_number: "رقم الملف",
      file_name: "اسم الملف",
      client_header: "الموكل",
      status_header: "الحالة",
      last_update_header: "آخر تحديث",
      dashboard_file_status_active: "جاري",
      dashboard_file_status_pending: "انتظار حكم",
      dashboard_file_status_closed: "محكوم",
      status_archived_at: "مؤرشف",


      calendar: "جدول المواعيد",
      view_calendar: "عرض التقويم",
      selectMonth: "اختر الشهر",
      loading_analysis: "جارٍ تحميل التحليل...",
      no_analysis_content: "لا يوجد محتوى تحليل بعد. حاول إعادة الفتح أو التحديث.",
      no_analysis_available: "لا يوجد تحليل متاح بعد.",
      no_content: "لا يوجد محتوى",
      generate: "توليد",
      generated_at: "تم التوليد في:",
      text_length: "طول النص:",
      analysis_ready: "التحليل جاهز",
      failed_to_get_analysis: "فشل في الحصول على التحليل",
      failed_to_generate_analysis: "فشل في توليد التحليل",
      show_analysis: "عرض التحليل",
      cases: "القضايا",
      clients: "الموكلين",
      client: "الموكل",
      for_client: "لفائدة",
      users: "المستخدمون",
      other_pages: "صفحات أخرى",
      settings: "إعدادات",
      account: "الحساب الشخصي",
      invoices: "الفواتير",
      cabinet_billing_desc: "عرض وتنزيل فواتير مكتبك.",
      invoice_number: "رقم الفاتورة",
      issue_date: "تاريخ الإصدار",
      no_invoices: "لا توجد فواتير بعد.",
      paid: "مدفوعة",
      pending: "قيد الانتظار",
      failed: "فشل",
      invoice: {
        number: "رقم الفاتورة",
        issue_date: "تاريخ الإصدار",
        status: "الحالة",
        total: "الإجمالي",
        Total: "الإجمالي",
        actions: "إجراءات",
        Actions: "إجراءات",
        download_pdf: "تحميل PDF",
        no_pdf: "لا يوجد رابط"
      },
      add_rendezvous: "إضافة موعد",
      rendezvous_list: "قائمة المواعيد",
      users_list: "قائمة المستخدمين",
      users_list_desc: "قم بإدارة مستخدميك هنا",
      name: "الاسم الكامل",
      status: "حالة الحساب",
      admin: "مدير",
      role: "الدور",
      created_at: "تاريخ التسجيل",
      updated_at: "تاريخ التحديث",
      last_activity: "آخر نشاط",
      cabinet_admin: "مدير المكتب",
      approval_status: "حالة الطلب",
      approval_pending: "قيد الانتظار",
      approval_approved: "مقبول",
      approval_rejected: "مرفوض",
      admin_phone: "هاتف المدير",
      admin_email: "البريد الإلكتروني للمدير",
      status_active: "مفعل",
      status_locked: "مغلق",
      table_load_error: "خطأ في تحميل البيانات. يرجى المحاولة مرة أخرى لاحقًا.",
      no_results: "لا توجد أي نتيجة.",
      role_name: ["غير معروف"],
      search_by_name: "البحث بالاسم...",
      search_by_case_id: "البحث برقم القضية",
      year: "السنة",
      number: "الرقم",
      code: "الرمز",
      search_by_case_name: "البحث باسم القضية",
      pagination: "الصفحة {{current_page}} من {{total_pages}}",
      rows_per_page: "الصفوف لكل صفحة",
      add_user: "إضافة مستخدم",
      go_first_page: "اذهب إلى الصفحة الأولى",
      go_last_page: "اذهب إلى الصفحة الأخيرة",
      go_next_page: "اذهب إلى الصفحة التالية",
      go_prev_page: "اذهب إلى الصفحة السابقة",
      selected: "{{selected}} مختار",
      clear_filters: "إلغاء الخيارات",
      filters: "الفلاتر",
      user_add_info: "أضف مستخدما جديدا هنا",
      user_action: "انقر على حفظ بعد الانتهاء.",
      save: "حفظ",
      edit_user: "تعديل المستخدم",
      select_role: "اختر الدور",
      select_account_status: "اختر حالة الحساب",
      name_placeholder: "محمد علي",
      title: "العنوان",
      name_required: "الاسم الكامل مطلوب",
      username_required: "يجب أن يتكون اسم المستخدم من 4 أحرف على الأقل",
      email_invalid: "البريد الإلكتروني غير صالح",
      phone_invalid: "رقم الهاتف غير صالح",
      loading: "جارٍ التحميل",
      plans: "الباقات",
      "Plans": "الباقات",
      subscriptions: "الاشتراكات",
      "Subscriptions": "الاشتراكات",
      no_subscriptions: "لا توجد اشتراكات",
      plan: "باقة",
      price: "السعر",
      public: "عام",
      current_plan: "الباقة الحالية",
      plans_mgmt_desc: "إدارة باقات الاشتراك للمنصة.",
      create_plan: "إنشاء باقة",
      edit_plan: "تعديل الباقة",
      monthly_price_mad: "السعر الشهري (درهم)",
      yearly_price_mad: "السعر السنوي (درهم)",
      monthly_token_cap: "الحد الشهري للرسائل",
      audio_access_enabled: "تشغيل الوصول الصوتي",
      max_storage_mb: "أقصى تخزين (MB)",
      extras: "خصائص إضافية",
      no_extras: "لا توجد خصائص إضافية",
      recommended: "موصى بها",
      delete_plan_confirm: "هل تريد حذف الباقة \"{{name}}\"؟",
      failed_to_load_plans: "فشل تحميل الباقات",
      failed_to_create_plan: "فشل إنشاء الباقة",
      failed_to_update_plan: "فشل تحديث الباقة",
      failed_to_delete_plan: "فشل حذف الباقة",
      cabinet_plans_desc: "اختر باقة اشتراك لمكتبك.",
      already_subscribed: "لديك اشتراك نشط",
      no_plans_available: "لا توجد باقات متاحة",
      free: "مجاني",
      trial_days: "أيام تجربة",
      or: "أو",
      storage: "التخزين",
      max_users: "الحد الأقصى للمستخدمين",
      max_cases: "الحد الأقصى للقضايا",
      max_active_cases: "الحد الأقصى للقضايا النشطة",
      ai_assistance: "مساعدة الذكاء الاصطناعي",
      audio_access: "الوصول إلى الصوت",
      included: "مشمول",
      not_included: "غير مشمول",
      monthly_ai_tokens: "رسائل الذكاء الاصطناعي الشهرية",
      unlimited: "غير محدود",
      choose_plan: "اختر الباقة",
      confirm_choose_plan: "تأكيد اختيار الباقة وطريقة الدفع.",
      user_added: "تم إضافة المستخدم {{user}}",
      user_updated: "تم تحديث المستخدم {{user}}",
      user_made_admin: "تم تعيين {{user}} كمدير",
      user_admin_revoked: "تم إلغاء صلاحيات المدير لـ {{user}}",
      idnumber: "رقم الهوية",
      idnumber_placeholder: "C123456789",
      idnumber_invalid: "رقم الهوية غير صالح",
      client_added: "تم إضافة الموكل {{client}}",
      client_updated: "تم تحديث الموكل {{client}}",
      username_taken: "اسم المستخدم مأخوذ",
      role_needed: "مطلوب الدور",
      status_needed: "مطلوب حالة الحساب",
      delete: "حذف",
      edit: "تعديل",
      make_admin: "تعيين كمدير",
      revoke_admin: "إزالة المدير",
      delete_confirm: "هل أنت متأكد أنك تريد حذف {{user}}؟",
      delete_warn: "لا يمكن التراجع عن هذه العملية.",
      warning: "تحذير",
      ai_response: "رد الذكاء الاصطناعي",
      appointment: "موعد",
      archive_error: "حدث خطأ أثناء الأرشفة",
      delete_user: "حذف المستخدم",
      cancel: "إلغاء",
      reset_pass: "إعادة كلمة المرور",
      remove: "إزالة",
      user_removed: "تم إزالة المستخدم {{user}}",
      client_removed: "تم إزالة الموكل {{client}}",
      reset_pass_user: "إعادة تعيين كلمة مرور المستخدم",
      reset_pass_confirm:
        "هل أنت متأكد أنك تريد إعادة تعيين كلمة مرور المستخدم {{user}}؟",
      reseted_pass: "تم إنشاء كلمة مرور جديدة للمستخدم {{user}}",
      new_pass: "كلمة المرور الجديدة",
      new_pass_notice:
        "يرجى عدم نسيان إعطاء كلمة المرور الجديدة للمستخدم {{user}}.",
      confirm: "تأكيد",
      make_admin_confirm_title: "تأكيد تعيين كمدير",
      make_admin_confirm_desc: "هل أنت متأكد أنك تريد تعيين {{user}} كمدير؟",
      revoke_admin_confirm_title: "تأكيد إلغاء صلاحيات المدير",
      revoke_admin_confirm_desc: "هل أنت متأكد أنك تريد إلغاء صلاحيات المدير لـ {{user}}؟",
      clip: "نسخ إلى الحافظة",
      clients_list: "قائمة الموكلين",
      clients_list_desc: "قم بإدارة موكليك هنا",
      phone: "رقم الهاتف",
      added_by: "أضيف بواسطة",
      search_country: "ابحث عن الدولة...",
      client_name_taken: "اسم الموكل مأخوذ",
      client_name_required: "يجب أن يكون اسم الموكل أطول من 4 أحرف",
      client_name: "اسم الموكل",
      client_type: "نوع الموكل",
      add_client: "إضافة موكل",
      edit_client: "تعديل الموكل",
      delete_client: "حذف الموكل",
      open_menu: "فتح القائمة",
      close: "إغلاق",
      case_id: "معرف القضية",
      assigned_to: "المسؤول",
      case_name_required: "اسم القضية مطلوب",
      case_name_taken: "اسم القضية مأخوذ",
      invalid_year: "سنة غير صالحة",
      invalid_code: "رمز القضية غير صالح",
      invalid_number: "رقم القضية غير صالح",
      case_added: "تم إضافة القضية {{case}}",
      case_updated: "تم تحديث القضية {{case}}",
      case_removed: "تم حذف القضية {{case}}",
      edit_case: "تعديل القضية",
      add_case: "إضافة قضية",
      create_case: "إنشاء قضية",
      create_case_file: "إنشاء ملف القضية",
      create_case_file_from_relation: "إنشاء قضية جديدة من هذا الارتباط",
      case_placeholder: "اسم القضية",
      case_type_name: ["غير معروف"],
      case_type: "نوع الملف",
      case_name: "اسم القضية",
      case_not_found: "لم يتم العثور على الملف",
      case_list: "قائمة القضايا",
      case_list_desc: "قم بإدارة قضاياك هنا",
      invalid_case_id: "رقم ملف غير صالح",
      invalid_full_case_id: "الرقم الكامل للملف غير صالح",
      visibility: "خصوصية القضية",
      select_visibility: "اختر مستوى الخصوصية",
      visibility_not_set: "غير محدد",
      visibility_public: "عام",
      visibility_partial: "جزئي",
      visibility_private: "خاص",
      limited_access_case: "لديك وصول جزئي إلى هذه القضية",
      // Calendar view labels
      today: "اليوم",
      month: "شهر",
      week: "أسبوع",
      day: "يوم",
      monthView: "عرض الشهر",
      weekView: "عرض الأسبوع",
      dayView: "عرض اليوم",

      // Lawyer filter combobox
      avocat: "المحامي",
      allLawyers: "جميع المحامين",
      searchLawyer: "بحث...",
      noResults: "لا توجد نتائج",

      // Loading and empty states
      clickToAddAppointment: "انقر لإضافة موعد",
      noAppointments:
        'لا توجد مواعيد في هذا اليوم. انقر على زر "إضافة موعد جديد" لإنشاء موعد.',
      // Action buttons
      addNewAppointment: "إضافة موعد جديد",
      createNewAppointment: "إنشاء موعد جديد",
      createAppointmentFor: "إنشاء موعد ليوم",
      create: "إنشاء موعد",
      editAppointment: "تعديل الموعد",
      editAppointmentFor: "تعديل الموعد ليوم",
      postpone: "تأجيل",
      postponeAppointment: "تأجيل الموعد",
      postponeAppointmentFor: "تأجيل الموعد ليوم",
      postponeDate: "تاريخ التأجيل",
      appointmentPostponed: "تم تأجيل الموعد بنجاح",
      postponedFromMsg: "تم تأجيل هذا الموعد من {{date}}",
      meetingPostponed: "هذا الموعد مؤجل",
      meetingPostponedWarning: "تم تأجيل هذا الموعد! موعد الالتقاء تغير.",
      meetingPostponedToNewTime: "تم تأجيل هذا الموعد إلى موعد جديد",
      update: "تحديث",
      // Form labels
      description: "الوصف",
      desc_desc: "أدخل وصفا اختياريا",
      caseNumber: "رقم القضية",
      casePrefix: "قضية",
      procedureType: "نوع الإجراء",
      startTime: "وقت البدء",
      endTime: "وقت الانتهاء",
      system: "النظام",
      // Location options
      location: "مكان الاجتماع",
      meetingType: "نوع الاجتماع",
      court: "في المحكمة",
      office: "في المكتب",
      courtHearing: "جلسة بالمحكمة",
      courtMeetingHelp: "إلزامية الربط بملف قضائي",
      officeMeeting: "موعد بالمكتب",
      officeMeetingHelp: "استشارة أو اجتماع",
      appointmentSchedule: "التوقيت والمدة",
      duration: "المدة",
      selectTime: "تحديد الوقت",
      hours: "الساعات",
      minutes: "الدقائق",
      now: "الآن",
      caseHelpCourt: "إلزامي لجلسات المحكمة",
      caseHelpOffice: "اختياري للمواعيد",
      locationRequired: "يجب تحديد مكان الاجتماع",
      meetingInProgress: "اجتماع جاري حالياًً",
      pick_a_date: "اختر تاريخاً",
      // Procedure types with proper typing
      procedureTypes: {
        initial: "جلسة أولى",
        review: "مراجعة",
        hearing: "جلسة استماع",
        judgment: "النطق بالحكم",
        appeal: "استئناف",
        consultation: "استشارة",
        other: "أخرى",
      },
      selectProcedureType: "اختر نوع الإجراء",
      // Validation messages
      descriptionRequired: "الوصف مطلوب",
      caseRequired: "القضية مطلوبة",
      procedureRequired: "نوع الإجراء مطلوب",
      attorneyRequired: "يجب تحديد المحامي المسؤول",
      startTimeRequired: "وقت البدء مطلوب",
      endTimeRequired: "وقت الانتهاء مطلوب",
      endTimeAfterStart: "يجب أن يكون وقت الانتهاء بعد وقت البدء",
      // Success messages
      appointmentCreated: "تم إنشاء الموعد",
      appointmentUpdated: "تم تحديث الموعد",
      appointmentDeleted: "تم حذف الموعد",
      // Error messages
      error: "خطأ",
      createError: "فشل في إنشاء الموعد. يرجى المحاولة مرة أخرى.",
      updateError: "حدث خطأ أثناء تحديث الموعد",
      deleteError: "فشل في حذف الموعد. يرجى المحاولة مرة أخرى.",
      fetchError: "فشل في تحميل بيانات التقويم. يرجى المحاولة مرة أخرى.",
      saveError: "حدث خطأ أثناء حفظ الموعد. يرجى المحاولة مرة أخرى.",
      appointmentError: "خطأ في الموعد:",
      invalidTime: "وقت غير صالح",
      dateParseError: "خطأ في تحليل تاريخ الاجتماع:",
      meetingDateParseError: "خطأ في تحليل تواريخ الاجتماع:",
      dateFormatError: "خطأ في تنسيق التاريخ:",
      notAvailable: "غير متوفر",
      select_date: "اختر التاريخ",
      invalidDate: "تاريخ غير صالح",
      confirmDelete: "تأكيد الحذف",
      areYouSureYouWantToDeleteThisEvent: "هل أنت متأكد أنك تريد حذف هذا الموعد؟",
      // Week days
      monday: "الإثنين",
      tuesday: "الثلاثاء",
      wednesday: "الأربعاء",
      thursday: "الخميس",
      friday: "الجمعة",
      saturday: "السبت",
      sunday: "الأحد",
      // Abbreviated week days for mobile
      mon_short: "إث",
      tue_short: "ثل",
      wed_short: "أر",
      thu_short: "خم",
      fri_short: "جم",
      sat_short: "سب",
      sun_short: "أح",

      // Event details
      event_details_description: "معلومات مفصلة حول حدث التقويم.",
      case: "القضية",
      select_case: "اختر القضية",
      select: "اختر",
      procedureLabel: "نوع الإجراء",
      case_code: "رمز الملف",
      case_number: "رقم الملف",
      case_year: "السنة",
      case_number_full: "الرقم الكامل للملف",
      select_client: "اختر الموكل",
      no_more_results: "لا توجد نتائج أخرى",
      select_case_type: "اختر الملف",
      tribunal: "المحكمة",
      select_case_location: "اختر المحكمة",
      select_user: "اختر المستخدم المعين",
      client_needed: "الموكل مطلوب",
      assigned_to_needed: "المستخدم المعين مطلوب",
      delete_case: "حذف القضية",
      case_status: "حالة الملف",
      active: "نشط",
      is_active: "نشط",
      archived: "مؤرشف",
      archive: "أرشفة",
      unarchive: "إلغاء الأرشفة",
      archive_case: "أرشفة الملف",
      unarchive_case: "فك أرشفة القضية",
      
      // Case Statuses
      "case_status.active": "رائج",
      "case_status.audience": "جلسة",
      "case_status.delibere": "المداولة",
      "case_status.suspended": "موقوفة",
      "case_status.closed": "محكوم",
      "case_status.archived": "مؤرشف",
      "case_status.incomplete": "غير مكتمل",

      // Case Jurisprudence
      case_jurisprudence: "الاجتهادات القضائية",
      case_jurisprudence_desc: "إدارة الملاحظات والاجتهادات القضائية لهذا الملف",
      add_jurisprudence: "إضافة اجتهاد",
      no_jurisprudence_found: "لا توجد اجتهادات",
      no_jurisprudence_desc: "لم يتم إضافة أي اجتهادات لهذا الملف بعد.",
      add_first_jurisprudence: "إضافة أول اجتهاد",
      download_pdf: "تحميل PDF",
      jurisprudence_added: "تمت إضافة الاجتهاد",
      jurisprudence_updated: "تم تحديث الاجتهاد",
      jurisprudence_deleted: "تم حذف الاجتهاد",
      edit_jurisprudence: "تعديل الاجتهاد",
      delete_jurisprudence: "حذف الاجتهاد",
      delete_jurisprudence_confirm: "هل أنت متأكد أنك تريد حذف هذا الاجتهاد؟",
      jurisprudence_title_placeholder: "أدخل العنوان",
      jurisprudence_content_placeholder: "أدخل المحتوى",
       


      confirm_archive_case: "هل أنت متأكد من رغبتك في أرشفة الملف {{case}}؟",
      confirm_unarchive_case: "هل أنت متأكد من رغبتك في إلغاء أرشفة الملف {{case}}؟",
      archived_at: "تاريخ الأرشفة",
      case_archived: "تم أرشفة الملف {{case}}",
      case_unarchived: "تم إلغاء أرشفة الملف {{case}}",
      
      // Case page translations
      overview: "نظرة عامة",
      files: "مرفقات",
      comments: "التعليقات",
      payments: "الأتعاب",
      "Payments": "الأتعاب",
      case_payments: "أتعاب القضية",
      payments_desc: "سجل الأتعاب والرسوم المتعلقة بهذه القضية",
      add_payment: "إضافة دفعة",
      payment: "دفعة",
      add_payment_desc: "إضافة دفعة جديدة لهذه القضية",
      payment_amount: "المبلغ",
      payment_note: "الوصف",
      payment_date: "تاريخ الدفع",
      payment_note_placeholder: "وصف الدفعة",
      payment_added: "تمت إضافة الدفعة",
      payment_updated: "تم تحديث الدفعة",
      payment_deleted: "تم حذف الدفعة",
      edit_payment: "تعديل الدفعة",
      edit_payment_desc: "تعديل تفاصيل الدفعة لهذه القضية",
      select_deposit_date: "اختر تاريخ الدفع",
      error_fetching_payments: "خطأ في جلب الدفعات",
      error_updating_payment: "خطأ في تحديث الدفعة",
      error_adding_payment: "خطأ في إضافة الدفعة",
      error_deleting_payment: "خطأ في حذف الدفعة",
      total_payments: "إجمالي الدفعات",
      payments_list_desc: "إدارة و التحقق من أتعاب المكاتب.",
      payment_details: "تفاصيل الدفع",
      method: "الطريقة",
      amount: "المبلغ",
      remaining_amount: "المبلغ المتبقي",
      total: "الإجمالي",
      delete_payment_confirmation_title: "تأكيد حذف الدفعة",
      delete_payment_confirmation_message: "هل أنت متأكد أنك تريد حذف هذه الدفعة؟ لا يمكن التراجع عن هذا الإجراء.",
      amount_required: "المبلغ مطلوب",
      case_info: "معلومات القضية",
      case_info_desc: "معلومات عامة عن القضية",
      tribunal_location: "نوع المحكمة",
      last_update: "آخر تحديث",
      recent_files: "الملفات الحديثة",
      recent_comments: "التعليقات الحديثة",
      view_all: "عرض الكل",
      case_files: "ملفات القضية",
      case_comments: "تعليقات القضية",
      comments_desc: "مناقشات وملاحظات متعلقة بهذه القضية",
      error_loading_case_data: "خطأ في تحميل بيانات الملف",
      error_loading_files: "خطأ في تحميل الملفات",
      error_loading_comments: "خطأ في تحميل التعليقات",
      view: "عرض",
      view_failed: "فشل عرض الملف",
      unknown: "غير معروف",
      unassigned: "غير معين",
      coming_soon: "قريباً",
      edit_case_not_implemented: "وظيفة تعديل القضية قيد التطوير",
      files_desc: "جميع المرفقات المرفقة بهذه القضية",
      // File viewer translations
      zoom_in: "تكبير",
      zoom_out: "تصغير",
      reset_view: "إعادة ضبط العرض",
      drag_to_move: "اسحب للتحريك",
      unsupported_file_type: "نوع مرفق غير مدعوم",
      no_file_to_display: "لا يوجد مرفق للعرض",
      file_uploaded: "تم رفع المرفق",
      download: "تنزيل",
      file_deleted: "تم حذف المرفق",
      delete_failed: "فشل حذف المرفق",
      download_failed: "فشل التنزيل",
      upload_file: "رفع ملف",
      uploaded_by: "تم التحميل بواسطة",
      add_comment: "إضافة تعليق",
      comment_placeholder: "اكتب تعليقك هنا...",
      post_comment: "نشر التعليق",
      edit_comment: "تعديل التعليق",
      edit_comment_desc: "تعديل محتوى التعليق",
      comment_added: "تمت إضافة التعليق",
      comment_deleted: "تم حذف التعليق",
      proceedings_table_description: "عرض ومتابعة جميع الإجراءات المتعلقة بالملف.",
      
      // Tribunal Decision
      tribunal_decision: "قرار المحكمة",
      tribunal_decision_desc: "قرارات المحكمة المتعلقة بهذه القضية",
      upload_decision: "إضافة الحكم أو القرار",
      replace_decision: "استبدال قرار المحكمة",
      no_decision_files: "لا توجد قرارات محكمة مرفقة",
      delete_decision: "حذف قرار المحكمة",
      decision_file_deleted: "تم حذف قرار المحكمة بنجاح",
      decision_file_replaced: "تم استبدال قرار المحكمة بنجاح",
      confirm_delete_decision_title: "تأكيد حذف قرار المحكمة",
      confirm_delete_decision_desc: "هل أنت متأكد من حذف قرار المحكمة؟ لا يمكن التراجع عن هذا الإجراء.",

      logout: "تسجيل الخروج",
      logout_successful: "تم تسجيل الخروج بنجاح",
      logout_failed: "فشل تسجيل الخروج",
      confirm_logout_title: "تأكيد تسجيل الخروج",
      confirm_logout_desc: "هل أنت متأكد أنك تريد تسجيل الخروج؟",

      // Profile Page Translations
      lawyer_profile_beta: "ملفي العام (تجريبي)",
      profilePageTitle: "الملف الشخصي",
      accountInfoCardTitle: "معلومات الحساب",
      accountInfoCardDescription: "معلومات الحساب الشخصي الخاص بك",
      adminBadgeText: "مدير",
      nameLabel: "الاسم",
      usernameLabel: "اسم المستخدم",
      emailLabel: "البريد الإلكتروني",
      notSet: "غير محدد",
      addEmailWarning: "الرجاء إضافة بريدك الإلكتروني",
      creationDateLabel: "تاريخ الإنشاء",
      adminAccountStatus: "حساب مدير مع صلاحيات كاملة",
      userAccountStatus: "حساب مستخدم عادي",
      changePasswordButton: "تغيير كلمة المرور",
      accountSecurityCardTitle: "أمان الحساب",
      editButton: "تعديل",
      loadingUserData: "جارٍ تحميل بيانات المستخدم...",

      // User page
      totalAssignedCases: "إجمالي القضايا المعينة",
      assignedCases: "القضايا المعينة",
      assignedCasesDescription: "عرض جميع القضايا المعينة لهذا المستخدم",
      noCasesAssigned: "لا توجد قضايا معينة لهذا المستخدم",
      userInfoCardTitle: "معلومات المستخدم",
      userInfoCardDescription: "معلومات المستخدم الشخصية",
      allCases: "إجمالي القضايا",
      ongoingCases: "القضايا الجارية",
      completedCases: "القضايا المكتملة",
      scheduledMeetings: "المواعيد المقبلة",
      // Edit Profile Dialog Translations
      edit_profile: "تعديل المعلومات الشخصية",
      edit_profile_description: "قم بتحديث المعلومات الشخصية الخاصة بك",
      profile_updated_successfully: "تم تحديث المعلومات الشخصية بنجاح",
      profile_update_failed: "فشل تحديث المعلومات الشخصية",
      saving: "جارٍ الحفظ...",
      
      // User Page - Coming Rendezvous
      comingRendezvous: "المواعيد القادمة",
      comingRendezvousDescription: "عرض جميع المواعيد القادمة لهذا المستخدم",
      noComingRendezvous: "لا توجد مواعيد قادمة لهذا المستخدم",

      // Table Actions
      minimize: "تصغير",
      maximize: "تكبير",

      // Change Password Dialog Translations
      change_password: "تغيير كلمة المرور",
      change_password_description: "أدخل كلمة المرور الحالية وكلمة المرور الجديدة",
      current_password: "كلمة المرور الحالية",
      current_password_placeholder: "أدخل كلمة المرور الحالية",
      current_password_required: "كلمة المرور الحالية مطلوبة",
      new_password: "كلمة المرور الجديدة",
      new_password_placeholder: "أدخل كلمة المرور الجديدة",
      new_password_too_short: "يجب أن تتكون كلمة المرور الجديدة من 8 أحرف على الأقل",
      confirm_password: "تأكيد كلمة المرور",
      confirm_password_placeholder: "أدخل كلمة المرور الجديدة مرة أخرى",
      confirm_password_required: "تأكيد كلمة المرور مطلوب",
      password_updated_successfully: "تم تحديث كلمة المرور بنجاح",
      password_update_failed: "فشل تحديث كلمة المرور",

      // Command Menu
      type_command_or_search: "اكتب أمرًا أو ابحث...",
      no_results_found: "لم يتم العثور على نتائج.",
      theme: "المظهر",
      light: "فاتح",
      dark: "داكن",
      toggle_theme: "تبديل السمة",
      // Data Table Column Header
      asc: "تصاعدي",
      desc: "تنازلي",
      hide: "إخفاء",
      filter: "تصفية",
      Filter: "تصفية",
      toggle_columns: "تبديل الأعمدة",
      "Toggle Columns": "تبديل الأعمدة",
      
      search: "بحث",
      service_fee: "مبلغ الأتعاب",
      service_fee_desc: "مبلغ الأتعاب لهذه القضية",
      service_fee_placeholder: "أدخل مبلغ الأتعاب",
      fee_type: "نوع الأتعاب",
      select_fee_type: "اختر نوع الأتعاب",
      fee_type_fixed: "مبلغ ثابت",
      fee_type_percentage: "نسبة مئوية",
      fee_percentage: "نسبة الأتعاب ",
      fee_percentage_placeholder: "أدخل النسبة المئوية",
      fee_reference_amount: "مبلغ المرجع",
      fee_reference_amount_placeholder: "أدخل مبلغ المرجع للحساب",
      fee_reference_amount_required: "مبلغ المرجع مطلوب للأتعاب بالنسبة المئوية",
      calculated_fee: "الأتعاب المحسوبة",
      payment_currency: "د.ه",

      // Cabinet settings translations
      cabinet_settings: "إعدادات المكتب",
      cabinet_settings_desc: "تكوين إعدادات المكتب",
      "cabinet.settings.plan_usage": "الخطة والاستخدام",
      "cabinet.plan": "الخطة",
      "cabinet.month_tokens_used": "رموز الشهر المستخدمة",
      "cabinet.users": "المستخدمون",
      "cabinet.cases": "الملفات",
      "cabinet.active_cases": "الملفات النشطة",
      "cabinet.storage": "التخزين",
      "cabinet.month_storage_uploaded": "مساحة الشهر المرفوعة",
      "cabinet.month_storage_deleted": "مساحة الشهر المحذوفة",
      "cabinet.monthly_analytics": "التحليلات الشهرية",
      "cabinet.show_monthly_details": "عرض التفاصيل الشهرية",
      "cabinet.hide_monthly_details": "إخفاء التفاصيل الشهرية",
      "cabinet.billing_invoices": "الفوترة والفواتير",
      "cabinet.case_types": "أنواع القضايا",
      "cabinet.roles": "الأدوار",
      click_to_mark_read: "انقر لتعليمه كمقروء",
      no_monthly_data: "لا توجد بيانات شهرية",
      no_data: "لا توجد بيانات",
      case_types_management: "إدارة أنواع القضايا",
      case_types_management_desc: "إدارة أنواع القضايا المتاحة في المكتب",
      add_case_type: "إضافة نوع قضية",
      current_case_types: "أنواع القضايا الحالية",
      loading_case_types: "جاري تحميل أنواع القضايا...",
      no_case_types: "لا توجد أنواع قضايا مكونة",
      case_type_added_to_cabinet: "تمت إضافة نوع القضية إلى المكتب",
      case_type_removed_from_cabinet: "تمت إزالة نوع القضية من المكتب",
        roles_management: "أمان الأدوار",
        roles_management_desc: "إدارة أدوار المستخدمين وصلاحيات الوصول الخاصة بهم داخل المكتب.",

        permission_actions: {
          READ: "عرض",
          CREATE: "إنشاء",
          UPDATE: "تعديل",
          DELETE: "حذف",
          MANAGE: "إدارة",
          USE: "استخدام",
          ARCHIVE: "أرشفة",
          ASSIGN: "تعيين",
          EXPORT: "تصدير",
          MERGE: "دمج"
        },
        roles: {
          title: "إدارة الأدوار",
          description: "إدارة أدوار المستخدمين والصلاحيات",
          info: "تحدد الأدوار الإجراءات التي يمكن للمستخدمين القيام بها في النظام.",
          createRole: "إنشاء دور",
          noRoles: "لا توجد أدوار",
          actions: "الإجراءات",
          categories: {
            user: "المستخدمين",
            role: "الأدوار",
            auth: "المصادقة",
            api: "API",
            cases: "القضايا",
            case: "القضايا",
            casedecisionfile: "ملفات القرارات",
            casedeposit: "عمليات الإيداع",
            rendezvous: "المواعيد",
            templaterequest: "طلبات النماذج",
            todo: "المهام",
            client: "الموكلين",
            documenttemplate: "نماذج المستندات",
            generateddocument: "المستندات المنشأة",
            caserelation: "علاقات القضية",
            cabinet: "المكتب",
            cabinetproceeding: "إجراءات المكتب",
            casefile: "ملفات القضية",
            casejurisprudence: "اجتهادات القضية",
            casenote: "ملاحظات القضية",
            caseparty: "أطراف القضية",
            caseproceeding: "إجراءات القضية",
            caseproceedingpersonaldecision: "قرارات شخصية للإجراءات",
            lawyerprofile: "الملف العام للمحامي"
          },
          dialog: {
            create: {
              title: "إنشاء دور",
              description: "إنشاء دور جديد بصلاحيات مخصصة. يجب أن يكون اسم الدور بالأحرف الكبيرة."
            },
            roleName: "اسم الدور",
            roleNamePlaceholder: "مثلاً: مدير",
            description: "الوصف",
            descriptionPlaceholder: "وصف مهام هذا الدور",
            permissions: "الصلاحيات",
            noPermissions: "لا توجد صلاحيات متاحة",
            readonly: "لا يمكن تعديل هذا الدور.",
            edit: {
              title: "تعديل الدور",
              description: "تحديث معلومات الدور. يجب أن تكون أسماء الأدوار بأحرف كبيرة.",
              save: "تحديث الدور"
            },
            delete: {
              title: "حذف الدور",
              confirmText: "هل أنت متأكد أنك تريد حذف الدور {{roleName}}؟",
              warningText: "سيؤدي هذا الإجراء إلى إزالة هذا الدور وجميع الصلاحيات المرتبطة به نهائيًا من النظام. لا يمكن التراجع عن هذا الإجراء.",
              riskText: "لا يمكن التراجع عن هذه العملية."
            }
          },

            permissions: {
              api: {
                  view_case: "يمكن عرض ملفات القضايا",
                  add_case: "يمكن إضافة ملفات القضايا",
                  change_case: "يمكن تعديل ملفات القضايا",
                  delete_case: "يمكن حذف ملفات القضايا",
                  export_case: "يمكن تصدير بيانات القضايا",
                  add_casedecisionfile: "يمكن إضافة ملف قرار",
                  change_casedecisionfile: "يمكن تعديل ملف قرار",
                  delete_casedecisionfile: "يمكن حذف ملف قرار",
                  view_casedecisionfile: "يمكن عرض ملف قرار",
                  view_casedeposit: "يمكن عرض دفعات الملف",
                  add_casedeposit: "يمكن إضافة دفعات الملف",
                  change_casedeposit: "يمكن تعديل دفعات الملف",
                  delete_casedeposit: "يمكن حذف دفعات الملف",
                  view_rendezvous: "يمكن عرض المواعيد",
                  add_rendezvous: "يمكن إضافة المواعيد",
                  change_rendezvous: "يمكن تعديل المواعيد",
                  delete_rendezvous: "يمكن حذف المواعيد",
                  view_role: "يمكن عرض الأدوار",
                  add_role: "يمكن إضافة الأدوار",
                  change_role: "يمكن تعديل الأدوار",
                  delete_role: "يمكن حذف الأدوار",
                  view_templaterequest: "يمكن عرض طلبات النماذج",
                  add_templaterequest: "يمكن إضافة طلبات النماذج",
                  change_templaterequest: "يمكن تعديل طلبات النماذج",
                  delete_templaterequest: "يمكن حذف طلبات النماذج",
                  view_todo: "يمكن عرض المهام",
                  add_todo: "يمكن إضافة المهام",
                  change_todo: "يمكن تعديل المهام",
                  delete_todo: "يمكن حذف المهام",
                  view_user: "يمكن عرض المستخدمين",
                  add_user: "يمكن إضافة المستخدمين",
                  change_user: "يمكن تعديل المستخدمين",
                  delete_user: "يمكن حذف المستخدمين",
                  manage_roles: "يمكن إنشاء وإدارة الأدوار المخصصة",
                  view_user_activity: "يمكن عرض سجلات نشاط المستخدم",
                  view_client: "يمكن عرض الموكلين",
                  add_client: "يمكن إضافة الموكلين",
                  change_client: "يمكن تعديل الموكلين",
                  delete_client: "يمكن حذف الموكلين",
                  export_client: "يمكن تصدير بيانات الموكلين",
                  merge_client: "يمكن دمج الموكلين المكررين",
                  view_documenttemplate: "يمكن عرض نماذج المستندات",
                  add_documenttemplate: "يمكن إضافة نماذج المستندات",
                  change_documenttemplate: "يمكن تعديل نماذج المستندات",
                  delete_documenttemplate: "يمكن حذف نماذج المستندات",
                  view_generateddocument: "يمكن عرض المستندات المنشأة",
                  add_generateddocument: "يمكن إضافة المستندات المنشأة",
                  change_generateddocument: "يمكن تعديل المستندات المنشأة",
                  delete_generateddocument: "يمكن حذف المستندات المنشأة",
                  view_caserelation: "يمكن عرض علاقات القضية",
                  add_caserelation: "يمكن إضافة علاقات القضية",
                  change_caserelation: "يمكن تعديل علاقات القضية",
                  delete_caserelation: "يمكن حذف علاقات القضية",
                  use_chatbot: "يمكن استخدام المساعد الذكي",
                  change_cabinet: "يمكن تغيير معلومات المكتب",
                  use_chatbot_audio: "يمكن استخدام الصوت مع المساعد الذكي",
                  view_cabinet: "يمكن عرض معلومات المكتب",
                  view_cabinetproceeding: "يمكن عرض إجراءات المكتب",
                  add_cabinetproceeding: "يمكن إضافة إجراءات المكتب",
                  change_cabinetproceeding: "يمكن تعديل إجراءات المكتب",
                  delete_cabinetproceeding: "يمكن حذف إجراءات المكتب",
                  archive_case: "يمكن أرشفة/إلغاء أرشفة القضايا",
                  assign_case: "يمكن تعيين القضايا للمستخدمين",
                  change_case_visibility: "يمكن تغيير إعدادات ظهور القضية",
                  delete_own_case: "يمكن حذف قضاياه الخاصة",
                  change_own_case: "يمكن تعديل قضاياه الخاصة",
                  view_own_case: "يمكن عرض قضاياه الخاصة",
                  change_own_rendezvous: "يمكن تعديل مواعيده الخاصة",
                  view_own_rendezvous: "يمكن عرض مواعيده الخاصة",
                  delete_own_rendezvous: "يمكن حذف مواعيده الخاصة",
                  view_casefile: "يمكن عرض ملفات القضية",
                  add_casefile: "يمكن إضافة ملفات القضية",
                  change_casefile: "يمكن تعديل ملفات القضية",
                  delete_casefile: "يمكن حذف ملفات القضية",
                  view_casejurisprudence: "يمكن عرض اجتهادات القضية",
                  add_casejurisprudence: "يمكن إضافة اجتهادات القضية",
                  change_casejurisprudence: "يمكن تعديل اجتهادات القضية",
                  delete_casejurisprudence: "يمكن حذف اجتهادات القضية",
                  view_casenote: "يمكن عرض ملاحظات القضية",
                  add_casenote: "يمكن إضافة ملاحظات القضية",
                  change_casenote: "يمكن تعديل ملاحظات القضية",
                  delete_casenote: "يمكن حذف ملاحظات القضية",
                  view_caseparty: "يمكن عرض أطراف القضية",
                  add_caseparty: "يمكن إضافة أطراف القضية",
                  change_caseparty: "يمكن تعديل أطراف القضية",
                  delete_caseparty: "يمكن حذف أطراف القضية",
                  view_caseproceeding: "يمكن عرض إجراءات القضية",
                  add_caseproceeding: "يمكن إضافة إجراءات القضية",
                  change_caseproceeding: "يمكن تعديل إجراءات القضية",
                  delete_caseproceeding: "يمكن حذف إجراءات القضية",
                  view_caseproceedingpersonaldecision: "يمكن عرض القرارات الشخصية للإجراءات",
                  add_caseproceedingpersonaldecision: "يمكن إضافة القرارات الشخصية للإجراءات",
                  change_caseproceedingpersonaldecision: "يمكن تعديل القرارات الشخصية للإجراءات",
                  delete_caseproceedingpersonaldecision: "يمكن حذف القرارات الشخصية للإجراءات",
                  view_lawyerprofile: "يمكن عرض الملف العام للمحامي",
                  add_lawyerprofile: "يمكن إضافة الملف العام للمحامي",
                  change_lawyerprofile: "يمكن تعديل الملف العام للمحامي",
                  delete_lawyerprofile: "يمكن حذف الملف العام للمحامي"
               }
            },

        },
      add_role: "إضافة دور",
      current_roles: "الأدوار الحالية",
      loading_roles: "جاري تحميل الأدوار...",
      no_roles: "لا توجد أدوار مكونة",
      role_added_to_cabinet: "تمت إضافة الدور إلى المكتب",
      role_removed_from_cabinet: "تمت إزالة الدور من المكتب",
      adding: "جاري الإضافة...",
      add: "إضافة",
      
      // Session expiration messages
      session_expired: "انتهت الجلسة",
      session_expired_desc: "لقد تم فصلك. يرجى تسجيل الدخول مرة أخرى.",
      payment_required: "يتطلب الحساب اشتراكًا نشطًا",
      payment_required_desc: "يرجى اختيار خطة للاشتراك للمتابعة.",
      cabinet_subscriptions_desc: "عرض وإدارة اشتراكات مكتبك.",
      price_per_month: "{{amount}} {{currency}}/شهر",
      price_per_year: "{{amount}} {{currency}}/سنة",
      save_percent: "وفّر {{pct}}%",
      no_period_info: "لا تتوفر معلومات عن الفترة الحالية",
      trial_end: "نهاية الفترة التجريبية",

      // Cabinet Plans Dialog
      confirm_subscription: "تأكيد الاشتراك",
      subscriptions_list_desc: "تتبع اشتراكات المكاتب في النظام.",
      subscription_details: "تفاصيل الاشتراك",
      current_period_start: "بداية الفترة الحالية",
      current_period_end: "نهاية الفترة الحالية",
      cancel_at_period_end: "إلغاء في نهاية الفترة",
      payment_method: "طريقة الدفع",
      wire_transfer: "تحويل بنكي",
      bank_transfer: "تحويل بنكي",
      payment_pending: "الدفع قيد الانتظار",
      wire_instructions_desc: "سيتم تفعيل اشتراكك بعد استلام التحويل البنكي والتحقق منه. استعمل المعلومات أدناه.",
      wire_beneficiary: "المستفيد",
      wire_bank: "البنك",
      wire_rib: "RIB",
      wire_iban: "IBAN",
      wire_swift: "SWIFT",
      days: "أيام",
      void: "ملغاة",
      monthly: "شهر",
      yearly: "سنة",
      wire_instructions_error: "تعذر تحميل المعلومات البنكية.",
      subscription_past_due: "دفعة الاشتراك متأخرة",
      subscription_past_due_desc: "انتهى اشتراكك. جدده الآن للحفاظ على الوصول إلى مكتبك.",
      subscription_expiring_soon: "اشتراكك على وشك الانتهاء",
      subscription_expiring_soon_desc: "ينتهي اشتراكك خلال {{days}} يوم.",
      payment_awaiting_validation: "الدفع في انتظار التحقق",
      payment_awaiting_validation_desc: "سيتم تفعيل اشتراكك بعد استلام التحويل البنكي والتحقق منه.",
      manage_subscription: "إدارة الاشتراك",
      subscription_status_active: "نشط",
      subscription_status_trialing: "فترة تجريبية",
      subscription_status_free: "مجاني",
      subscription_status_pending: "قيد الانتظار",
      subscription_status_past_due: "متأخر",
      subscription_status_paused: "متوقف مؤقتا",
      subscription_status_canceled: "ملغى",
      upcoming_payment: "الدفعة القادمة",
      due: "الاستحقاق",
      renew_now: "جدد الآن",
      renew_failed: "تعذر طلب التجديد",
      view_payment_instructions: "معلومات الدفع",
      subscription_history: "السجل",
      subscriptions_load_error: "تعذر تحميل الاشتراكات",
      cancel_at_period_end_notice: "لن يتم تجديد هذا الاشتراك بعد الفترة الحالية.",
      awaiting_payment: "في انتظار الدفع",
      payment_gateway: "بوابة الدفع",
      credit_card: "بطاقة ائتمان",
      jeune: "Jeune",

      cabinet_proceedings: "إجراءات المكتب",
      cabinet_proceedings_desc: "سجل جميع الإجراءات الداخلية المرتبطة بهذه القضية.",
      add_proceeding: "إضافة إجراء",
      add_proceeding_desc: "إضافة إجراء جديد لهذه القضية.",
      edit_proceeding: "تعديل الإجراء",
      edit_proceeding_desc: "تعديل تفاصيل الإجراء لهذه القضية.",
      delete_proceeding_confirmation_title: "تأكيد حذف الإجراء",
      action: "الإجراء",
      action_required: "الإجراء مطلوب",
      action_placeholder: "مثال: مراجعة مستندات، اتصال مع الموكل...",
      date: "التاريخ",
      time: "الوقت",
      hour: "ساعة",
      minute: "دقيقة",
      error_fetching_proceedings: "خطأ في جلب الإجراءات",
      error_updating_proceeding: "خطأ في تحديث الإجراء",
      error_adding_proceeding: "خطأ في إضافة الإجراء",
      error_deleting_proceeding: "خطأ في حذف الإجراء",
      proceeding_added: "تمت إضافة الإجراء",
      proceeding_updated: "تم تحديث الإجراء",
      proceeding_deleted: "تم حذف الإجراء",

      // Tribunal Proceedings translations
      tribunal_proceedings: "إجراءات المحكمة",
      proceedings_desc: "محتوى إجراءات المحكمة",
      proceedings: "الإجراءات",
      refresh_proceedings: "تحديث الإجراءات",
      confirm_refresh_proceedings: "تأكيد تحديث الإجراءات",
      confirm_refresh_proceedings_description: "يمكنك تحديث الإجراءات مرة واحدة فقط في الساعة.",
      refresh: "تحديث",
      type: "النوع",
      decision: "القرار",
      next_hearing_date: "تاريخ الجلسة القادمة",
      personal_decisions: "القرارات الشخصية",
      personal_decision_updated_successfully: "تم تحديث القرار الشخصي بنجاح",
      personal_decision_added_successfully: "تمت إضافة القرار الشخصي بنجاح",
      failed_to_save_personal_decision: "فشل في حفظ القرار الشخصي",
      personal_decision_deleted_successfully: "تم حذف القرار الشخصي بنجاح",
      failed_to_delete_personal_decision: "فشل في حذف القرار الشخصي",
      proceedings_refreshed_successfully: "تم تحديث الإجراءات بنجاح",
      failed_to_refresh_proceedings: "فشل في تحديث الإجراءات",
      edit_personal_decision: "تعديل القرار الشخصي",
      add_personal_decision: "إضافة قرار شخصي",
      update_the_details_of_the_personal_decision: "تحديث تفاصيل القرار الشخصي.",
      add_a_new_personal_decision_to_this_proceeding: "إضافة قرار شخصي جديد لهذا الإجراء.",
      enter_decision_details: "أدخل تفاصيل القرار...",
      add_decision: "إضافة قرار",
      decision_is_required: "القرار مطلوب",
      confirm_delete_personal_decision: "تأكيد حذف القرار الشخصي",
      are_you_sure_you_want_to_delete_this_personal_decision: "هل أنت متأكد من حذف هذا القرار الشخصي؟",
      this_action_cannot_be_undone: "لا يمكن التراجع عن هذا الإجراء.",
      delete_personal_decision: "حذف القرار الشخصي",
      error_loading_proceedings: "خطأ في تحميل الإجراءات",

      // Case Relations translations
      case_relations: "القضايا المرتبطة",
      case_relations_desc: "القضايا المرتبطة بهذه القضية (استئناف، نقض...)",
      relation_type: "نوع العلاقة",
      jurisdiction: "الجهة القضائية",
      related_case_number: "رقم القضية المرتبطة",
      no_relations: "لا توجد قضايا مرتبطة",
      error_loading_relations: "خطأ في تحميل القضايا المرتبطة",

      // Case Hierarchy translations
      case_hierarchy: "تسلسل القضايا",
      case_hierarchy_desc: "عرض القضايا الأصلية والفرعية المرتبطة",
      parent_case: "القضية الأصلية",
      parent_cases: "القضايا الأصلية",
      child_cases: "القضايا الفرعية",
      current_case: "القضية الحالية",
      current: "الحالية",
      no_hierarchy: "لا توجد قضايا مرتبطة في التسلسل",
      error_loading_hierarchy: "خطأ في تحميل تسلسل القضايا",
      create_related_case: "إنشاء قضية مرتبطة",
      create_related_case_desc: "إنشاء قضية جديدة مرتبطة بهذه القضية للعميل {{client}}",
      continue_to_create: "متابعة الإنشاء",
      case_number_required_for_relations: "يجب إدخال رقم القضية لإنشاء قضايا مرتبطة",
      can_create_related_case: "يمكنك إنشاء قضية مرتبطة مثل استئناف أو نقض",
      appeal: "استئناف",
      cassation: "نقض",
      related: "ملف مرتبط",
      continuation: "استمرار",
      opposition: "معارضة",
      view_case_details: "عرض تفاصيل الملف",
      missing_required_data: "بيانات مطلوبة مفقودة",

      // Document Templates
      document_templates: "نماذج الوثائق",
      document_templates_desc: "نماذج وثائق معرفة مسبقاً لإنشاء ملفات PDF",
      manage_document_templates: "إدارة نماذج الوثائق",
      favorites_only: "المفضلة فقط",
      favorite: "المفضلة",
      mark_favorite: "إضافة إلى المفضلة",
      unfavorite: "إزالة من المفضلة",
      no_templates: "لا توجد نماذج",
      create_template: "إنشاء نموذج",
      manage_templates: "إدارة النماذج",
      render_pdf: "إنشاء PDF",
      render_document: "إنشاء الوثيقة",
      render_document_desc: "ملء الحقول لإنشاء ملف PDF",
      rendering_document: "جاري إنشاء الوثيقة...",
      rendering: "جاري الإنشاء...",
      document_rendered: "تم إنشاء الوثيقة",
      document_generated: "تم إنشاء المستند",
      document_ready: "المستند جاهز",
      open_pdf: "فتح PDF",
      form_payload: "بيانات النموذج",
      render_success: "تم الإنشاء بنجاح",
      render_failed: "فشل الإنشاء",
      image_preview: "معاينة الصورة",
      insert_variable: "إدراج متغير",
      insert: "إدراج",
      error_loading: "خطأ في التحميل",
      open_detail: "فتح التفاصيل",
      template_version: "إصدار النموذج",

      // Template Authoring
      html: "HTML",
      css: "CSS",
      schema: "المخطط",
      create_new_template_desc: "إنشاء نموذج HTML جديد مع أنماط مخصصة ومخطط JSON",
      template_details: "تفاصيل النموذج",
      example_schema: "مثال على المخطط",
      enter_template_title: "أدخل عنوان النموذج",
      title_required: "العنوان مطلوب",
      category: "الفئة",
      select_category: "اختر الفئة",
      enter_template_slug: "مثال: عقد-خدمة",
      slug: "المعرّف (Slug)",
      slug_help: "استخدم حروفاً صغيرة وشرطات فقط (مثال: contract-template)",
      fill_required_fields: "يرجى ملء جميع الحقول المطلوبة",
      error_creating_template: "فشل إنشاء النموذج",
      html_help: "يجب أن يبدأ بـ <html lang=\"ar\" dir=\"rtl\">. استخدم {{ }} للمحتوى الديناميكي.",
      css_help: "اختياري. يتم تضمين خطوط Amiri تلقائياً. استخدم @page لأنماط الطباعة.",
      schema_help: "يحدد حقول النموذج وقواعد التحقق. استخدم الخصائص التي تطابق عناصر HTML.",
      // Visual Block Builder
      document_structure: "هيكل الوثيقة",
      form_fields: "حقول النموذج",
      form_fields_schema: "مخطط حقول النموذج",
      add_block: "إضافة كتلة",
      no_blocks: "لم تتم إضافة كتل بعد. أضف الكتل أعلاه لبناء النموذج.",
      block_header: "الرأس (الشعار + بيانات المكتب)",
      block_parties: "الأطراف (الموكل، الخصم)",
      block_case_meta: "بيانات القضية",
      block_text: "كتلة نصية",
      block_table: "جدول بيانات",
      block_fees: "الرسوم والمجاميع",
      block_signatures: "التوقيعات",
      block_footer: "التذييل (أرقام الصفحات)",
      show_logo: "إظهار الشعار",
      show_cabinet_info: "إظهار بيانات المكتب",
      alignment: "المحاذاة",
      center: "الوسط",
      left: "يسار",
      right: "يمين",
      text_content: "محتوى النص",
      enter_text: "أدخل محتوى النص...",
      select_variable: "اختر متغيراً...",
      show_subtotal: "إظهار المجموع الفرعي",
      show_total: "إظهار الإجمالي",
      show_tax: "إظهار الضريبة",
      block_config_coming_soon: "خيارات التكوين لهذا النوع من الكتل قريباً...",
      
      // Variable Management
      system_variable: "متغير نظام",
      custom_variable: "متغير مخصص",
      variable_not_found: "المتغير غير موجود",
      create_new_variable: "إنشاء متغير جديد",
      variable_key: "مفتاح المتغير",
      variable_label: "تسمية المتغير",
      label_help: "وصف قصير يظهر أثناء اختيار المتغير",
      variable_label_ar: "التسمية بالعربية",
      label_ar_help: "التسمية باللغة العربية التي ستظهر للمستخدمين",
      variable_created: "تم إنشاء المتغير بنجاح",
      variable_created_successfully: "تم إنشاء المتغير بنجاح",
      error_creating_variable: "فشل إنشاء المتغير",
      creating_variable: "جارٍ الإنشاء...",
      page_layout: "تخطيط الصفحة",
      layout: "التخطيط",
      select_page_layout: "اختر تخطيط الصفحة",
      tip: "نصيحة",
      variable_autocomplete_help: "اكتب {{ في المحرر لفتح الإكمال التلقائي للمتغيرات. اختر متغيراً موجوداً أو أنشئ واحداً جديداً.",
      template_content: "محتوى النموذج",
      template_content_desc: "استخدم محرر النصوص الغني لتكوين وثيقتك. أدرج المتغيرات لتخصيص المحتوى.",
      enter_template_content: "أدخل محتوى النموذج",
      variables_management_desc: "إدارة المتغيرات المتاحة لاستخدامها داخل النماذج",
      create_variable: "إنشاء متغير",
      create_first_variable: "أنشئ أول متغير للبدء",
      no_variables_found: "لا توجد متغيرات",
      invalid_key_format: "صيغة المفتاح غير صحيحة",
      key_format_help: "الصيغة: الكيان.الخاصية (مثال: client.name)",
      
      // Template Generation Page
      template_preview: "معاينة النموذج",
      template_preview_desc: "معاينة نموذج الوثيقة",
      preview: "معاينة",
      fill_document_data: "إدخال بيانات الوثيقة",
      fill_document_data_desc: "أكمل النموذج أدناه لإنشاء وثيقتك",
      generate_document_info: "انقر على الزر لإنشاء وثيقة PDF الخاصة بك",
      generate_pdf: "إنشاء PDF",
      generating: "جاري الإنشاء",
      opening_pdf: "فتح PDF في علامة تبويب جديدة...",
      enter: "أدخل",
      
      // Word Document Import
      template_engine: "محرك النموذج",
      html_editor: "محرر HTML",
      word_document: "مستند Word (.docx)",
      html_editor_desc: "إنشاء نموذج باستخدام المحرر المرئي",
      word_document_desc: "رفع مستند Word مع {{متغيرات}}",
      upload_word_document: "رفع مستند Word",
      upload_word_desc: "رفع ملف .docx مع متغيرات بالتنسيق {{variable.name}}",
      select_file: "اختر ملف",
      change_file: "تغيير الملف",
      validating_document: "جاري التحقق من الوثيقة...",
      validation_passed: "نجح التحقق",
      found_variables: "المتغيرات الموجودة",
      invalid_variables: "متغيرات غير صالحة",
      validation_success: "نجح التحقق",
      invalid_file_type: "يرجى اختيار ملف .docx",
      invalid_variables_found: "تم العثور على متغيرات غير صالحة",
      validation_error: "خطأ في التحقق",
      failed_to_validate: "فشل التحقق من المستند",
      template_content_required: "يرجى توفير محتوى النموذج",
      word_file_required: "يرجى رفع مستند Word",
      fix_validation_errors: "يرجى إصلاح أخطاء التحقق قبل الإرسال",
      creating: "جاري الإنشاء...",
      
      // Cabinet Document Template Page Specific
      back_to_templates: "العودة إلى النماذج",
      document_information: "معلومات الوثيقة",
      fill_form_to_generate: "املأ النموذج أدناه لإنشاء الوثيقة",
      select_case_context: "اختر القضية (اختياري)",
      failed_load_case_context: "فشل في تحميل سياق الملف",
      search_cases: "ابحث عن القضية...",
      template_variables: "متغيرات النموذج",
      edit_template_variables: "تحرير متغيرات النموذج",
      generate_document: "إنشاء الوثيقة",
      
      // Template Edit (using existing keys: edit, saving)
      save_changes: "حفظ التغييرات",
      template_created: "تم إنشاء النموذج",
      template_updated: "تم تحديث النموذج بنجاح",
      template_saved_successfully: "تم حفظ النموذج بنجاح",
      error_updating_template: "فشل تحديث النموذج",
      word_template_edit_info: "لا يمكن تعديل محتوى قالب Word. لتحديث المستند، يجب عليك إنشاء قالب جديد برفع ملف Word جديد.",
      validation_errors: "أخطاء التحقق",
      validation_failed: "فشل التحقق من الصحة",
      valid_variables: "المتغيرات الصحيحة",
      version: "الإصدار",
      engine: "المحرك",
      all_categories: "جميع الفئات",
      confirm_delete: "تأكيد الحذف",
      delete_template_confirmation: "هل أنت متأكد من رغبتك في حذف هذا النموذج؟",
      action_cannot_be_undone: "لا يمكن التراجع عن هذا الإجراء.",
      template_deleted_successfully: "تم حذف النموذج بنجاح",
      error_deleting_template: "فشل حذف النموذج",
      template_not_found: "لم يتم العثور على النموذج",
      
      // Search and Filtering
      search_variables: "البحث عن المتغيرات...",
      search_by_key_label: "البحث حسب المفتاح أو التسمية أو الوصف",
      search_templates: "البحث في النماذج...",
      filter_by_source: "تصفية حسب المصدر",
      filter_by_type: "تصفية حسب النوع",
      variables_list: "قائمة المتغيرات",
      variables: "المتغيرات",
      pdf_preview: "معاينة PDF",
      available_variables: "المتغيرات المتاحة",
      system_variables: "متغيرات النظام",
      custom_variables: "متغيرات مخصصة",
      jino_variables_found: "لم يتم العثور على متغيرات",
      loading_variables: "جاري تحميل المتغيرات...",
      
      // Variable Types
      variable_type_string: "نص",
      variable_type_number: "رقم",
      variable_type_date: "تاريخ",
      variable_type_boolean: "نعم/لا",
      
      // Pagination and Sorting
      items_per_page: "عدد العناصر في الصفحة",
      sort_by: "ترتيب حسب",
      page_number: "رقم الصفحة",

      select_cases_for_report: "اختر القضايا للتقرير",
      select_assigned_to: "اختر المسؤول",
      added_cases: "القضايا المضافة",
      unselect_all: "إلغاء تحديد الكل",
      export_as_excel: "تصدير إلى excel",
      build_report: "إنشاء تقرير",
      no_case_selected: "لم يتم تحديد أي قضية",

      // Super Admin translations
      super_admin_dashboard: "لوحة تحكم المدير العام",
      super_admin_dashboard_desc: "إحصائيات النظام وإدارة المكاتب",
      super_admin_dashboard_description: "إحصائيات النظام وإدارة المكاتب",
      total_cabinets: "إجمالي المكاتب",
      active_cabinets: "المكاتب النشطة",
      disabled_cabinets: "المكاتب المعطلة",
      total_users: "إجمالي المستخدمين",
      active_users: "المستخدمون النشطون",
      cabinet_admins: "مديرو المكاتب",
      super_admins: "المديرون العامون",
      total_cases: "إجمالي القضايا",
      cases_this_month: "قضايا هذا الشهر",
      manage_cabinets: "إدارة المكاتب",
      system_analytics: "تحليلات النظام",
      quick_actions: "إجراءات سريعة",
      loading_dashboard: "جاري تحميل لوحة التحكم...",
      dashboard_error: "خطأ في تحميل بيانات لوحة التحكم",
      
      // Cabinet management translations
      cabinets_management: "إدارة المكاتب",
      manage_system_cabinets: "إدارة مكاتب النظام",
      all_cabinets: "جميع المكاتب",
      create_cabinet: "إنشاء مكتب",
      create_new_cabinet: "إنشاء مكتب جديد",
      create_cabinet_description: "إنشاء مكتب جديد في النظام",
      search_cabinets: "البحث في المكاتب...",
      no_cabinets: "لا توجد مكاتب",
      no_cabinets_found: "لم يتم العثور على مكاتب",
      try_different_search: "جرب بحثاً مختلفاً",
      get_started_create_cabinet: "ابدأ بإنشاء مكتب جديد",
      cabinet_detailed_information: "معلومات المكتب التفصيلية",
      users_statistics: "إحصائيات المستخدمين",
      cases_statistics: "إحصائيات القضايا",
      recent_activity: "النشاط الأخير",
      inactive_users: "المستخدمون غير النشطين",
      admin_users: "المستخدمون المديرون",
      open_cases: "القضايا المفتوحة",
      archived_cases: "القضايا المؤرشفة",
      disabled: "معطل",
      disabled_at: "تم التعطيل في",
      by: "بواسطة",
      view_details: "عرض التفاصيل",
      mark_as_succeeded: "وضع علامة كمكتمل",
      mark_as_failed: "وضع علامة كفاشل",
      disable: "تعطيل",
      enable: "تفعيل",
      disable_cabinet: "تعطيل المكتب",
      enable_cabinet: "تفعيل المكتب",
      disable_cabinet_description: "هل أنت متأكد من تعطيل هذا المكتب؟",
      enable_cabinet_description: "هل أنت متأكد من تفعيل هذا المكتب؟",
      reason: "السبب",
      optional: "اختياري",
      enter_reason: "أدخل السبب...",
      delete_cabinet: "حذف المكتب",
      delete_cabinet_warning: "هذا الإجراء سيحذف المكتب",
      
      // Users management translations (avoiding duplicates)
      users_management: "إدارة المستخدمين",
      manage_system_users: "إدارة مستخدمي النظام",
      search_users: "البحث في المستخدمين...",
      system_users: "مستخدمو النظام",
      no_users: "لا يوجد مستخدمون",
      no_users_found: "لم يتم العثور على مستخدمين",
      no_users_available: "لا يوجد مستخدمون متاحون",
      no_users_yet: "لا يوجد أي مستخدم بعد",
      create_first_user_to_get_started: "أنشئ أول مستخدم للبدء",
      try_different_search_terms: "حاول استخدام كلمات بحث مختلفة",
      user_detailed_information: "معلومات المستخدم التفصيلية",
      basic_information: "المعلومات الأساسية",
      status_and_permissions: "الحالة والصلاحيات",
      permissions: "الصلاحيات",
      cabinet_and_activity: "المكتب والنشاط",
      super_admin: "مدير عام",
      inactive: "غير نشط",
      never: "أبداً",
      last_login: "آخر تسجيل دخول",
      yes: "نعم",
      no: "لا",
      remove_admin: "إزالة المدير",
      deactivate: "إلغاء التفعيل",
      activate: "تفعيل",
      password_reset_successfully: "تم إعادة تعيين كلمة المرور بنجاح",
      reset_password_for: "إعادة تعيين كلمة المرور لـ",
      remove_admin_privileges: "إزالة صلاحيات المدير",
      grant_admin_privileges: "منح صلاحيات المدير",
      remove_admin_privileges_description: "هل أنت متأكد من إزالة صلاحيات المدير؟",
      grant_admin_privileges_description: "هل أنت متأكد من منح صلاحيات المدير؟",
      deactivate_user: "إلغاء تفعيل المستخدم",
      activate_user: "تفعيل المستخدم",
      deactivate_user_description: "هل أنت متأكد من إلغاء تفعيل هذا المستخدم؟",
      activate_user_description: "هل أنت متأكد من تفعيل هذا المستخدم؟",
      user_created_successfully: "تم إنشاء المستخدم بنجاح",
      please_fill_required_fields: "يرجى تعبئة الحقول المطلوبة",
      no_email: "لا يوجد بريد إلكتروني",
      no_cabinet: "لا يوجد مكتب",
      no_role: "لا يوجد دور",
      
      // Cabinet users translations
      back_to_cabinets: "العودة إلى المكاتب",
      manage_cabinet_users: "إدارة مستخدمي المكتب",
      cabinet_information: "معلومات المكتب",
      cabinet_users: "مستخدمو المكتب",
      no_users_in_cabinet: "لا يوجد مستخدمون في هذا المكتب",
      no_users_available_in_cabinet: "لا يوجد مستخدمون متاحون في هذا المكتب",
      
      // Dashboard specific translations
      total_registered_cabinets: "إجمالي المكاتب المسجلة",
      currently_active_cabinets: "المكاتب النشطة حالياً",
      temporarily_disabled_cabinets: "المكاتب المعطلة مؤقتاً",
      all_system_users: "جميع مستخدمي النظام",
      currently_active_users: "المستخدمون النشطون حالياً",
      cabinet_administrators: "مديرو المكاتب",
      system_super_administrators: "مديرو النظام العامون",
      all_cases_in_system: "جميع القضايا في النظام",
      new_cases_current_month: "القضايا الجديدة هذا الشهر",
      create_enable_disable_cabinets: "إنشاء وتفعيل وتعطيل المكاتب",
      view_manage_system_users: "عرض وإدارة مستخدمي النظام",
      view_detailed_system_analytics: "عرض تحليلات النظام التفصيلية",
      
      // Cabinet details enhancements
      registered_users: "المستخدمون المسجلون",
      all_cases: "جميع القضايا",
      cabinet_id: "معرف المكتب",
      unique_identifier: "المعرف الفريد",
      user_activity_rate: "معدل نشاط المستخدمين",
      active_cases_rate: "معدل القضايا النشطة",
      no_recent_activity: "لا توجد أنشطة حديثة",
      cabinet_disabled_info: "معلومات تعطيل المكتب",
      disabled_by: "تم التعطيل بواسطة",
      disabled_cabinet: "مكتب معطل",
      user_activity: "نشاط المستخدمين",
      details: "التفاصيل",
      recent_cases: "القضايا الحديثة",
      recent_updates: "التحديثات الحديثة",
      
      // File storage translations
      file_storage_statistics: "إحصائيات تخزين الملفات",
      total_files: "إجمالي الملفات",
      storage_size: "حجم التخزين",
      recent_files_30_days: "الملفات الحديثة (30 يوم)",
      file_types: "أنواع الملفات",
      edit_name: "تعديل الاسم",
      
      // Missing navigation translations
      super_admin_cabinets: "المكاتب",
      super_admin_users: "المستخدمون",
      // Public listing requests ("référencez-moi")
      // Super-admin "work waiting" section
      sa_to_process: "قيد المعالجة",
      sa_pending_cabinets: "تسجيلات في انتظار الموافقة",
      sa_pending_listing_requests: "طلبات الإدراج",
      sa_nothing_pending: "لا شيء في الانتظار",
      sa_review_cabinets: "معالجة الطلبات",
      sa_review_listing_requests: "معالجة الطلبات",
      sa_last_7d: "خلال 7 أيام",
      lr_page_title: "طلبات الإدراج",
      lr_page_desc: "طلبات المحامين للإدراج في الدليل العام، الواردة من الصفحة الرئيسية",
      lr_status: "الحالة",
      lr_status_pending: "في انتظار المراجعة",
      lr_status_approved: "مقبول",
      lr_status_rejected: "مرفوض",
      lr_contact: "وسائل الاتصال",
      lr_submitted_at: "تاريخ الطلب",
      lr_approve: "قبول",
      lr_reject: "رفض",
      lr_approve_title: "قبول طلب الإدراج",
      lr_approve_desc: "سيتم نشر الملف في الدليل العام:",
      lr_reject_title: "رفض طلب الإدراج",
      lr_reject_desc: "سيبقى الملف غير منشور:",
      lr_rejection_reason: "سبب الرفض (داخلي)",
      lr_rejection_reason_placeholder: "مثال: تعذر التحقق من التسجيل في هيئة المحامين",
      lr_send_review_link: "إرسال رابط المراجعة إلى المحامي",
      lr_send_review_link_hint: "يمكّن المحامي من تأكيد بياناته أو طلب تعديلها بعد النشر.",
      lr_approved: "تم قبول الطلب ونشر الملف",
      lr_rejected: "تم رفض الطلب",
      lr_review_email_failed: "تم النشر، لكن تعذر إرسال بريد المراجعة.",
      lr_recent_submitted: "طلبات جديدة ({{days}} يوم)",
      lr_oldest_pending: "أقدم طلب ينتظر منذ {{days}} يوم.",
      lr_export_csv: "تصدير CSV",
      lp_export_csv: "تصدير CSV",
      lp_export_done: "تم تصدير {{count}} محامي",
      lr_empty: "لا توجد طلبات إدراج مطابقة.",
      lp_page_title: "ملفات المحامين",
      lp_page_desc: "إدارة ملفات المحامين العامة وإرسال روابط الاستحواذ",
      lp_add_profile: "إضافة ملف",
      lp_add_profile_desc: "أضف ملف محامٍ جديد في المنصة",
      lp_full_name: "الاسم الكامل",
      lp_full_name_fr: "الاسم بالفرنسية",
      lp_cabinet: "المكتب",
      lp_verified: "موثّق",
      lp_unverified: "غير موثّق",
      lp_published: "منشور",
      lp_published_yes: "منشور",
      lp_published_no: "غير منشور",
      lp_filter_published: "حالة النشر",
      lp_unclaimed: "غير مطالَب به",
      lp_claimed: "مطالَب به",
      lp_all: "الكل",
      lp_yes: "نعم",
      lp_no: "لا",
      lp_city: "المدينة",
      lp_send_claim: "إرسال رابط الاستحواذ",
      lp_view_details: "عرض التفاصيل",
      lp_claim_link_title: "رابط الاستحواذ",
      lp_claim_url: "الرابط",
      lp_email_sent: "تم إرسال الرابط عبر البريد الإلكتروني",
      lp_email_not_sent: "البريد الإلكتروني غير متوفر — شارك الرابط يدوياً",
      lp_delete_title: "حذف الملف",
      lp_created: "تم إنشاء الملف بنجاح",
      lp_deleted: "تم حذف الملف بنجاح",
      lp_no_profiles: "لا توجد ملفات",
      lp_search_name: "البحث بالاسم",
      lp_filter_claim_status: "حالة الاستحواذ",
      lp_filter_verified: "حالة التوثيق",
      chatbot_configuration: "إعدادات الشات بوت",
      chatbot: "روبوت المحادثة",
      chatbot_coming_soon: "روبوت المحادثة قادم قريباً",
      super_admin_feedback: "ملاحظات الشات بوت",
      search_feedback: "البحث في الملاحظات",
      sent_message: "الرسالة المرسلة",
      received_message: "الرسالة المستلمة",
      feedback_type: "نوع الملاحظة",
      no_feedback_found: "لم يتم العثور على ملاحظات",
      super_admin_logs: "سجلات الشات بوت",
      
      // Audit Logs translations
      audit_logs: "سجلات التدقيق",
      audit_logs_description: "عرض وإدارة سجلات نشاط النظام",
      audit_log_details: "تفاصيل سجل التدقيق",
      no_audit_logs_found: "لم يتم العثور على سجلات تدقيق",
      timestamp: "الطابع الزمني",
      model: "النموذج",
      object: "الكائن",
      object_id: "معرف الكائن",
      object_representation: "تمثيل الكائن",
      changes: "التغييرات",
      search_user: "بحث عن المستخدم",
      search_by_user_name: "البحث بواسطة اسم المستخدم",
      date_from: "من تاريخ",
      date_to: "إلى تاريخ",
      apply_filters: "تطبيق الفلاتر",
      
      // Logs Statistics Dashboard translations
      logs_statistics_dashboard: "لوحة إحصائيات السجلات",
      statistics: "الإحصائيات",
      logs_list: "قائمة السجلات",
      date_filter: "تصفية التاريخ",
      all_time: "كل الوقت",
      last_day: "اليوم الأخير",
      custom_range: "نطاق مخصص",
      period: "الفترة",
      beginning: "البداية",
      loading_stats: "جاري تحميل الإحصائيات",
      failed_to_load_stats: "فشل تحميل الإحصائيات",
      
      // Stats metrics translations
      total_logs: "إجمالي السجلات",
      total_messages_logged: "إجمالي الرسائل المسجلة",
      total_tokens: "إجمالي الرموز",
      total_tokens_consumed: "إجمالي الرموز المستهلكة",
      success_rate: "معدل النجاح",
      successful: "ناجح",
      errors: "أخطاء",
      avg_tokens_per_message: "متوسط الرموز لكل رسالة",
      average_token_usage: "متوسط استخدام الرموز",
      avg_llm_response_time: "متوسط وقت استجابة النموذج",
      llm_processing_time: "وقت معالجة النموذج",
      avg_processing_time: "متوسط وقت المعالجة",
      total_processing_time: "وقت المعالجة الإجمالي",
      avg_tool_calls: "متوسط استدعاءات الأدوات",
      avg_tools_per_message: "متوسط الأدوات لكل رسالة",
      top_models: "أفضل النماذج",
      top_tools: "أفضل الأدوات",
      no_data_available: "لا توجد بيانات متاحة",
      
      // Missing user management translations
      create_user: "إنشاء مستخدم",
      user_details: "تفاصيل المستخدم",
      username: "اسم المستخدم",
      
      // Missing form field translations
      enter_name: "أدخل الاسم",
      enter_username: "أدخل اسم المستخدم",
      enter_email: "أدخل البريد الإلكتروني",
      select_cabinet: "اختر المكتب",
      
      // Missing password-related translations
      password: "كلمة المرور",
      enter_password: "أدخل كلمة المرور",
      enter_new_password: "أدخل كلمة المرور الجديدة",
      confirm_new_password: "تأكيد كلمة المرور الجديدة",
      
      // Missing cabinet and role translations
      cabinet: "المكتب",
      active_user: "مستخدم نشط",
      
      // Missing dialog descriptions
      create_new_user_description: "إنشاء مستخدم جديد في النظام",
      

      all_registered_cabinets: "جميع المكاتب المسجلة",
      usage_analytics: "تحليلات الاستخدام",
      view_all_alerts: "عرض جميع التنبيهات",
      system_settings: "إعدادات النظام",
      more: "المزيد",
      
      // Credit System translations
      credit_management: "إدارة الاعتمادات",
      credit_usage: "استخدام الاعتمادات",
      monthly_credit_limit: "الحد الشهري للاعتمادات",
      credits_used: "الاعتمادات المستخدمة",
      credits_remaining: "الاعتمادات المتبقية",
      resets_on: "تتجدد في",
      credit_configuration: "تكوين الاعتمادات",
      input_token_cost: "تكلفة رموز الإدخال",
      output_token_cost: "تكلفة رموز الإخراج",
      credit_config_description: "إعدادات تكلفة رموز الذكاء الاصطناعي",
      tokens_per_credit: "رموز لكل اعتماد",
      update_configuration: "تحديث التكوين",
      configuration_updated: "تم تحديث التكوين بنجاح",
      total_messages_credit: "إجمالي الرسائل",
      total_tokens_credit: "إجمالي الرموز",
      total_credits_used: "إجمالي الاعتمادات المستخدمة",
      input_tokens_credit: "رموز الإدخال",
      output_tokens_credit: "رموز الإخراج",
      average_tokens_per_message: "متوسط الرموز لكل رسالة",
      average_credits_per_message: "متوسط الاعتمادات لكل رسالة",
      credit_stats: "إحصائيات الاعتمادات",
      usage_details: "تفاصيل الاستخدام",
      update_credit_limit: "تحديث حد الاعتمادات",
      manage_cabinet_quotas_and_usage_limits: "إدارة حصص المكاتب وحدود الاستخدام",
      monthly_limit: "الحد الشهري",
      current_month: "الشهر الحالي",
      is_exceeded: "تم التجاوز",
      failed_to_update: "فشل التحديث",
      
      //Blog section
      add_blog:"أضف مدونة",
      blog_management: "إدارة المدونات",
      search_blogs: "ابحث عن المقالات",
      no_blogs_yet: "لا توجد مقالات في الوقت الحالي",
      no_blogs_found: "لم يتم العثور على أي مقالات",
      create_first_blog_to_get_started: "لم يتم العثور على مقالات. أنشئ مقالتك الأولى للبدء.",
      blog_status: "حالة المقال",
      create_blog: "إنشاء مقال",
      blog_title: "عنوان المقال",
      blog_summary: "الوصف",
      content: "المحتوى",
      new_category: "إنشاء تصنيف",
      new_tag: "إنشاء وسم",
      create_t:"إنشاء",
      create_b:"إنشاء",
      category_b: "التصنيف",
      tags: "وسم",
      select_category_b: "اختر تصنيف",
      Arabe:"عربي",
      Français:"فرنسي",
      Back_to_blog_menu:"العودة إلى القائمة ",
      Publish:"انشر",
      Delete:"مسح",
      published:"تم النشر",
      draft:"مسودة",
      //blog_edit
      edit_blog:"تعديل",
      Unpublish:"إلغاء النشر",

      
      //CRM
      Create_contact:"إنشاء جهة اتصال",
      Contacts_List:"قائمة جهات الاتصال",
      Search_crm:"Rechercher par nom / Télephone / email / linkedin / tags",
      Total: "إجمالي السجلات",
      New_tag_name: "إنشاء وسم جديد",
      Add: "إضافة",
      Import_CSV_XLSX: "استيراد ملف CSV / XLSX",
      Create_missing_tags: "إنشاء الوسوم غير الموجودة",
      Nom_complet: "الاسم الكامل",
      Telephone: "رقم الهاتف",
      Email: "البريد الإلكتروني",
      LinkedIn: "لينكدإن",
      Tags: "الوسوم",
      Status: "الحالة",
      Actions: "الإجراءات",
      Voir:"عرض",
      Tags_a: "إنشاء وسم",
      Page_a:"الصفحة",
      sur_a:"الى",
      page_of: "الصفحة {current} من {total}",
      Import: "استيراد",
      Importing: "جارٍ الاستيراد...",
      chatbotInterface: {
        title: "مستشار AvocatPro",
        subtitle: "مساعد قانوني ذكي",
        typing: "يكتب...",
        close: "إغلاق",
        deleteConversation: "حذف المحادثة",
        suggestionsTitle: "اقتراحات للبدء:",
        welcomeTitle: "كيف يمكنني مساعدتك؟",
        welcomeSubtitle: "اطرح سؤالاً قانونياً أو اختر اقتراحاً",
        connectionError: "عذراً، لا يمكنني الاتصال بالخادم في الوقت الحالي. يرجى المحاولة مرة أخرى لاحقاً.",
        conversationDeleted: "تم حذف المحادثة. كيف يمكنني مساعدتك؟",
        deleteError: "حدث خطأ أثناء حذف المحادثة.",
        serviceUnavailable: "الخدمة غير متاحة حالياً. الرجاء المحاولة لاحقاً.",
        serviceNotActive: "خدمة المساعد الذكي غير مفعلة لحسابك.",
        aiAccessDisabled: "الوصول إلى الذكاء الاصطناعي غير مفعّل لحسابك.",
        quotaExhausted: "تم استنفاد الاعتمادات الشهرية للمساعد. الحد الشهري: {{limit}}. سيتم التجديد في: {{reset}}.",
        messageTooLong: "الرسالة طويلة جداً. الحد الأقصى هو {{maxLength}} حرف.",
        responseError: "عذراً، حدث خطأ أثناء الاستجابة.",
        networkError: "خطأ في الاتصال بالشبكة. يرجى التحقق من اتصالك بالإنترنت والمحاولة مرة أخرى.",
        timeoutError: "انتهت مهلة الاتصال. يرجى المحاولة مرة أخرى.",
        dailyQuotaExhausted: "تم استنفاد حصتك اليومية من الرسائل.",
        generalError: "عذراً، حدث خطأ. يرجى المحاولة مرة أخرى.",
        noInternet: "لا يوجد اتصال بالإنترنت. يرجى التحقق من اتصالك والمحاولة مرة أخرى.",
        audioMessage: "🎤 رسالة صوتية",
        transcribedText: "**النص المحول:** ",
        audioSendError: "خطأ في إرسال الصوت: ",
        // File Upload translations
        attachFile: "إرفاق ملف",
        uploadingFile: "جارٍ الرفع...",
        fileUploaded: "تم رفع الملف \"{{filename}}\" وهو جاهز للتحليل.",
        fileSizeError: "الملف كبير جداً. الحد الأقصى 10 ميجابايت.",
        fileTypeError: "نوع الملف غير مدعوم. الأنواع المسموحة: PDF, DOCX, TXT, PNG, JPEG",
        maxFilesError: "الحد الأقصى 5 ملفات. يرجى حذف ملف قبل رفع ملف جديد.",
        deleteFile: "حذف الملف",
        attachedFiles: "الملفات المرفقة",
        fileReady: "جاهز",
        fileProcessing: "قيد المعالجة",
        fileError: "خطأ",
        fileExpired: "منتهي الصلاحية",
        fileUploadError: "فشل رفع الملف. يرجى المحاولة مرة أخرى.",
        fileDeleteError: "فشل حذف الملف. يرجى المحاولة مرة أخرى."
      },
      chatbotConfig: {
        title: "إعدادات الشات بوت",
        description: "إدارة إعدادات الشات بوت للنظام",
        loading: "جاري تحميل الإعدادات...",
        saving: "جاري حفظ الإعدادات...",
        resetting: "جاري إعادة تعيين الإعدادات...",
        refreshing: "جاري تحديث الإعدادات...",
        
        // Status and Actions
        status: "الحالة",
        active: "نشط",
        default: "افتراضي",
        activeDescription: "تفعيل أو إلغاء تفعيل الشات بوت",
        defaultDescription: "تعيين هذا كإعداد افتراضي",
        resetToDefaults: "إعادة تعيين إلى الافتراضي",
        resetConfirmation: "هل أنت متأكد من إعادة تعيين جميع الإعدادات إلى القيم الافتراضية؟",
        unsavedChanges: "لديك تغييرات غير محفوظة",
        status_updated_successfully: "تم تحديث حالة الملف بنجاح",
        
        // Model Configuration
        modelConfiguration: "إعدادات النموذج",
        modelName: "اسم النموذج",
        modelNameDescription: "اختر نموذج الذكاء الاصطناعي المستخدم",
        temperature: "درجة الحرارة",
        temperatureDescription: "التحكم في إبداعية الردود (0.0 = محافظ، 1.0 = إبداعي)",
        maxTokens: "الحد الأقصى للرموز",
        maxTokensDescription: "الحد الأقصى لعدد الرموز في الرد",
        maxIterations: "الحد الأقصى للتكرارات",
        maxIterationsDescription: "عدد المحاولات القصوى للحصول على رد",
        
        // System Prompt
        systemPrompt: "رسالة النظام",
        systemPromptDescription: "التعليمات الأساسية للشات بوت",
        systemPromptPlaceholder: "أدخل تعليمات النظام للشات بوت...",
        
        // Default Message
         defaultMessage: "الرسالة الافتراضية",
         defaultMessageDescription: "الرسالة التي يراها المستخدم عند بدء المحادثة",
         defaultMessagePlaceholder: "أدخل الرسالة الافتراضية...",
         
         // Conversation Settings
         conversationSettings: "إعدادات المحادثة",
         maxConversationHistory: "تاريخ المحادثة الأقصى",
         maxConversationHistoryDescription: "الحد الأقصى لعدد الرسائل المحفوظة في التاريخ",
         conversationTimeoutHours: "انتهاء صلاحية المحادثة (ساعات)",
         conversationTimeoutHoursDescription: "عدد الساعات قبل انتهاء صلاحية المحادثة",
         maxMessageLength: "الحد الأقصى لطول الرسالة",
         maxMessageLengthDescription: "الحد الأقصى لعدد الأحرف في الرسالة الواحدة (50-5000)",
         maxAudioDuration: "مدة الصوت القصوى",
         maxAudioDurationDescription: "الحد الأقصى لمدة الرسالة الصوتية بالثواني (0-600)",
        
        // Status Settings
        statusSettings: "إعدادات الحالة",
        
        // Actions
        save: "حفظ الإعدادات",
        reset: "إعادة تعيين",
        refresh: "تحديث",
        cancel: "إلغاء",
        
        // Success messages
        saveSuccess: "تم حفظ الإعدادات بنجاح",
        resetSuccess: "تم إعادة تعيين الإعدادات بنجاح",
        refreshSuccess: "تم تحديث الإعدادات بنجاح",
        
        // Error messages
        saveError: "فشل في حفظ الإعدادات",
        loadError: "فشل في تحميل الإعدادات",
        resetError: "فشل في إعادة تعيين الإعدادات",
        refreshError: "فشل في تحديث الإعدادات"
      },
      
      // Additional missing keys
      lastUpdated: "آخر تحديث",
      reset: "إعادة تعيين",
      
      // Chatbot Logs translations
      search_logs: "البحث في السجلات",
      no_logs_found: "لم يتم العثور على سجلات",
      log_details: "تفاصيل السجل",
      user_message: "رسالة المستخدم",
      response_status: "حالة الرد",
      input_tokens: "رموز الإدخال",
      output_tokens: "رموز الإخراج",
      full_prompt: "النص الكامل",
      success: "نجح",
      timeout: "انتهت المهلة",
      partial: "جزئي",
      ordering: "الترتيب",
      default_order: "الترتيب الافتراضي",
      newest_first: "الأحدث أولاً",
      oldest_first: "الأقدم أولاً",
      longest_processing: "الأطول معالجة",
      shortest_processing: "الأقصر معالجة",
      
      chatFeedback: {
        helpful: "مفيد",
        not_helpful: "غير مفيد",
        submitting: "جارٍ الإرسال...",
        feedback_submitted: "✓ تم إرسال الملاحظة",
        add_details_title: "أضف تفاصيل لملاحظتك",
        add_details_prompt_positive: "شكراً على ملاحظتك الإيجابية! هل تود إضافة تفاصيل إضافية؟",
        add_details_prompt_negative: "شكراً على ملاحظتك السلبية! هل تود إضافة تفاصيل إضافية؟",
        details_placeholder: "يرجى مشاركة أي ملاحظات محددة حول الرد...",
        characters_count: "{{count}}/500 حرف",
        skip: "تخطي",
        add_details: "إضافة تفاصيل",
        share_feedback_title: "شارك ملاحظتك",
        your_question: "سؤالك",
        ai_response: "رد الذكاء الاصطناعي",
        rate_response_question: "كيف تقيم هذا الرد؟",
        positive_desc: "الرد كان مفيداً ودقيقاً",
        negative_desc: "الرد غير مفيد أو غير دقيق",
        additional_comments_optional: "ملاحظات إضافية (اختياري)",
        submit_feedback: "إرسال الملاحظة",
        cancel: "إلغاء"
      },
      chatbotSuggestions: {
        myAppointments: "ما هي مواعيدي؟",
        searchClient: "البحث عن موكيل",
        viewCases: "عرض قضاياي",
        generalHelp: "مساعدة عامة"
      },
      chatbotDocAnalysis: {
        title: "إعدادات نموذج تحليل الوثائق",
        description: "تحليل المستندات الطويلة واستخراج المعلومات بدقة",
        modelName: "اسم نموذج تحليل الوثائق",
        modelNameDescription: "اختر النموذج المستخدم لتحليل الوثائق",
        temperature: "درجة حرارة نموذج التحليل",
        temperatureDescription: "التحكم في إبداعية التحليل (0.0 = محافظ، 1.0 = إبداعي)",
        maxTokens: "الحد الأقصى للرموز في التحليل",
        maxTokensDescription: "الحد الأقصى لعدد الرموز المستخدمة في التحليل",
        maxTextLength: "الحد الأقصى لطول النص",
        maxTextLengthDescription: "أقصى عدد للأحرف المسموح بها في نص الوثيقة",
        systemPrompt: "رسالة النظام لنموذج التحليل",
        systemPromptDescription: "تعليمات مخصصة لتحليل الوثائق",
        systemPromptPlaceholder: "أدخل تعليمات النظام لتحليل الوثائق..."
      },
      // Template Requests
      all: "الكل",
      error_updating_request: "فشل في تحديث الطلب",
      template_requests: "طلبات النماذج",
      my_template_requests: "طلباتي",
      my_template_requests_desc: "تتبع حالة طلبات رفع النماذج الخاصة بك.",
      new_request: "طلب جديد",
      request_template: "طلب نموذج جديد",
      upload_template_request: "رفع طلب نموذج",
      upload_template_subtitle: "معالجة من طرف فريقنا",
      upload_template_desc: "قم برفع نموذج Word ليتم تحويله إلى نموذج ذكي يملأ بيانات القضية والموكل تلقائيًا.",
      choose_file: "اختيار ملف",
      file_format_note: "الصيغ المقبولة: Word قابل للتعديل (بدون مسح ضوئي).",
      no_file_selected: "لم يتم اختيار ملف",
      please_select_file: "يرجى اختيار ملف",
      description_label: "الوصف (اختياري)",
      description_placeholder: "يرجى شرح استخدام هذا النموذج باختصار (نوع الإجراء، الجهة القضائية، والمعلومات التي ترغب في تعبئتها تلقائيًا داخل الوثيقة...)",
      reassuring_message: "سيتم دراسة طلبكم من طرف فريق AvocatPro، وسيتم إشعاركم فور الشروع في معالجته.",

      individual: "فرد",
      corporate: "شركة",
      general_info: "معلومات عامة",
      specific_info: "معلومات خاصة",
      id_type: "نوع الهوية",
      cin: "بطاقة التعريف الوطنية",
      id_number: "رقم الهوية",
      passport: "جواز سفر",
      residence_card: "بطاقة إقامة",
      birth_date: "تاريخ الميلاد",
      nationality: "الجنسية",
      profession: "المهنة",
      legal_form: "الشكل القانوني",
      rc_number: "رقم السجل التجاري",
      rc_city: "مدينة السجل التجاري",
      if_number: "التعريف الجبائي",
      activity_sector: "قطاع النشاط",
      legal_representative: "الممثل القانوني",
      representative_role: "صفة الممثل",
      company_creation_date: "تاريخ التأسيس",
      internal_notes: "ملاحظات داخلية",
      city: "المدينة",
      country: "البلد",
      address: "العنوان",
      address_placeholder: "العنوان الكامل",
      ice_invalid: "يجب أن يتكون الرقم التعريفي الموحد للمقاولة من 15 رقمًا",
      ice_placeholder: "123456789012345",
      notes: "ملاحظات",
      status_pending: "قيد الانتظار",
      status_done: "مكتمل",
      status_refused: "مرفوض",
      no_requests_found: "لا توجد طلبات.",
      error_fetching_requests: "فشل في جلب الطلبات",
      request_submitted: "تم إرسال طلبكم بنجاح وهو قيد المعالجة.",
      request_approved: "تم اعتماد الطلب",
      request_rejected: "تم رفض الطلب",
      reject_request: "رفض الطلب",
      reject_reason_desc: "يرجى تقديم سبب لرفض هذا الطلب.",
      reason_placeholder: "سبب الرفض...",
      filter_status: "تصفية حسب الحالة",
      search_placeholder: "البحث باسم المكتب أو الملف...",
      approve: "موافقة",
      reject: "رفض",
      my_requests: "طلباتي",
      request_new_template: "طلب نموذج جديد",
      adversaries: "الخصوم",
      adversaries_desc: "إدارة خصوم القضية",
      add_adversary: "إضافة خصم",
      add_adversary_desc: "إضافة خصم جديد لهذه القضية",
      adversary_name: "اسم الخصم",
      search_adversaries: "البحث عن الخصوم...",
      adversary_added: "تمت إضافة الخصم {{name}}",
      adversary_removed: "تم حذف الخصم {{name}}",
      delete_adversary: "حذف الخصم",
      edit_adversary: "تعديل الخصم",
      edit_adversary_desc: "تعديل تفاصيل الخصم",
      adversary_updated: "تم تحديث الخصم {{name}}",
      no_adversaries: "لا يوجد خصوم",
      add_first_adversary: "أضف الخصم الأول",
      add_adversary_to_case: "إضافة خصم للقضية",
      select_existing_adversary: "اختيار خصم موجود",
      create_new_adversary: "إنشاء خصم جديد",
      adversary_added_to_case: "تمت إضافة الخصم {{name}} للقضية",
      adversary_removed_from_case: "تم إزالة الخصم {{name}} من القضية",
      no_adversaries_in_case: "لا يوجد خصوم في هذه القضية",
      no_profession_specified: "لم يتم تحديد مهنة",
      legal_info: "المعلومات القانونية",
      cases_as_client: "قضايا كموكل",
      cases_as_adversary: "قضايا كخصم",
      latest_cases_as_client: "آخر القضايا كموكل",
      latest_cases_as_adversary: "آخر القضايا كخصم",
      all_cases_as_client_desc: "عرض جميع القضايا التي يشارك فيها كطرف موكل",
      all_cases_as_adversary_desc: "عرض جميع القضايا التي يشارك فيها كطرف خصم",
      no_cases_found: "لم يتم العثور على قضايا",
      party: "طرف",
      party_not_found: "لم يتم العثور على الطرف",
      file: "ملف",
      Blog: "المدونة",
      user_name: "اسم المستخدم",
      filename: "اسم الملف",
      case_details: "تفاصيل القضية",
      no_notes_click_to_add: "لا توجد ملاحظات. اضغط للإضافة...",
      add_notes_placeholder: "أضف ملاحظات خاصة حول هذا الطرف...",
      ai_case_analysis: "تحليل القضية بالذكاء الاصطناعي",
      priority: "أولوية",
      only_priority: "الأولوية فقط",
      add_to_favorites: "إضافة إلى المفضلة",
      remove_from_favorites: "إزالة من المفضلة",
      case_marked_as_favorite: "تم تحديد القضية كأولوية",
      case_unmarked_as_favorite: "تم إزالة الأولوية عن القضية",
      failed_to_update_favorite: "فشل في تحديث حالة الأولوية",
      added_to_favorites: "تمت الإضافة إلى المفضلة",
      removed_from_favorites: "تمت الإزالة من المفضلة",
      ai_analysis: "تحليل الذكاء الاصطناعي",
      ai_case_analysis_desc: "تحليل ذكي لملف القضية",
      generate_analysis: "توليد التحليل",
      regenerate_analysis: "إعادة التحليل",
      generating_analysis: "جاري التحليل...",
      ai_analysis_complete: "تم التحليل بنجاح",
      ai_analysis_success_desc: "تم إنشاء ملخص القضية بنجاح.",
      error_generating_summary: "حدث خطأ أثناء توليد التحليل.",
      quick_summary: "ملخص سريع",
      quick_analysis_wait_msg: "جاري إنشاء نظرة عامة سريعة...",
      select_status: "اختر الحالة",
      status_overview: "نظرة عامة على الحالة",
      current_stage: "المرحلة الحالية",
      last_proceeding: "آخر إجراء",
      parties: "الأطراف",
      financial_summary: "الوضع المالي",

      total_deposits: "إجمالي المدفوعات",
      remaining: "المتبقي",
      next_steps: "الخطوات التالية",
      key_dates: "تواريخ مهمة",
      required_actions: "إجراءات مطلوبة",
      deep_analysis: "تحليل عميق",
      deep_analysis_wait_msg: "جاري إنشاء تحليل مفصل (قد يستغرق 30 ثانية)...",
      executive_summary: "الملخص التنفيذي",
      proceedings_analysis: "تحليل الإجراءات",
      total_hearings: "إجمالي الجلسات",
      total_postponements: "التأجيلات",
      pattern_detected: "نمط مكتشف",
      legal_strategy: "الاستراتيجية القانونية",
      strengths: "نقاط القوة",
      risks: "المخاطر",
      recommendations: "التوصيات",
      audience_preparation: "تحضير الجلسة",
      next_hearing: "الجلسة القادمة",
      required_documents: "وثائق مطلوبة",
      anticipated_questions: "أسئلة متوقعة",
      timeline: "الجدول الزمني",
      ready_to_analyze: "جاهز للتحليل",
      ai_analysis_intro: "استخدم الذكاء الاصطناعي للحصول على رؤى فورية حول هذه القضية.",
      type_needed: "النوع مطلوب",
      
      // New AI Analysis Fields
      checklist: "قائمة التحقق",
      key_arguments: "الحجج الرئيسية",
      financial_analysis: "التحليل المالي",
      fee_structure: "هيكل الأتعاب",
      deposits_timeline: "جدول الودائع",
      outstanding_balance: "الرصيد المتبقي",
      parties_analysis: "تحليل الأطراف",
      client_profile: "ملف الموكل",
      adversary_profiles: "ملفات الخصوم",
      document_analysis: "تحليل الوثائق",
      key_findings: "النتائج الرئيسية",
      documents_analyzed: "الوثائق المحللة",
      no_documents_analyzed: "لم يتم تحليل أي وثائق",

      // Honoraires Page
      honoraires: "الأتعاب",
      guides_resources: "الأدلة والموارد",
      honoraires_desc: "إدارة أتعاب القضايا ومتابعة المدفوعات",
      honoraires_total: "إجمالي الأتعاب",
      honoraires_paid: "المدفوع",
      honoraires_remaining: "المتبقي",
      honoraires_for_period: "للفترة المحددة",
      honoraires_collected: "تم تحصيلها",
      honoraires_outstanding: "مستحقات معلقة",
      honoraires_search: "بحث برقم القضية أو اسم الموكل...",
      honoraires_status_all: "الكل",
      honoraires_status_paid: "مدفوع",
      honoraires_status_partial: "جزئي",
      honoraires_status_unpaid: "غير مدفوع",
      honoraires_status_pending: "معلق",
      honoraires_col_case_number: "رقم القضية",
      honoraires_col_client: "الموكل",
      honoraires_col_tribunal: "المحكمة",
      honoraires_col_total_fee: "إجمالي الأتعاب",
      honoraires_col_amount_paid: "المدفوع",
      honoraires_col_amount_remaining: "المتبقي",
      honoraires_col_status: "الحالة",
      honoraires_loading: "جاري التحميل...",
      honoraires_page_of: "صفحة {{current}} من {{total}}",
      honoraires_deposits_received: "الاستئجارات الحرة (لم تُطبق على فاتورة)",
      honoraires_formally_paid: "مدفوعات رسمية (عبر فاتورة)",
      honoraires_total_invoiced: "إجمالي المفوتر رسمياً (HT)",
      honoraires_prov_abbr: "أمانات",
      honoraires_formal_abbr: "رسمي",
      honoraires_invoiced_abbr: "مفوتر",
      honoraires_gap_warning: "{{amount}} غير مفوترة",
      honoraires_credit_note_warning: "تجاوز — أصل الاعتماد",
      deposit_applied_to_invoice: "مُطبقة على فاتورة",
      inv_create_from_honoraire: "فوترة الأتعاب",
      inv_from_honoraire_desc: "سيتم إنشاء فاتورة مسودة بناءً على أتعاب هذه القضية.",
      inv_from_honoraire_deposits_desc: "{{count}} من الاستئجارات الحرة بمبلغ {{total}} ستُحول تلقائياً كمدفوعات على هذه الفاتورة. هل تريد المتابعة؟",
      inv_from_honoraire_success: "تم إنشاء الفاتورة بنجاح",
      inv_from_honoraire_error: "فشل في إنشاء الفاتورة",
      inv_gap_fully_invoiced: "الأتعاب مفوترة بالكامل",
      inv_gap_update_draft: "تحديث المسودة",
      inv_gap_cancel_reissue: "إلغاء وإعادة الإصدار",
      inv_gap_complement: "فاتورة تكميلية {{amount}}",
      inv_gap_complement_error: "فشل في إنشاء الفاتورة التكميلية",
      inv_gap_credit_note: "تجاوز: {{amount}}",

      // Facturation (Client Invoices) Page
      facturation: "الفوترة",
      facturation_desc: "إنشاء وإدارة فواتير العملاء",
      inv_create: "فاتورة جديدة",
      inv_col_number: "رقم الفاتورة",
      inv_col_client: "العميل",
      inv_col_issue_date: "تاريخ الإصدار",
      inv_col_due_date: "تاريخ الاستحقاق",
      inv_col_total_ttc: "المبلغ الإجمالي",
      inv_col_net: "صافي المستحق",
      inv_col_reste: "المتبقي",
      inv_col_status: "الحالة",
      inv_status_draft: "مسودة",
      inv_status_sent: "مرسلة",
      inv_status_partial: "جزئي",
      inv_status_paid: "مدفوعة",
      inv_status_cancelled: "ملغاة",
      inv_action_send: "إرسال الفاتورة",
      inv_action_pdf: "تحميل PDF",
      inv_action_edit: "تعديل",
      inv_action_delete: "حذف",
      inv_action_add_payment: "تسجيل دفعة",
      inv_total_ttc: "إجمالي المبالغ",
      inv_total_paid: "المدفوع",
      inv_reste: "المتبقي",
      inv_for_page: "للنتائج الحالية",
      inv_paid_desc: "مجموع المدفوعات",
      inv_reste_desc: "مستحقات معلقة",
      inv_detail_client: "العميل",
      inv_detail_case: "القضية",
      inv_detail_issue_date: "تاريخ الإصدار",
      inv_detail_due_date: "تاريخ الاستحقاق",
      inv_detail_notes: "ملاحظات",
      inv_lines_title: "بنود الفاتورة",
      inv_line_description: "الوصف",
      inv_line_qty: "الكمية",
      inv_line_unit_price: "سعر الوحدة",
      inv_line_tva: "TVA",
      inv_line_total_ht: "المجموع HT",
      inv_line_total_ttc: "المجموع TTC",
      inv_totals_ht: "الإجمالي HT",
      inv_totals_tva: "TVA",
      inv_totals_ttc: "الإجمالي TTC",
      inv_totals_ras_tva: "RAS TVA",
      inv_totals_ras_ir: "RAS IR",
      inv_totals_net: "صافي المستحق",
      inv_payments_title: "المدفوعات",
      inv_payment_date: "تاريخ الدفع",
      inv_payment_method: "طريقة الدفع",
      inv_payment_amount: "المبلغ",
      inv_payment_reference: "المرجع",
      inv_payment_notes: "ملاحظات",
      inv_payment_method_cash: "نقدًا",
      inv_payment_method_check: "شيك",
      inv_payment_method_wire: "تحويل",
      inv_payment_method_mobile: "هاتف",
      inv_payment_method_other: "أخرى",
      inv_add_payment: "إضافة دفعة",
      inv_delete_payment_confirm: "هل تريد حذف هذه الدفعة؟",
      inv_send_confirm: "إرسال الفاتورة",
      inv_send_confirm_desc: "سيتم إنشاء PDF وتغيير حالة الفاتورة إلى 'مرسلة'.",
      inv_delete_confirm: "حذف الفاتورة",
      inv_delete_confirm_desc: "لا يمكن التراجع عن هذا الإجراء.",
      inv_form_client: "العميل",
      inv_form_case: "القضية (اختياري)",
      inv_form_issue_date: "تاريخ الإصدار",
      inv_form_due_date: "تاريخ الاستحقاق (اختياري)",
      inv_form_notes: "ملاحظات",
      inv_form_ras_tva: "RAS TVA",
      inv_form_ras_tva_rate: "نسبة RAS TVA (%)",
      inv_form_ras_ir: "RAS IR",
      inv_form_ras_ir_rate: "نسبة RAS IR (%)",
      inv_form_lines: "بنود الفاتورة",
      inv_form_add_line: "إضافة بند",
      inv_form_remove_line: "حذف",
      inv_form_submit: "إنشاء الفاتورة",
      inv_form_update: "تحديث الفاتورة",
      inv_no_lines: "أضف بنداً واحداً على الأقل",
      inv_total_preview: "معاينة الإجماليات",
      inv_settings_title: "إعدادات الفوترة",
      inv_settings_desc: "بيانات الكابينة التي تظهر على PDF",
      inv_settings_identity: "هوية الكابينة",
      inv_settings_legal: "المعرفات القانونية",
      inv_settings_tva: "الضريبة على القيمة المضافة (TVA)",
      inv_settings_numbering: "ترقيم الفواتير",
      inv_settings_bank: "المعلومات البنكية",
      inv_settings_other: "إعدادات أخرى",
      inv_settings_saved: "تم حفظ الإعدادات بنجاح",
      inv_settings_address: "العنوان",
      inv_settings_phone: "الهاتف",
      inv_settings_email: "البريد الإلكتروني",
      inv_settings_ice: "رقم ICE",
      inv_settings_if: "رقم IF",
      inv_settings_rc: "رقم RC",
      inv_settings_patente: "رقم الإجازة (Patente)",
      inv_settings_cnss: "رقم CNSS",
      inv_settings_tva_enabled: "تفعيل TVA على الفواتير",
      inv_settings_tva_number: "رقم TVA",
      inv_settings_tva_rate: "نسبة TVA الافتراضية (%)",
      inv_settings_prefix: "بادئة رقم الفاتورة",
      inv_settings_next_number: "الرقم التالي للفاتورة (تلقائي)",
      inv_settings_bank_name: "اسم البنك",
      inv_settings_bank_rib: "رقم RIB",
      inv_settings_bank_iban: "رقم IBAN",
      inv_settings_payment_terms: "آجال الدفع الافتراضية (أيام)",
      inv_settings_footer: "تذييل الفاتورة",
      inv_settings_save: "حفظ الإعدادات",

      // Dépenses (Expenses module)
      depenses: "المصاريف",
      depenses_desc: "إدارة مصاريف القضايا والمكتب",
      exp_create: "مصروف جديد",
      exp_kpi_total: "إجمالي المصاريف",
      exp_kpi_billed: "المفوترة",
      exp_kpi_cabinet: "مصاريف المكتب",
      exp_kpi_dossier: "ديبور القضايا",
      exp_col_date: "التاريخ",
      exp_col_description: "الوصف",
      exp_col_case: "القضية",
      exp_col_category: "الفئة",
      exp_col_amount: "المبلغ",
      exp_col_status: "الحالة",
      exp_col_vendor: "المورد",
      exp_col_billable: "قابل للفوترة",
      exp_type_cabinet: "مكتب",
      exp_type_dossier: "دوسيه",
      exp_cat_frais_justice: "مصاريف قضائية",
      exp_cat_deplacement: "تنقل",
      exp_cat_expertise: "خبرة",
      exp_cat_honoraires_confrere: "أتعاب زميل",
      exp_cat_fournitures: "لوازم",
      exp_cat_communication: "اتصالات",
      exp_cat_other: "أخرى",
      exp_status_refacturee: "مفوتر",
      exp_status_a_refacturer: "للفوترة",
      exp_status_non_facturable: "غير قابل للفوترة",
      exp_tab_all: "الكل",
      exp_tab_a_refacturer: "للفوترة",
      exp_tab_refacturee: "مفوتر",
      exp_tab_non_facturable: "غير قابل",
      exp_filter_type: "النوع",
      exp_filter_category: "الفئة",
      exp_create_title: "مصروف جديد",
      exp_create_desc: "أضف مصروف مكتب أو ديبور قضية",
      exp_edit_title: "تعديل المصروف",
      exp_edit_desc: "تعديل بيانات المصروف",
      exp_field_type: "نوع المصروف",
      exp_field_case: "القضية",
      exp_field_category: "الفئة",
      exp_field_description: "الوصف",
      exp_field_amount: "المبلغ",
      exp_field_currency: "العملة",
      exp_field_date: "التاريخ",
      exp_field_billable: "قابل للفوترة على الموكل",
      exp_field_assigned_to: "مسند إلى",
      exp_field_assigned_to_placeholder: "اختر محاميا (اختياري)",
      exp_case_tab_title: "ديبور وتكاليف",
      exp_case_tab_desc: "المصاريف المرتبطة بهذه القضية",
      exp_add_case: "إضافة ديبور",
      exp_cannot_delete_billed: "لا يمكن حذف مصروف مفوتر. أوقف الفوترة أولاً.",
      exp_cannot_edit_billed: "لا يمكن تعديل مصروف مفوتر. أوقف الفوترة أولاً.",
      exp_delete_success: "تم حذف المصروف",
      exp_save_success: "تم حفظ المصروف",
      exp_delete_error: "خطأ في حذف المصروف",
      exp_save_error: "خطأ في حفظ المصروف",
      exp_action_bill: "فوترة للموكل",
      exp_action_unbill: "إلغاء الفوترة",
      exp_bill_dialog_title: "إضافة إلى فاتورة",
      exp_bill_no_invoices: "لا توجد فواتير مفتوحة لهذا الملف.",
      exp_bill_confirm: "فوترة",
      exp_bill_success: "تمت الفوترة بنجاح",
      exp_unbill_success: "تم إلغاء الفوترة",

      // Affectation des avocats
      affectation: "تعيين المحامين",
      affectation_desc: "إدارة ملفات تفضيلات التعيين لكل محامٍ",
      aff_add_profile: "إضافة ملف تفضيلات",
      aff_edit_profile: "تعديل ملف التفضيلات",
      aff_delete_profile: "حذف ملف التفضيلات",
      aff_delete_profile_desc: "هل أنت متأكد من حذف ملف تفضيلات هذا المحامي؟ لا يمكن التراجع عن هذا الإجراء.",
      aff_col_lawyer: "المحامي",
      aff_col_villes: "المدن",
      aff_col_tribunal_types: "الجهات القضائية",
      aff_col_case_types: "أنواع الإجراءات",
      aff_col_status: "الحالة",
      aff_active: "نشط",
      aff_inactive: "غير نشط",
      aff_any: "الكل",
      aff_select_lawyer: "اختر المحامي",
      aff_search_villes: "ابحث عن مدينة...",
      aff_search_tribunals: "ابحث عن جهة قضائية...",
      aff_search_case_types: "ابحث عن نوع الإجراء...",
      aff_profile_created: "تم إنشاء ملف التفضيلات بنجاح",
      aff_profile_updated: "تم تحديث ملف التفضيلات بنجاح",
      aff_profile_deleted: "تم حذف ملف التفضيلات",
      aff_no_profiles: "لا توجد ملفات تفضيلات. أضف ملفاً للبدء.",
      aff_history: "سجل التعيينات",
      aff_history_lawyer: "المحامي",
      aff_history_context: "السياق",
      aff_history_date: "التاريخ",
      aff_history_by: "بواسطة",
      aff_context_case: "ملف",
      aff_context_rendezvous: "جلسة",
      aff_score: "الدرجة",
      aff_recommended: "مُوصى به",

      // External Lawyers
      external_lawyers: "المحامون الخارجيون",
      external_lawyers_desc: "إدارة المحامين الخارجيين المرتبطين بالمكتب",
      ext_add: "إضافة محامٍ خارجي",
      ext_edit: "تعديل المحامي الخارجي",
      ext_delete: "حذف المحامي الخارجي",
      ext_delete_desc: "هل أنت متأكد من حذف هذا المحامي الخارجي؟ لا يمكن التراجع عن هذا الإجراء.",
      ext_col_name: "الاسم",
      ext_col_email: "البريد الإلكتروني",
      ext_col_created: "تاريخ الإضافة",
      ext_name_placeholder: "مثال: الأستاذ دوبون",
      ext_email_placeholder: "email@cabinet.ma",
      ext_created: "تم إضافة المحامي الخارجي بنجاح",
      ext_updated: "تم تحديث المحامي الخارجي بنجاح",
      ext_deleted: "تم حذف المحامي الخارجي",
      ext_no_data: "لا يوجد محامون خارجيون. أضف محاميًا للبدء.",
      ext_name_required: "الاسم مطلوب",
      ext_badge: "خارجي",

      // Documents Page
      documents: "المستندات",
      documents_desc: "عرض وبحث جميع ملفات المكتب",
      doc_search_placeholder: "بحث باسم الملف أو اسم القضية...",
      doc_col_filename: "اسم الملف",
      doc_col_type: "النوع",
      doc_col_size: "الحجم",
      doc_col_case: "القضية",
      doc_col_uploaded_by: "رفع بواسطة",
      doc_col_date: "التاريخ",
      full_text_search: "البحث النصي الشامل",
      full_text_search_desc: "البحث داخل محتوى الملفات عبر التعرف الضوئي على الحروف",
      full_text_search_placeholder: "ابحث داخل محتوى الملفات...",
      search_snippet: "السياق",
      no_match_context: "بدون سياق",

      // ── Lawyer Profile — Arabic ───────────────────────────────────────────────────
      lawyer_profile: "الصفحة المهنية",
      lawyer_profile_desc: "أدر صفحتك المهنية العامة التي يراها الزوار",
      publish_profile: "نشر الصفحة",
      publish_profile_desc: "عند التفعيل، ستكون صفحتك مرئية للعموم",
      show_section: "إظهار القسم",
      identity: "الهوية المهنية",
      identity_desc: "معلوماتك الشخصية والمهنية",
      full_name: "الاسم الكامل بالعربية",
      full_name_fr: "الاسم بالأحرف اللاتينية",
      bar_city: "هيئة المحامين",
      rattachement_year: "سنة الانتساب للهيئة",
      since: "منذ",
      barreau_de: "هيئة محامي",
      bio: "نبذة تعريفية",
      bio_ar: "النبذة بالعربية",
      bio_fr: "النبذة بالفرنسية",
      contact: "معلومات الاتصال",
      whatsapp: "واتساب",
      email_public: "البريد الإلكتروني",
      website: "الموقع الإلكتروني",
      linkedin: "لينكدإن",
      google_maps_url: "رابط خرائط غوغل",
      view_on_maps: "عرض على الخريطة",
      cabinet_location: "عنوان المكتب",
      cabinet_address: "العنوان التفصيلي",
      select_city: "اختر المدينة",
      specializations: "التخصصات",
      experience: "الخبرة المهنية",
      years_of_experience: "سنوات الخبرة",
      years: "سنة",
      experience_requires_rattachement_year: "يرجى تحديد سنة الانتساب للهيئة",
      education: "المؤهلات العلمية",
      degree: "الشهادة",
      institution: "المؤسسة التعليمية",
      add_education: "إضافة شهادة",
      certifications: "الشهادات المهنية",
      certification_title: "اسم الشهادة",
      issuer: "الجهة المانحة",
      add_certification: "إضافة شهادة مهنية",
      career: "المسيرة المهنية",
      from_month: "الشهر (من)",
      from_year: "السنة (من)",
      to_month: "الشهر (إلى)",
      to_year: "السنة (إلى)",
      no_month: "بدون شهر",
      current_position: "العمل الحالي",
      present: "حتى الآن",
      add_career: "إضافة منصب",
      languages_spoken: "اللغات",
      save_profile: "حفظ الصفحة",
      profile_deleted: "تم حذف الصفحة",
      delete_profile: "حذف الصفحة المهنية",
      saved_successfully: "تم الحفظ بنجاح",
      photo_profile: "الصورة الشخصية",
      upload_photo_hint: "JPG أو PNG — الحد الأقصى 10 ميغابايت",
      preview_mode: "وضع المعاينة",
      close_preview: "إغلاق المعاينة",
      back_to_edit: "العودة للتعديل",
      no_name: "لا يوجد اسم",
      publish: "نشر",
      unpublish: "إلغاء النشر",
      confirm_publish_title: "نشر الصفحة المهنية",
      confirm_publish_desc: "ستصبح صفحتك مرئية للعموم. يمكن للزوار الاطلاع على معلوماتك. هل تريد المتابعة؟",
      confirm_unpublish_title: "إلغاء نشر الصفحة",
      confirm_unpublish_desc: "لن تكون صفحتك مرئية للعموم بعد الآن. هل تريد المتابعة؟",
       
      // Validation errors — Arabic
      error_name_min: "الاسم يجب أن يحتوي على حرفين على الأقل",
      error_name_max: "الاسم يجب ألا يتجاوز 80 حرفاً",
      error_name_chars: "الاسم يجب أن يحتوي على أحرف فقط",
      error_title_max: "اللقب يجب ألا يتجاوز 50 حرفاً",
      error_bio_max: "النبذة يجب ألا تتجاوز 500 حرف",
      error_phone_format: "رقم الهاتف غير صحيح. مثال: +212600000000 أو 0600000000",
      error_email_format: "البريد الإلكتروني غير صحيح",
      error_url_https: "الرابط يجب أن يبدأ بـ https://",
      error_career_dates: "تاريخ البداية يجب أن يكون قبل تاريخ النهاية",

      // Onboarding Tour
      onboarding: {
        case_summary: {
            title: "مرحبًا بك في تحليل القضايا بالذكاء الاصطناعي!",
            content: "اكتشف كيف يمكن للذكاء الاصطناعي مساعدتك في تحليل ملفات القضايا بسرعة ودقة.",
            mode_title: "اختر نوع التحليل",
            mode_content: "يمكنك التبديل بين 'ملخص سريع' للحصول على نظرة عامة، أو 'تحليل عميق' للتفاصيل الكاملة.",
            generate_title: "ابدأ التحليل",
            generate_content: "اضغط هنا لتوليد تحليل جديد أو تحديث التحليل الحالي.",
            result_title: "عرض النتائج",
            result_content: "ستظهر نتائج التحليل هنا، بما في ذلك التواريخ المهمة، والملخص المالي، والتوصيات.",
            key_dates_hint: "هنا تجد الجدول الزمني للأحداث الرئيسية في القضية.",
        },
        skip: "تخطي الجولة",
        next: "التالي",
        next_with_step: "التالي ({{current}} من {{total}})",
        back: "السابق",
        done: "إنهاء",
        welcome_video: {
          badge: "🚀 جولة سريعة • 90 ثانية لاكتشاف المنصة",
          title: "مرحباً بك في AvocatPro!",
          subtitle: "دليل تعريفي سريع مدته 90 ثانية يشرح لك كيفية تسيير مكتبك وإدارة ملفاتك ومواعيدك وفواتيرك بكل احترافية.",
          feature_cases_title: "إدارة القضايا والملفات",
          feature_cases_desc: "تتبع ملفات الموكلين، الجلسات، والمستندات بضغطة زر.",
          feature_agenda_title: "الأجندة والمواعيد",
          feature_agenda_desc: "تنظيم مواعيد الاستشارات والجلسات وتجنب أي تعارض في التواريخ.",
          feature_billing_title: "الفواتير والمصاريف",
          feature_billing_desc: "إصدار فواتير الأتعاب، تتبع المدفوعات ومراقبة مصاريف المكتب بسهولة.",
          cta_start: "ابدأ استخدام المنصة",
          cta_skip: "تخطي الآن",
          dont_show_again: "عدم إظهار هذا الفيديو تلقائياً مرة أخرى",
          replay_button: "دليل المنصة (90 ثانية)",
          replay_tooltip: "مشاهدة الفيديو التعريفي الشامل للمنصة (90 ثانية)",
          video_load_error: "تعذر تحميل الفيديو، يرجى التحقق من اتصال الإنترنت أو المحاولة لاحقاً."
        },
      }
    },
  },
  fr: {
  translation: {
    appname: "AvocatPro",
    common: {
      cancel: "Annuler",
      creating: "Création en cours...",
      saving: "Enregistrement en cours...",
      delete: "Supprimer",
      edit: "Modifier",
      add: "Ajouter",
      view: "Voir",
    },
    guides: {
      "page_title": "Guides et ressources",
      "page_desc": "Vidéos explicatives et bonnes pratiques pour tirer le meilleur d'AvocatPro",
      "search_placeholder": "Rechercher un guide...",
      "all": "Tous",
      "best_practices": "Bonnes pratiques",
      "empty": "Aucun guide trouvé.",
      "modules": {
        "general_overview": "Présentation",
        "home_dashboard": "Tableau de bord",
        "appointments": "Agenda",
        "cases": "Dossiers",
        "clients": "Clients",
        "adversaries": "Adversaires",
        "invoicing": "Facturation",
        "expenses": "Dépenses",
        "fees": "Honoraires",
        "lawyer_assignment": "Affectation des avocats",
        "external_lawyers": "Avocats externes",
        "team_permissions": "Équipe et permissions",
        "ai_assistant": "Assistant IA",
        "settings": "Paramètres",
        "dossier_mobile": "Application mobile",
        "other": "Autres"
      },
      "tips": {
        "general_overview": [
          "Commencez par la vidéo de présentation, puis suivez les guides dans l'ordre proposé.",
          "Configurez d'abord votre cabinet (profil, équipe, rôles) avant de saisir vos dossiers."
        ],
        "home_dashboard": [
          "Consultez le tableau de bord chaque matin : audiences, rendez-vous et tâches du jour.",
          "Notez vos tâches dès qu'elles surviennent pour ne rien oublier."
        ],
        "appointments": [
          "Rattachez toujours un rendez-vous ou une audience à son dossier.",
          "Précisez le lieu (cabinet ou tribunal) et l'heure de fin pour éviter les chevauchements.",
          "Vérifiez l'agenda de la semaine chaque vendredi."
        ],
        "cases": [
          "Utilisez une numérotation cohérente (numéro, code, année) pour retrouver un dossier rapidement.",
          "Renseignez le client, le tribunal et le montant des honoraires dès la création.",
          "Mettez à jour le statut du dossier après chaque audience."
        ],
        "clients": [
          "Distinguez correctement personne physique et société.",
          "Renseignez téléphone et e-mail : ils servent aux rappels et à la facturation.",
          "Évitez les doublons : recherchez le client avant d'en créer un."
        ],
        "adversaries": [
          "Enregistrez la partie adverse dès l'ouverture du dossier.",
          "Gardez ses coordonnées complètes pour les notifications et les actes."
        ],
        "invoicing": [
          "Vérifiez la TVA et la retenue à la source (RAS TVA / RAS IR) avant d'émettre la facture.",
          "Renseignez toujours une date d'échéance pour suivre les impayés.",
          "Détaillez les lignes (description, quantité, prix) pour éviter les contestations."
        ],
        "expenses": [
          "Saisissez chaque dépense le jour même, avec sa catégorie.",
          "Rattachez les frais engagés pour un client à son dossier afin de les refacturer.",
          "Séparez les dépenses du cabinet de celles des dossiers."
        ],
        "fees": [
          "Suivez régulièrement le montant payé et le restant dû par dossier.",
          "Exportez le récapitulatif pour vos points mensuels de trésorerie."
        ],
        "lawyer_assignment": [
          "Définissez les tribunaux et types de dossiers de chaque avocat.",
          "Gardez un profil actif par avocat pour une répartition équitable."
        ],
        "external_lawyers": [
          "Enregistrez vos confrères partenaires avec nom et e-mail à jour.",
          "Vérifiez l'accord de confidentialité avant de partager un dossier."
        ],
        "team_permissions": [
          "Appliquez le principe du moindre privilège : donnez à chacun le rôle strictement nécessaire.",
          "Désactivez immédiatement le compte d'un collaborateur qui quitte le cabinet."
        ],
        "ai_assistant": [
          "Posez des questions précises et indiquez le dossier concerné.",
          "Vérifiez toujours les références juridiques avant de les utiliser.",
          "Ne partagez pas de données sensibles inutiles."
        ],
        "settings": [
          "Complétez le profil du cabinet : il apparaît sur vos factures et documents.",
          "Contrôlez régulièrement votre abonnement et votre consommation."
        ],
        "dossier_mobile": [
          "Installez l'application pour consulter vos audiences en déplacement.",
          "Activez les notifications pour ne manquer aucun rappel."
        ]
      },
      proposal_message: "Souhaitez-vous regarder un guide rapide sur « {{title}} » ?",
      watch_video: "Regarder la vidéo",
      no_thanks: "Non merci",
      close: "Fermer",
      video_error: "Impossible de charger la vidéo, veuillez réessayer plus tard.",
    },
    last_week: "La semaine dernière",
    last_month: "Le mois dernier",
    last_year: "L'année dernière",
    custom: "Personnalisé",
    filter_by_period: "Filtrer par période",
    pick_date_range: "Choisir une période",
    filter_by_date: "Filtrer par date",
    min_amount: "Montant min",
    max_amount: "Montant max",
    reset_filters: "Réinitialiser les filtres",
    login: "Connexion",
    user: "Nom d'utilisateur",
    pass: "Mot de passe",
    log_ins: "Veuillez entrer votre nom d'utilisateur et votre mot de passe.",
    forgot_pass: "Mot de passe oublié ?",
    remember_me: "Se souvenir de moi",
    notifications: "Notifications",
    no_notifications: "Aucune notification",
    all_caught_up: "Vous êtes à jour",
    unread: "Non lu",
    mark_as_read_and_continue: "J'ai lu et compris",
    dir: "ltr",
    forgot_password_title: "Mot de passe oublié ?",
    forgot_password_desc: "Entrez votre nom d'utilisateur et votre e-mail pour recevoir un lien de réinitialisation.",
    send_reset_link: "Envoyer le lien",
    sending: "Envoi en cours...",
    reset_link_sent_title: "Lien de réinitialisation envoyé",
    reset_link_sent_desc: "Nous avons envoyé un lien de réinitialisation de mot de passe à votre adresse e-mail.",
    reset_link_sent_message: "Veuillez vérifier votre e-mail pour le lien de réinitialisation. Si vous ne recevez pas l'e-mail, vérifiez votre dossier spam ou réessayez.",
    back_to_login: "Retour à la connexion",
    verify_email_title: "Vérifiez votre e-mail",
    verify_email_desc: "Votre compte nécessite une vérification par e-mail. Nous vous avons envoyé un lien.",
    user_placeholder: "Nom",
    enter_user: "Veuillez entrer le nom d'utilisateur",
    enter_pass: "Veuillez entrer le mot de passe",
    tos: "En cliquant sur Connexion, vous acceptez nos conditions d'utilisation et notre politique de confidentialité.",
    privacy_policy: 'Notre politique de confidentialité',
    signup: "Créer un compte",
    signup_subtitle: "Créer un compte pour un nouveau cabinet.",
    have_account: "Vous avez déjà un compte ?",
    dont_have_account: "Vous n'avez pas de compte ?",
    agree_privacy: "En vous inscrivant, vous acceptez ",
    step: "Étape",
    back: "Retour",
    next: "Suivant",
    actions: "Actions",
    signup_step_account: "Infos du compte",
    signup_step_cabinet: "Infos du cabinet",
    signup_step_preferences: "Préférences",
    preferred_language: "Langue préférée",
    arabic: "Arabe",
    french: "Français",
    step_of_total: "Étape {{current}} / {{total}}",
    username_placeholder: "Choisissez un nom d'utilisateur",
    password_hint: "Au moins 8 caractères",
    password_min_8: "Le mot de passe doit contenir au moins 8 caractères",
    cabinet_name_required: "Le nom du cabinet est requis",
    billing_name_required: "Le nom de facturation est requis",
    billing_email_required: "L'e-mail de facturation est requis",
    signup_review_message: "Nous définirons automatiquement la langue et le fuseau horaire. Vérifiez les détails puis envoyez.",
    availability_intro: "Votre compte est examiné par notre équipe avant activation. Indiquez-nous quand vous contacter (jours ouvrés).",
    availability_days: "Jours disponibles",
    availability_slot: "Horaire préféré",
    availability_slot_placeholder: "Matin ou après-midi",
    availability_days_required: "Sélectionnez au moins un jour",
    availability_slot_required: "Sélectionnez un horaire",
    day_mon: "Lun",
    day_tue: "Mar",
    day_wed: "Mer",
    day_thu: "Jeu",
    day_fri: "Ven",
    slot_morning: "Matin",
    slot_afternoon: "Après-midi",
    signup_pending_title: "Votre compte est en attente d'approbation",
    signup_pending_desc: "Notre équipe examine chaque nouveau cabinet. Nous vous contacterons durant votre disponibilité choisie.",
    signup_rejected_title: "Demande rejetée",
    signup_rejected_desc: "Veuillez contacter le support pour plus d'informations.",
    creating_account: "Création du compte...",
    cabinet_name: "Nom du cabinet",
    billing_name: "Nom de facturation",
    billing_email: "E-mail de facturation",
    cabinet_name_placeholder: "Nom de votre cabinet",
    billing_name_placeholder: "Nom légal pour la facturation",
    billing_email_placeholder: "E-mail pour la facturation",
    serv_error: "Impossible de se connecter au serveur",
    serv_wrong_resp: "Le serveur a renvoyé une réponse incorrecte",
    email: "E-mail",
    invalid_email: "E-mail invalide",
    email_placeholder: "E-mail",
    confirm_new_pass: "Veuillez confirmer le nouveau mot de passe",
    new_pass_placeholder: "Nouveau mot de passe",
    confirm_new_pass_placeholder: "Confirmer le nouveau mot de passe",
    passwords_do_not_match: "Les mots de passe ne correspondent pas",
    reset_password_title: "Réinitialiser le mot de passe",
    reset_password_desc: "Entrez et confirmez votre nouveau mot de passe.",
    resetting_password: "Réinitialisation du mot de passe...",
    reset_password: "Réinitialiser le mot de passe",
    password_reset_success_title: "Mot de passe réinitialisé avec succès",
    password_reset_success_desc: "Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",

    calendar: "Agenda",
    view_calendar: "Voir le calendrier",
    selectMonth: "Choisir le mois",
    loading_analysis: "Chargement de l'analyse...",
    no_analysis_content: "Aucun contenu d'analyse pour le moment. Essayez de rouvrir ou d'actualiser.",
    no_analysis_available: "Aucune analyse disponible.",
    no_content: "Aucun contenu",
    generate: "Générer",
    generated_at: "Généré le :",
    text_length: "Longueur du texte :",
    analysis_ready: "Analyse prête",
    good_morning: "Bonjour",
    good_evening: "Bonsoir",
    agenda_time_morning: "Matin",
    agenda_time_evening: "Soir",
    upcoming_appointments_this_month: "{{count}} rendez-vous restants ce mois-ci",
    // Dashboard Refinements
    dashboard: "Tableau de bord",
    add_new_file: "Ajouter un dossier",
    view_full_schedule: "Voir le planning complet",
    upcoming_sessions: "Prochaines audiences",
    active_files: "Dossiers actifs",
    todays_appointments: "Rendez-vous du jour",
    pending_tasks: "Tâches en attente",
    todays_agenda: "Agenda du jour",
    dashboard_recent_files: "Dossiers récents",
    next_appointment: "Prochain RDV",
    no_upcoming_appointments: "Aucun rendez-vous à venir",
    professor_title: "Maître",
    dashboard_subtitle: "Voici un résumé de l'activité de votre cabinet pour aujourd'hui.",
    today_in_trend: "Aujourd'hui",
    new_files_this_week: "nouveaux dossiers cette semaine",
    active_tasks_count_label: "tâches actives",
    quick_tasks: "Tâches rapides",
    no_active_tasks: "Aucune tâche active. Ajoutez une nouvelle tâche pour commencer !",
    add_new_task_placeholder: "Ajouter une nouvelle tâche...",
    task_added: "Tâche ajoutée",
    task_added_desc: "Tâche ajoutée avec succès",
    task_limit_reached: "Vous avez atteint la limite de 10 tâches actives. Veuillez en terminer certaines d'abord.",
    task_add_failed: "Échec de l'ajout de la tâche. Veuillez réessayer.",
    task_update_failed: "Échec de la mise à jour de la tâche. Veuillez réessayer.",
    task_deleted: "Supprimé",
    task_deleted_desc: "Tâche supprimée avec succès",
    task_delete_failed: "Échec de la suppression de la tâche. Veuillez réessayer.",
    // Agenda List
    session: "Audience",
    office_meeting: "Bureau",
    done: "Terminé",
    no_appointments_today: "Aucun rendez-vous aujourd'hui",
    // Recent Files Table
    file_number: "N° Dossier",
    file_name: "Nom du dossier",
    client_header: "Client",
    status_header: "État",
    last_update_header: "Dernière mise à jour",
    dashboard_file_status_active: "En cours",
    dashboard_file_status_pending: "En délibéré",
    dashboard_file_status_closed: "Jugé",
    status_archived_at: "Archivé",
    failed_to_get_analysis: "Échec de l'obtention de l'analyse",
    failed_to_generate_analysis: "Échec de la génération de l'analyse",
    show_analysis: "Voir l'analyse",
    cases: "Dossiers",
    clients: "Clients",
    client: "Client",
    for_client: "Pour le compte de",
    users: "Utilisateurs",
    other_pages: "Autres pages",
    settings: "Paramètres",
    account: "Compte personnel",
    invoices: "Factures",
    cabinet_billing_desc: "Consultez et téléchargez les factures de votre cabinet.",
    invoice_number: "Numéro de facture",
    issue_date: "Date d'émission",
    no_invoices: "Aucune facture pour le moment.",
    paid: "Payée",
    pending: "En attente",
    failed: "Échouée",
    invoice: {
      number: "N° Facture",
      issue_date: "Date d'émission",
      status: "État",
      total: "Total",
      Total: "Total",
      actions: "Actions",
      Actions: "Actions",
      download_pdf: "Télécharger PDF",
      no_pdf: "Aucun lien"
    },
    add_rendezvous: "Ajouter un rendez-vous",
    rendezvous_list: "Liste des rendez-vous",
    users_list: "Liste des utilisateurs",
    users_list_desc: "Gérez vos utilisateurs ici",
    name: "Nom complet",
    status: "État du compte",
    admin: "Administrateur",
    role: "Rôle",
    created_at: "Date d'inscription",
    updated_at: "Dernière modification",
    last_activity: "Dernière activité",
    cabinet_admin: "Administrateur du cabinet",
    approval_status: "Statut de la demande",
    approval_pending: "En attente",
    approval_approved: "Approuvé",
    approval_rejected: "Rejeté",
    admin_phone: "Tél. Admin",
    admin_email: "Email Admin",
    status_active: "Actif",
    status_locked: "Verrouillé",
    table_load_error: "Erreur de chargement des données. Veuillez réessayer plus tard.",
    no_results: "Aucun résultat.",
    role_name: ["Inconnu"],
    search_by_name: "Rechercher par nom...",
    search_by_case_id: "Rechercher par N° de dossier",
    year: "Année",
    number: "Numéro",
    code: "Code",
    search_by_case_name: "Rechercher par nom de dossier",
    pagination: "Page {{current_page}} sur {{total_pages}}",
    rows_per_page: "Lignes par page",
    add_user: "Ajouter un utilisateur",
    go_first_page: "Aller à la première page",
    go_last_page: "Aller à la dernière page",
    go_next_page: "Aller à la page suivante",
    go_prev_page: "Aller à la page précédente",
    selected: "{{selected}} sélectionné(s)",
    clear_filters: "Effacer les filtres",
    apply_filters: "Appliquer les filtres",
    filters: "Filtres",
    user_add_info: "Ajoutez un nouvel utilisateur ici",
    user_action: "Cliquez sur Enregistrer une fois terminé.",
    save: "Enregistrer",
    edit_user: "Modifier l'utilisateur",
    select_role: "Sélectionner un rôle",
    select_account_status: "Sélectionner l'état du compte",
    name_placeholder: "Mohammed Ali",
    title: "Titre",
    name_required: "Le nom complet est requis",
    username_required: "Le nom d'utilisateur doit comporter au moins 4 caractères",
    email_invalid: "E-mail invalide",
    phone_invalid: "Numéro de téléphone invalide",
    invalid_amount: "Le montant doit être supérieur à 0",
    invalid_fee_amount: "Les honoraires doivent être supérieurs ou égaux à 0",
    loading: "Chargement",
    plans: "Forfaits",
    "Plans": "Forfaits",
    subscriptions: "Abonnements",
    "Subscriptions": "Abonnements",
    no_subscriptions: "Aucun abonnement",
    plan: "Forfait",
    price: "Prix",
    public: "Public",
    current_plan: "Forfait actuel",
    plans_mgmt_desc: "Gérer les forfaits d'abonnement de la plateforme.",
    create_plan: "Créer un forfait",
    edit_plan: "Modifier le forfait",
    monthly_price_mad: "Prix mensuel (DH)",
    yearly_price_mad: "Prix annuel (DH)",
    monthly_token_cap: "Limite mensuelle de messages",
    audio_access_enabled: "Accès audio activé",
    max_storage_mb: "Stockage max (MB)",
    extras: "Fonctionnalités supplémentaires",
    no_extras: "Aucune fonctionnalité supplémentaire",
    recommended: "Recommandé",
    delete_plan_confirm: "Voulez-vous supprimer le forfait \"{{name}}\" ?",
    failed_to_load_plans: "Échec du chargement des forfaits",
    failed_to_create_plan: "Échec de la création du forfait",
    failed_to_update_plan: "Échec de la mise à jour du forfait",
    failed_to_delete_plan: "Échec de la suppression du forfait",
    cabinet_plans_desc: "Choisissez un forfait d'abonnement pour votre cabinet.",
    already_subscribed: "Vous avez un abonnement actif",
    no_plans_available: "Aucun forfait disponible",
    free: "Gratuit",
    trial_days: "Jours d'essai",
    or: "ou",
    storage: "Stockage",
    max_users: "Utilisateurs max",
    max_cases: "Dossiers max",
    max_active_cases: "Dossiers actifs max",
    ai_assistance: "Assistance IA",
    audio_access: "Accès audio",
    included: "Inclus",
    not_included: "Non inclus",
    monthly_ai_tokens: "Messages IA mensuels",
    unlimited: "Illimité",
    choose_plan: "Choisir ce forfait",
    confirm_choose_plan: "Confirmer le choix du forfait et la méthode de paiement.",
    user_added: "Utilisateur {{user}} ajouté",
    user_updated: "Utilisateur {{user}} mis à jour",
    user_made_admin: "{{user}} a été nommé administrateur",
    user_admin_revoked: "Droits d'administrateur révoqués pour {{user}}",
    idnumber: "Numéro d'identité",
    idnumber_placeholder: "C123456789",
    idnumber_invalid: "Numéro d'identité invalide",
    client_added: "Client {{client}} ajouté",
    client_updated: "Client {{client}} mis à jour",
    username_taken: "Nom d'utilisateur déjà pris",
    role_needed: "Le rôle est requis",
    status_needed: "L'état du compte est requis",
    delete: "Supprimer",
    edit: "Modifier",
    make_admin: "Nommer administrateur",
    revoke_admin: "Révoquer administrateur",
    delete_confirm: "Êtes-vous sûr de vouloir supprimer {{user}} ?",
    delete_warn: "Cette opération est irréversible.",
    warning: "Attention",
    ai_response: "Réponse de l'IA",
    appointment: "Rendez-vous",
    archive_error: "Une erreur est survenue lors de l'archivage",
    delete_user: "Supprimer l'utilisateur",
    cancel: "Annuler",
    reset_pass: "Réinitialiser m.d.p",
    remove: "Retirer",
    user_removed: "Utilisateur {{user}} retiré",
    client_removed: "Client {{client}} retiré",
    reset_pass_user: "Réinitialiser le mot de passe utilisateur",
    reset_pass_confirm:
      "Êtes-vous sûr de vouloir réinitialiser le mot de passe de l'utilisateur {{user}} ?",
    reseted_pass: "Un nouveau mot de passe a été généré pour {{user}}",
    new_pass: "Nouveau mot de passe",
    new_pass_notice:
      "N'oubliez pas de communiquer le nouveau mot de passe à l'utilisateur {{user}}.",
    confirm: "Confirmer",
    make_admin_confirm_title: "Confirmer la nomination administrateur",
    make_admin_confirm_desc: "Êtes-vous sûr de vouloir nommer {{user}} administrateur ?",
    revoke_admin_confirm_title: "Confirmer la révocation administrateur",
    revoke_admin_confirm_desc: "Êtes-vous sûr de vouloir révoquer les droits d'administrateur de {{user}} ?",
    clip: "Copier dans le presse-papiers",
    clients_list: "Liste des clients",
    clients_list_desc: "Gérez vos clients ici",
    phone: "Téléphone",
    added_by: "Ajouté par",
    search_country: "Rechercher un pays...",
    client_name_taken: "Nom du client déjà pris",
    client_name_required: "Le nom du client doit comporter plus de 4 caractères",
    client_type: "Type de client",
    client_name: "Nom du client",
    add_client: "Ajouter un client",
    edit_client: "Modifier le client",
    delete_client: "Supprimer le client",
    open_menu: "Ouvrir le menu",
    close: "Fermer",
    case_id: "ID Dossier",
    assigned_to: "Responsable",
    case_name_required: "Le nom du dossier est requis",
    case_name_taken: "Le nom du dossier est déjà pris",
    invalid_year: "Année invalide",
    invalid_code: "Code de dossier invalide",
    invalid_number: "Numéro de dossier invalide",
    case_added: "Dossier {{case}} ajouté",
    case_updated: "Dossier {{case}} mis à jour",
    case_removed: "Dossier {{case}} supprimé",
    edit_case: "Modifier le dossier",
    add_case: "Ajouter un dossier",
    create_case: "Créer un dossier",
    create_case_file: "Créer le fichier du dossier",
    create_case_file_from_relation: "Créer un nouveau dossier à partir de cette liaison",
    case_placeholder: "Nom de l'affaire",
    case_type_name: ["Inconnu"],
    case_type: "Type de dossier",
    case_name: "Nom de l'affaire",
    case_not_found: "Dossier introuvable",
    case_list: "Liste des dossiers",
    case_list_desc: "Gérez vos dossiers ici",
    invalid_case_id: "Numéro de dossier invalide",
    invalid_full_case_id: "Numéro complet du dossier invalide",
    visibility: "Confidentialité du dossier",
    select_visibility: "Choisir le niveau de confidentialité",
    visibility_not_set: "Non défini",
    visibility_public: "Public",
    visibility_partial: "Partiel",
    visibility_private: "Privé",
    limited_access_case: "Vous avez un accès partiel à ce dossier",
    // Calendar view labels
    today: "Aujourd'hui",
    month: "Mois",
    week: "Semaine",
    day: "Jour",
    monthView: "Vue Mois",
    weekView: "Vue Semaine",
    dayView: "Vue Jour",

    // Lawyer filter combobox
    avocat: "Avocat",
    allLawyers: "Tous les avocats",
    searchLawyer: "Rechercher...",
    noResults: "Aucun résultat",

    // Loading and empty states
    clickToAddAppointment: "Cliquez pour ajouter un rendez-vous",
    noAppointments:
      'Aucun rendez-vous ce jour. Cliquez sur "Ajouter un rendez-vous" pour en créer un.',
    // Action buttons
    addNewAppointment: "Ajouter un nouveau rendez-vous",
    createNewAppointment: "Créer un nouveau rendez-vous",
    createAppointmentFor: "Créer un rendez-vous pour",
    create: "Créer",
    editAppointment: "Modifier le rendez-vous",
    editAppointmentFor: "Modifier le rendez-vous pour",
    postpone: "Reporter",
    postponeAppointment: "Reporter le rendez-vous",
    postponeAppointmentFor: "Reporter le rendez-vous pour",
    postponeDate: "Date de report",
    appointmentPostponed: "Rendez-vous reporté avec succès",
    postponedFromMsg: "Ce rendez-vous a été reporté depuis le {{date}}",
    meetingPostponed: "Ce rendez-vous est reporté",
    meetingPostponedWarning: "Ce rendez-vous a été reporté ! L'heure de la réunion a changé.",
    meetingPostponedToNewTime: "Ce rendez-vous a été reporté à un nouvel horaire",
    update: "Mettre à jour",
    // Form labels
    description: "Description",
    desc_desc: "Entrez une description optionnelle",
    caseNumber: "Numéro de dossier",
    casePrefix: "Dossier",
    procedureType: "Type de procédure",
    startTime: "Heure de début",
    endTime: "Heure de fin",
    system: "Système",
    // Location options
    location: "Lieu de la réunion",
    meetingType: "Type de réunion",
    court: "Au tribunal",
    office: "Au bureau",
    courtHearing: "Audience au tribunal",
    courtMeetingHelp: "Liée obligatoirement à un dossier",
    officeMeeting: "Rendez-vous au cabinet",
    officeMeetingHelp: "Consultation ou réunion",
    appointmentSchedule: "Horaire et durée",
    duration: "Durée",
    selectTime: "Choisir l'heure",
    hours: "Heures",
    minutes: "Minutes",
    now: "Maintenant",
    caseHelpCourt: "Requis pour les audiences",
    caseHelpOffice: "Optionnel pour les rendez-vous",
    locationRequired: "Le lieu de la réunion doit être précisé",
    meetingInProgress: "Réunion en cours",
    pick_a_date: "Choisissez une date",
    // Procedure types with proper typing
    procedureTypes: {
      initial: "Première audience",
      review: "Mise en état / Examen",
      hearing: "Audience",
      judgment: "Prononcé du jugement",
      appeal: "Appel",
      consultation: "Consultation",
      other: "Autre",
    },
    selectProcedureType: "Sélectionner le type de procédure",
    // Validation messages
    descriptionRequired: "La description est requise",
    caseRequired: "Le dossier est requis",
    procedureRequired: "Le type de procédure est requis",
    attorneyRequired: "L'avocat responsable doit être sélectionné",
    startTimeRequired: "L'heure de début est requise",
    endTimeRequired: "L'heure de fin est requise",
    endTimeAfterStart: "L'heure de fin doit être après l'heure de début",
    // Success messages
    appointmentCreated: "Rendez-vous créé",
    appointmentUpdated: "Rendez-vous mis à jour",
    appointmentDeleted: "Rendez-vous supprimé",
    // Error messages
    error: "Erreur",
    createError: "Échec de la création du rendez-vous. Veuillez réessayer.",
    updateError: "Une erreur est survenue lors de la mise à jour du rendez-vous",
    deleteError: "Échec de la suppression du rendez-vous. Veuillez réessayer.",
    fetchError: "Échec du chargement des données de l'agenda. Veuillez réessayer.",
    saveError: "Une erreur est survenue lors de l'enregistrement. Veuillez réessayer.",
    appointmentError: "Erreur de rendez-vous :",
    invalidTime: "Heure invalide",
    dateParseError: "Erreur d'analyse de la date de réunion :",
    meetingDateParseError: "Erreur d'analyse des dates de réunion :",
    dateFormatError: "Erreur de format de date :",
    notAvailable: "Non disponible",
    select_date: "Sélectionner une date",
    invalidDate: "Date invalide",
    confirmDelete: "Confirmer la suppression",
    areYouSureYouWantToDeleteThisEvent: "Êtes-vous sûr de vouloir supprimer ce rendez-vous ?",
    // Week days
    monday: "Lundi",
    tuesday: "Mardi",
    wednesday: "Mercredi",
    thursday: "Jeudi",
    friday: "Vendredi",
    saturday: "Samedi",
    sunday: "Dimanche",
    // Abbreviated week days for mobile
    mon_short: "Lun",
    tue_short: "Mar",
    wed_short: "Mer",
    thu_short: "Jeu",
    fri_short: "Ven",
    sat_short: "Sam",
    sun_short: "Dim",
    more: "plus",

    // Event details
    event_details_description: "Informations détaillées sur l'événement.",
    case: "Dossier",
    select_case: "Sélectionner le dossier",
    select: "Sélectionner",
    procedureLabel: "Type de procédure",
    case_code: "Code dossier",
    case_number: "Numéro dossier",
    case_year: "Année",
    case_number_full: "Numéro complet du dossier",
    select_client: "Sélectionner le client",
    no_more_results: "Aucun autre résultat",
    select_case_type: "Sélectionner le type",
    tribunal: "Tribunal",
    select_case_location: "Sélectionner le tribunal",
    select_user: "Sélectionner l'utilisateur assigné",
    client_needed: "Le client est requis",
    assigned_to_needed: "L'utilisateur assigné est requis",
    delete_case: "Supprimer le dossier",
    case_status: "État du dossier",
    "case_status.active": "En cours",
    "case_status.audience": "Audience",
    "case_status.delibere": "En délibéré",
    "case_status.suspended": "Suspendu",
    "case_status.closed": "Jugé",
    "case_status.archived": "Archivé",
    "case_status.incomplete": "Incomplet",
    active: "Actif",
    is_active: "Actif",
    archived: "Archivé",
    archive: "Archiver",
    unarchive: "Désarchiver",
    archive_case: "Archiver le dossier",
    unarchive_case: "Désarchiver le dossier",
    confirm_archive_case: "Êtes-vous sûr de vouloir archiver le dossier {{case}} ?",
    confirm_unarchive_case: "Êtes-vous sûr de vouloir désarchiver le dossier {{case}} ?",
    archived_at: "Date d'archivage",
    case_archived: "Le dossier {{case}} a été archivé",
    case_unarchived: "Le dossier {{case}} a été désarchivé",
    
    // Case page translations
    overview: "Aperçu",
    files: "Pièces jointes",
    comments: "Commentaires",
    payments: "Honoraires",
    "Payments": "Honoraires",
    case_payments: "Honoraires du dossier",
    payments_desc: "Historique des honoraires et frais liés à ce dossier",
    add_payment: "Ajouter un paiement",
    payment: "Paiement",
    add_payment_desc: "Ajouter un nouveau paiement pour ce dossier",
    payment_amount: "Montant",
    payment_note: "Description",
    payment_date: "Date de paiement",
    payment_note_placeholder: "Description du paiement",
    payment_added: "Paiement ajouté",
    payment_updated: "Paiement mis à jour",
    payment_deleted: "Paiement supprimé",
    edit_payment: "Modifier le paiement",
    edit_payment_desc: "Modifier les détails du paiement pour ce dossier",
    select_deposit_date: "Sélectionner la date de dépôt",
    error_fetching_payments: "Erreur lors de la récupération des paiements",
    error_updating_payment: "Erreur lors de la mise à jour du paiement",
    error_adding_payment: "Erreur lors de l'ajout du paiement",
    error_deleting_payment: "Erreur lors de la suppression du paiement",
    total_payments: "Total des paiements",
    payments_list_desc: "Gérer et vérifier les honoraires du cabinet.",
    payment_details: "Détails du paiement",
    method: "Méthode",
    amount: "Montant",
    remaining_amount: "Montant restant",
    total: "Total",
    delete_payment_confirmation_title: "Confirmer la suppression du paiement",
    delete_payment_confirmation_message: "Êtes-vous sûr de vouloir supprimer ce paiement ? Cette action est irréversible.",
    amount_required: "Le montant est requis",
    case_info: "Infos du dossier",
    case_info_desc: "Informations générales sur le dossier",
    tribunal_location: "Tribunal",
    last_update: "Dernière mise à jour",
    recent_files: "Fichiers récents",
    recent_comments: "Commentaires récents",
    view_all: "Voir tout",
    case_files: "Fichiers du dossier",
    case_comments: "Commentaires du dossier",
    comments_desc: "Discussions et notes liées à ce dossier",
    error_loading_case_data: "Erreur de chargement des données du dossier",
    error_loading_files: "Erreur de chargement des fichiers",
    error_loading_comments: "Erreur de chargement des commentaires",
    view: "Voir",
    view_failed: "Échec de l'affichage du fichier",
    unknown: "Inconnu",
    unassigned: "Non assigné",
    coming_soon: "Bientôt",
    edit_case_not_implemented: "La fonction de modification du dossier est en développement",
    files_desc: "Toutes les pièces jointes attachées à ce dossier",
    // File viewer translations
    zoom_in: "Zoom avant",
    zoom_out: "Zoom arrière",
    reset_view: "Réinitialiser la vue",
    drag_to_move: "Glisser pour déplacer",
    unsupported_file_type: "Type de fichier non supporté",
    no_file_to_display: "Aucun fichier à afficher",
    file_uploaded: "Fichier téléchargé",
    download: "Télécharger",
    file_deleted: "Fichier supprimé",
    delete_failed: "Échec de la suppression",
    download_failed: "Échec du téléchargement",
    upload_file: "Téléverser un fichier",
    uploaded_by: "Téléversé par",
    add_comment: "Ajouter un commentaire",
    comment_placeholder: "Écrivez votre commentaire ici...",
    post_comment: "Publier",
    edit_comment: "Modifier le commentaire",
    edit_comment_desc: "Modifier le contenu du commentaire",
    comment_added: "Commentaire ajouté",
    comment_deleted: "Commentaire supprimé",
    proceedings_table_description: "Voir et suivre toutes les procédures liées au dossier.",
    
    // Tribunal Decision
    tribunal_decision: "Décision du tribunal",
    tribunal_decision_desc: "Décisions du tribunal liées à ce dossier",
    upload_decision: "Ajouter le jugement ou la décision",
    replace_decision: "Remplacer la décision du tribunal",
    no_decision_files: "Aucune décision de tribunal jointe",
    delete_decision: "Supprimer la décision",
    decision_file_deleted: "Décision du tribunal supprimée avec succès",
    decision_file_replaced: "Décision du tribunal remplacée avec succès",
    confirm_delete_decision_title: "Confirmer la suppression de la décision",
    confirm_delete_decision_desc: "Êtes-vous sûr de vouloir supprimer la décision du tribunal ? Cette action est irréversible.",

    logout: "Déconnexion",
    logout_successful: "Déconnexion réussie",
    logout_failed: "Échec de la déconnexion",
    confirm_logout_title: "Confirmer la déconnexion",
    confirm_logout_desc: "Êtes-vous sûr de vouloir vous déconnecter ?",

    // Profile Page Translations
    lawyer_profile_beta: "Mon Profil Public (Beta)",
    profilePageTitle: "Profil",
    accountInfoCardTitle: "Infos du compte",
    accountInfoCardDescription: "Informations de votre compte personnel",
    adminBadgeText: "Admin",
    nameLabel: "Nom",
    usernameLabel: "Nom d'utilisateur",
    emailLabel: "E-mail",
    notSet: "Non défini",
    addEmailWarning: "Veuillez ajouter votre e-mail",
    creationDateLabel: "Date de création",
    adminAccountStatus: "Compte administrateur avec accès complet",
    userAccountStatus: "Compte utilisateur standard",
    changePasswordButton: "Changer le mot de passe",
    accountSecurityCardTitle: "Sécurité du compte",
    editButton: "Modifier",
    loadingUserData: "Chargement des données utilisateur...",

    // User page
    totalAssignedCases: "Total des dossiers assignés",
    assignedCases: "Dossiers assignés",
    assignedCasesDescription: "Voir tous les dossiers assignés à cet utilisateur",
    noCasesAssigned: "Aucun dossier assigné à cet utilisateur",
    userInfoCardTitle: "Informations utilisateur",
    userInfoCardDescription: "Informations personnelles de l'utilisateur",
    allCases: "Total des dossiers",
    ongoingCases: "Dossiers en cours",
    completedCases: "Dossiers terminés",
    scheduledMeetings: "Rendez-vous à venir",
    // Edit Profile Dialog Translations
    edit_profile: "Modifier les informations personnelles",
    edit_profile_description: "Mettez à jour vos informations personnelles",
    profile_updated_successfully: "Informations personnelles mises à jour avec succès",
    profile_update_failed: "Échec de la mise à jour des informations personnelles",
    saving: "Enregistrement...",
    
    // User Page - Coming Rendezvous
    comingRendezvous: "Rendez-vous à venir",
    comingRendezvousDescription: "Voir tous les rendez-vous à venir pour cet utilisateur",
    noComingRendezvous: "Aucun rendez-vous à venir pour cet utilisateur",

    // Table Actions
    minimize: "Réduire",
    maximize: "Agrandir",

    // Change Password Dialog Translations
    change_password: "Changer le mot de passe",
    change_password_description: "Entrez le mot de passe actuel et le nouveau mot de passe",
    current_password: "Mot de passe actuel",
    current_password_placeholder: "Entrez votre mot de passe actuel",
    current_password_required: "Le mot de passe actuel est requis",
    new_password: "Nouveau mot de passe",
    new_password_placeholder: "Entrez le nouveau mot de passe",
    new_password_too_short: "Le nouveau mot de passe doit comporter au moins 8 caractères",
    confirm_password: "Confirmer le mot de passe",
    confirm_password_placeholder: "Entrez à nouveau le nouveau mot de passe",
    confirm_password_required: "La confirmation du mot de passe est requise",
    password_updated_successfully: "Mot de passe mis à jour avec succès",
    password_update_failed: "Échec de la mise à jour du mot de passe",

    // Command Menu
    type_command_or_search: "Tapez une commande ou cherchez...",
    no_results_found: "Aucun résultat trouvé.",
    theme: "Thème",
    light: "Clair",
    dark: "Sombre",
    toggle_theme: "Changer le thème",
    // Data Table Column Header
    asc: "Ascendant",
    desc: "Descendant",
    hide: "Masquer",
    filter: "Filtrer",
    Filter: "Filtrer",
    toggleColumns: "Colonnes",
    toggle_columns: "Basculer les colonnes",
    "Toggle Columns": "Basculer les colonnes",
    
    search: "Rechercher",
    service_fee: "Montant des honoraires",
    service_fee_desc: "Montant des honoraires pour ce dossier",
    service_fee_placeholder: "Entrez le montant",
    fee_type: "Type d'honoraires",
    select_fee_type: "Sélectionnez le type d'honoraires",
    fee_type_fixed: "Montant fixe",
    fee_type_percentage: "Pourcentage",
    fee_percentage: "Pourcentage des honoraires ",
    fee_percentage_placeholder: "Entrez le pourcentage",
    fee_reference_amount: "Montant de référence",
    fee_reference_amount_placeholder: "Entrez le montant de référence pour le calcul",
    fee_reference_amount_required: "Le montant de référence est requis pour les honoraires en pourcentage",
    calculated_fee: "Honoraires calculés",
    payment_currency: "DH",

    // Cabinet settings translations
    cabinet_settings: "Paramètres du cabinet",
    cabinet_settings_desc: "Configurer les paramètres du cabinet",
    "cabinet.settings.plan_usage": "Forfait et utilisation",
    "cabinet.plan": "Forfait",
    "cabinet.month_tokens_used": "Jetons utilisés (mois)",
    "cabinet.users": "Utilisateurs",
    "cabinet.cases": "Dossiers",
    "cabinet.active_cases": "Dossiers actifs",
    "cabinet.storage": "Stockage",
    "cabinet.month_storage_uploaded": "Espace utilisé (mois)",
    "cabinet.month_storage_deleted": "Espace libéré (mois)",
    "cabinet.monthly_analytics": "Analyses mensuelles",
    "cabinet.show_monthly_details": "Afficher les détails mensuels",
    "cabinet.hide_monthly_details": "Masquer les détails mensuels",
    "cabinet.billing_invoices": "Facturation et factures",
    "cabinet.case_types": "Types de dossiers",
    "cabinet.roles": "Rôles",
    click_to_mark_read: "Cliquer pour marquer comme lu",
    no_monthly_data: "Aucune donnée mensuelle",
    no_data: "Aucune donnée",
    case_types_management: "Gestion des types de dossiers",
    case_types_management_desc: "Gérer les types de dossiers disponibles dans le cabinet",
    add_case_type: "Ajouter un type de dossier",
    current_case_types: "Types de dossiers actuels",
    loading_case_types: "Chargement des types de dossiers...",
    no_case_types: "Aucun type de dossier configuré",
    case_type_added_to_cabinet: "Type de dossier ajouté au cabinet",
    case_type_removed_from_cabinet: "Type de dossier retiré du cabinet",
    roles_management: "Gestion des rôles",
    roles_management_desc: "Gérer les rôles disponibles dans le cabinet",

    permission_actions: {
      READ: "Lecture",
      CREATE: "Création",
      UPDATE: "Modification",
      DELETE: "Suppression",
      MANAGE: "Gérer",
      USE: "Utilisation",
      ARCHIVE: "Archivage",
      ASSIGN: "Affectation",
      EXPORT: "Exportation",
      MERGE: "Fusion"
    },
    roles: {
      title: "Gestion des rôles",
      description: "Gérer les rôles et les permissions des utilisateurs.",
      info: "Les rôles définissent ce que les utilisateurs peuvent faire dans l'application.",
      createRole: "Créer un rôle",
      noRoles: "Aucun rôle trouvé",
      actions: "Actions",
      categories: {
        user: "Utilisateurs",
        role: "Rôles",
        auth: "Authentification",
        api: "API",
        cases: "Dossiers",
        casedecisionfile: "Décisions de justice",
        casedeposit: "Dépôts de dossier",
        rendezvous: "Rendez-vous",
        templaterequest: "Demandes de modèles",
        todo: "Tâches",
        client: "Clients",
        documenttemplate: "Modèles de documents",
        generateddocument: "Documents générés",
        caserelation: "Relations de dossier",
        case: "Affaire",
        cabinet: "Cabinet",
        cabinetproceeding: "Procédures du cabinet",
        casefile: "Dossiers de l'affaire",
        casejurisprudence: "Jurisprudence de l'affaire",
        casenote: "Notes de l'affaire",
        caseparty: "Parties de l'affaire",
        caseproceeding: "Procédures de l'affaire",
        caseproceedingpersonaldecision: "Décisions personnelles de procédure",
        lawyerprofile: "Profil public de l'avocat"
      },
      dialog: {
        create: {
          title: "Créer un rôle",
          description: "Créez un nouveau rôle avec des permissions personnalisées. Le nom du rôle doit être en majuscules."
        },
        roleName: "Nom du rôle",
        roleNamePlaceholder: "ex: MANAGER",
        description: "Description",
        descriptionPlaceholder: "Description du rôle et de ses permissions",
        permissions: "Permissions",
        noPermissions: "Aucune permission disponible",
        readonly: "Ce rôle ne peut pas être modifié.",
        edit: {
          title: "Modifier le rôle",
          description: "Mettre à jour les informations du rôle. Les noms de rôle doivent être en majuscules.",
          save: "Mettre à jour le rôle"
        },
        delete: {
          title: "Supprimer le rôle",
          confirmText: "Êtes-vous sûr de vouloir supprimer le rôle {{roleName}} ?",
          warningText: "Cette action supprimera définitivement ce rôle et toutes ses permissions associées du système. Cette action est irréversible.",
          riskText: "Cette opération ne peut pas être annulée."
        }
      },

      permissions: {
        api: {
            view_case: "Peut voir les dossiers",
            add_case: "Peut ajouter des dossiers",
            change_case: "Peut modifier des dossiers",
            delete_case: "Peut supprimer des dossiers",
            export_case: "Peut exporter les données des dossiers",
            add_casedecisionfile: "Peut ajouter un fichier de décision",
            change_casedecisionfile: "Peut modifier un fichier de décision",
            delete_casedecisionfile: "Peut supprimer un fichier de décision",
            view_casedecisionfile: "Peut voir un fichier de décision",
            view_casedeposit: "Peut voir les dépôts",
            add_casedeposit: "Peut ajouter des dépôts",
            change_casedeposit: "Peut modifier des dépôts",
            delete_casedeposit: "Peut supprimer des dépôts",
            view_rendezvous: "Peut voir les rendez-vous",
            add_rendezvous: "Peut ajouter des rendez-vous",
            change_rendezvous: "Peut modifier des rendez-vous",
            delete_rendezvous: "Peut supprimer des rendez-vous",
            view_role: "Peut voir les rôles",
            add_role: "Peut ajouter des rôles",
            change_role: "Peut modifier des rôles",
            delete_role: "Peut supprimer des rôles",
            view_templaterequest: "Peut voir les demandes de modèles",
            add_templaterequest: "Peut ajouter des demandes de modèles",
            change_templaterequest: "Peut modifier des demandes de modèles",
            delete_templaterequest: "Peut supprimer des demandes de modèles",
            view_todo: "Peut voir les tâches",
            add_todo: "Peut ajouter des tâches",
            change_todo: "Peut modifier des tâches",
            delete_todo: "Peut supprimer des tâches",
            view_user: "Peut voir les utilisateurs",
            add_user: "Peut ajouter des utilisateurs",
            change_user: "Peut modifier des utilisateurs",
            delete_user: "Peut supprimer des utilisateurs",
            manage_roles: "Peut créer et gérer des rôles personnalisés",
            view_user_activity: "Peut voir les journaux d'activité des utilisateurs",
            view_client: "Peut voir les clients",
            add_client: "Peut ajouter des clients",
            change_client: "Peut modifier des clients",
            delete_client: "Peut supprimer des clients",
            export_client: "Peut exporter les données des clients",
            merge_client: "Peut fusionner les clients en double",
            view_documenttemplate: "Peut voir les modèles de documents",
            add_documenttemplate: "Peut ajouter des modèles de documents",
            change_documenttemplate: "Peut modifier des modèles de documents",
            delete_documenttemplate: "Peut supprimer des modèles de documents",
            view_generateddocument: "Peut voir les documents générés",
            add_generateddocument: "Peut ajouter des documents générés",
            change_generateddocument: "Peut modifier des documents générés",
            delete_generateddocument: "Peut supprimer des documents générés",
            view_caserelation: "Peut voir les relations de dossier",
            add_caserelation: "Peut ajouter des relations de dossier",
            change_caserelation: "Peut modifier des relations de dossier",
            delete_caserelation: "Peut supprimer des relations de dossier",
            use_chatbot: "Peut utiliser le chatbot",
            change_cabinet: "Peut modifier le cabinet",
            use_chatbot_audio: "Peut utiliser l'audio avec le chatbot",
            view_cabinet: "Peut voir le cabinet",
            view_cabinetproceeding: "Peut voir les procédures du cabinet",
            add_cabinetproceeding: "Peut ajouter des procédures du cabinet",
            change_cabinetproceeding: "Peut modifier des procédures du cabinet",
            delete_cabinetproceeding: "Peut supprimer des procédures du cabinet",
            archive_case: "Peut archiver/désarchiver les dossiers",
            assign_case: "Peut assigner des dossiers aux utilisateurs",
            change_case_visibility: "Peut modifier la visibilité du dossier",
            delete_own_case: "Peut supprimer ses propres dossiers",
            view_casefile: "Peut voir les dossiers de l'affaire",
            add_casefile: "Peut ajouter des dossiers à l'affaire",
            change_casefile: "Peut modifier les dossiers de l'affaire",
            delete_casefile: "Peut supprimer les dossiers de l'affaire",
            view_casejurisprudence: "Peut voir la jurisprudence de l'affaire",
            add_casejurisprudence: "Peut ajouter de la jurisprudence à l'affaire",
            change_casejurisprudence: "Peut modifier la jurisprudence de l'affaire",
            delete_casejurisprudence: "Peut supprimer la jurisprudence de l'affaire",
            view_casenote: "Peut voir les notes de l'affaire",
            add_casenote: "Peut ajouter des notes à l'affaire",
            change_casenote: "Peut modifier les notes de l'affaire",
            delete_casenote: "Peut supprimer les notes de l'affaire",
            view_caseparty: "Peut voir les parties de l'affaire",
            add_caseparty: "Peut ajouter des parties à l'affaire",
            change_caseparty: "Peut modifier les parties de l'affaire",
            delete_caseparty: "Peut supprimer les parties de l'affaire",
            view_caseproceeding: "Peut voir les procédures de l'affaire",
            add_caseproceeding: "Peut ajouter des procédures à l'affaire",
            change_caseproceeding: "Peut modifier les procédures de l'affaire",
            delete_caseproceeding: "Peut supprimer les procédures de l'affaire",
            view_caseproceedingpersonaldecision: "Peut voir les décisions personnelles de procédure",
            add_caseproceedingpersonaldecision: "Peut ajouter des décisions personnelles de procédure",
            change_caseproceedingpersonaldecision: "Peut modifier les décisions personnelles de procédure",
            delete_caseproceedingpersonaldecision: "Peut supprimer les décisions personnelles de procédure",
            view_lawyerprofile: "Peut voir le profil public de l'avocat",
            add_lawyerprofile: "Peut ajouter un profil public d'avocat",
            change_lawyerprofile: "Peut modifier le profil public de l'avocat",
            delete_lawyerprofile: "Peut supprimer le profil public de l'avocat"
         }
      },

    },
    add_role: "Ajouter un rôle",
    current_roles: "Rôles actuels",
    loading_roles: "Chargement des rôles...",
    no_roles: "Aucun rôle configuré",
    role_added_to_cabinet: "Rôle ajouté au cabinet",
    role_removed_from_cabinet: "Rôle retiré du cabinet",
    adding: "Ajout en cours...",
    add: "Ajouter",
    
    // Session expiration messages
    session_expired: "Session expirée",
    session_expired_desc: "Vous avez été déconnecté. Veuillez vous reconnecter.",
    payment_required: "Le compte nécessite un abonnement actif",
    payment_required_desc: "Veuillez choisir un forfait pour continuer.",
    cabinet_subscriptions_desc: "Visualisez et gérez les abonnements de votre cabinet.",
    price_per_month: "{{amount}} {{currency}}/mois",
    price_per_year: "{{amount}} {{currency}}/an",
    save_percent: "Économisez {{pct}}%",
    no_period_info: "Aucune information sur la période actuelle",
    trial_end: "Fin de l'essai",

    // Cabinet Plans Dialog
    confirm_subscription: "Confirmer l'abonnement",
    subscriptions_list_desc: "Suivi des abonnements des cabinets.",
    subscription_details: "Détails de l'abonnement",
    current_period_start: "Début de période",
    current_period_end: "Fin de période",
    cancel_at_period_end: "Annuler à la fin de la période",
    payment_method: "Méthode de paiement",
    wire_transfer: "Virement bancaire",
    bank_transfer: "Virement bancaire",
    payment_pending: "Paiement en attente",
    wire_instructions_desc: "Votre abonnement sera activé dès réception et validation de votre virement bancaire. Utilisez les coordonnées ci-dessous.",
    wire_beneficiary: "Bénéficiaire",
    wire_bank: "Banque",
    wire_rib: "RIB",
    wire_iban: "IBAN",
    wire_swift: "SWIFT",
    days: "jours",
    void: "Annulée",
    monthly: "mois",
    yearly: "an",
    wire_instructions_error: "Impossible de charger les coordonnées bancaires.",
    subscription_past_due: "Paiement de l'abonnement en retard",
    subscription_past_due_desc: "Votre abonnement a expiré. Renouvelez-le maintenant pour conserver l'accès à votre cabinet.",
    subscription_expiring_soon: "Abonnement bientôt expiré",
    subscription_expiring_soon_desc: "Votre abonnement se termine dans {{days}} jour(s).",
    payment_awaiting_validation: "Paiement en attente de validation",
    payment_awaiting_validation_desc: "Votre abonnement sera activé dès réception et validation de votre virement.",
    manage_subscription: "Gérer l'abonnement",
    subscription_status_active: "Actif",
    subscription_status_trialing: "Période d'essai",
    subscription_status_free: "Gratuit",
    subscription_status_pending: "En attente",
    subscription_status_past_due: "En retard",
    subscription_status_paused: "En pause",
    subscription_status_canceled: "Annulé",
    upcoming_payment: "Prochain paiement",
    due: "Échéance",
    renew_now: "Renouveler maintenant",
    renew_failed: "Impossible de demander le renouvellement",
    view_payment_instructions: "Coordonnées de paiement",
    subscription_history: "Historique",
    subscriptions_load_error: "Impossible de charger les abonnements",
    cancel_at_period_end_notice: "Cet abonnement ne sera pas renouvelé après la période en cours.",
    awaiting_payment: "En attente de paiement",
    payment_gateway: "Passerelle de paiement",
    credit_card: "Carte de crédit",
    jeune: "Jeune",

    cabinet_proceedings: "Procédures du cabinet",
    cabinet_proceedings_desc: "Journal de toutes les procédures internes liées à ce dossier.",
    add_proceeding: "Ajouter une procédure",
    add_proceeding_desc: "Ajouter une nouvelle procédure pour ce dossier.",
    edit_proceeding: "Modifier la procédure",
    edit_proceeding_desc: "Modifier les détails de la procédure pour ce dossier.",
    delete_proceeding_confirmation_title: "Confirmer la suppression de la procédure",
    action: "Action",
    action_required: "L'action est requise",
    action_placeholder: "Ex: Revue de documents, appel au client...",
    date: "Date",
    time: "Heure",
    hour: "Heure",
    minute: "Minute",
    error_fetching_proceedings: "Erreur lors de la récupération des procédures",
    error_updating_proceeding: "Erreur lors de la mise à jour de la procédure",
    error_adding_proceeding: "Erreur lors de l'ajout de la procédure",
    error_deleting_proceeding: "Erreur lors de la suppression de la procédure",
    proceeding_added: "Procédure ajoutée",
    proceeding_updated: "Procédure mise à jour",
    proceeding_deleted: "Procédure supprimée",

    // Tribunal Proceedings translations
    tribunal_proceedings: "Procédures judiciaires",
    proceedings_desc: "Contenu des procédures judiciaires",
    proceedings: "Procédures",
    refresh_proceedings: "Actualiser les procédures",
    confirm_refresh_proceedings: "Confirmer l'actualisation",
    confirm_refresh_proceedings_description: "Vous ne pouvez actualiser les procédures qu'une fois par heure.",
    refresh: "Actualiser",
    type: "Type",
    decision: "Décision",
    next_hearing_date: "Date prochaine audience",
    personal_decisions: "Décisions internes",
    personal_decision_updated_successfully: "Décision interne mise à jour avec succès",
    personal_decision_added_successfully: "Décision interne ajoutée avec succès",
    failed_to_save_personal_decision: "Échec de l'enregistrement de la décision interne",
    personal_decision_deleted_successfully: "Décision interne supprimée avec succès",
    failed_to_delete_personal_decision: "Échec de la suppression de la décision interne",
    proceedings_refreshed_successfully: "Procédures actualisées avec succès",
    failed_to_refresh_proceedings: "Échec de l'actualisation des procédures",
    edit_personal_decision: "Modifier la décision interne",
    add_personal_decision: "Ajouter une décision interne",
    update_the_details_of_the_personal_decision: "Mettre à jour les détails de la décision interne.",
    add_a_new_personal_decision_to_this_proceeding: "Ajouter une nouvelle décision interne à cette procédure.",
    enter_decision_details: "Entrez les détails de la décision...",
    add_decision: "Ajouter décision",
    decision_is_required: "La décision est requise",
    confirm_delete_personal_decision: "Confirmer la suppression",
    are_you_sure_you_want_to_delete_this_personal_decision: "Êtes-vous sûr de vouloir supprimer cette décision interne ?",
    this_action_cannot_be_undone: "Cette action est irréversible.",
    delete_personal_decision: "Supprimer",
    error_loading_proceedings: "Erreur de chargement des procédures",

    // Case Relations translations
    case_relations: "Dossiers liés",
    case_relations_desc: "Dossiers liés à cette affaire (Appel, Cassation...)",
    relation_type: "Type de relation",
    jurisdiction: "Juridiction",
    related_case_number: "Numéro dossier lié",
    no_relations: "Aucun dossier lié",
    error_loading_relations: "Erreur de chargement des dossiers liés",

    // Case Hierarchy translations
    case_hierarchy: "Hiérarchie du dossier",
    case_hierarchy_desc: "Afficher les dossiers parents et enfants liés",
    parent_case: "Dossier parent",
    parent_cases: "Dossiers parents",
    child_cases: "Dossiers enfants",
    current_case: "Dossier actuel",
    current: "Actuel",
    no_hierarchy: "Aucun dossier lié dans la hiérarchie",
    error_loading_hierarchy: "Erreur de chargement de la hiérarchie",
    create_related_case: "Créer un dossier lié",
    create_related_case_desc: "Créer un nouveau dossier lié pour le client {{client}}",
    relation_type_required: "Le type de relation est requis",
    continue_to_create: "Continuer la création",
    case_number_required_for_relations: "Le numéro de dossier est requis pour créer des liaisons",
    can_create_related_case: "Vous pouvez créer un dossier lié comme un Appel ou une Cassation",
    appeal: "Appel",
    cassation: "Cassation",
    related: "Dossier lié",
    continuation: "Continuation",
    opposition: "Opposition",
    view_case_details: "Voir les détails du dossier",
    missing_required_data: "Données requises manquantes",

    // Document Templates
    document_templates: "Modèles de documents",
    document_templates_desc: "Modèles prédéfinis pour la génération de PDF",
    manage_document_templates: "Gérer les modèles",
    favorites_only: "Favoris seulement",
    favorite: "Favori",
    mark_favorite: "Ajouter aux favoris",
    unfavorite: "Retirer des favoris",
    no_templates: "Aucun modèle",
    create_template: "Créer un modèle",
    manage_templates: "Gérer les modèles",
    render_pdf: "Générer PDF",
    render_document: "Générer le document",
    render_document_desc: "Remplir les champs pour créer un fichier PDF",
    rendering_document: "Génération du document en cours...",
    rendering: "Génération...",
    document_rendered: "Document généré",
    document_generated: "Document généré",
    document_ready: "Document prêt",
    open_pdf: "Ouvrir PDF",
    form_payload: "Données du formulaire",
    render_success: "Génération réussie",
    render_failed: "Échec de la génération",
    image_preview: "Aperçu image",
    insert_variable: "Insérer variable",
    insert: "Insérer",
    error_loading: "Erreur de chargement",
    open_detail: "Ouvrir les détails",
    template_version: "Version du modèle",

    // Template Authoring
    html: "HTML",
    css: "CSS",
    schema: "Schéma",
    create_new_template_desc: "Créer un nouveau modèle HTML avec styles personnalisés et schéma JSON",
    template_details: "Détails du modèle",
    example_schema: "Exemple de schéma",
    enter_template_title: "Entrez le titre du modèle",
    title_required: "Le titre est requis",
    category: "Catégorie",
    select_category: "Sélectionner une catégorie",
    enter_template_slug: "Ex: contrat-service",
    slug: "Identifiant (Slug)",
    slug_help: "Utilisez uniquement des minuscules et des tirets (ex: contrat-modele)",
    fill_required_fields: "Veuillez remplir tous les champs requis",
    error_creating_template: "Échec de la création du modèle",
    html_help: "Doit commencer par <html lang=\"fr\">. Utilisez {{ }} pour le contenu dynamique.",
    css_help: "Optionnel. Utilisez @page pour les styles d'impression.",
    schema_help: "Définit les champs du formulaire et les règles de validation.",
    // Visual Block Builder
    document_structure: "Structure du document",
    form_fields: "Champs du formulaire",
    form_fields_schema: "Schéma des champs",
    add_block: "Ajouter un bloc",
    no_blocks: "Aucun bloc ajouté. Ajoutez des blocs ci-dessus pour construire le modèle.",
    block_header: "En-tête (Logo + Infos Cabinet)",
    block_parties: "Parties (Client, Adverse)",
    block_case_meta: "Données du dossier",
    block_text: "Bloc de texte",
    block_table: "Tableau de données",
    block_fees: "Frais et Totaux",
    block_signatures: "Signatures",
    block_footer: "Pied de page (Pagination)",
    show_logo: "Afficher le logo",
    show_cabinet_info: "Afficher les infos cabinet",
    alignment: "Alignement",
    center: "Centré",
    left: "Gauche",
    right: "Droite",
    text_content: "Contenu du texte",
    enter_text: "Entrez le texte...",
    select_variable: "Choisir une variable...",
    show_subtotal: "Afficher sous-total",
    show_total: "Afficher total",
    show_tax: "Afficher taxes",
    block_config_coming_soon: "Options de configuration bientôt disponibles...",
    
    // Variable Management
    system_variable: "Variable système",
    custom_variable: "Variable personnalisée",
    variable_not_found: "Variable introuvable",
    create_new_variable: "Créer une nouvelle variable",
    variable_key: "Clé de variable",
    variable_label: "Libellé de variable",
    label_help: "Courte description affichée lors du choix de la variable",
    variable_label_ar: "Libellé en Arabe",
    label_ar_help: "Le libellé qui s'affichera pour les utilisateurs arabophones",
    variable_created: "Variable créée avec succès",
    variable_created_successfully: "Variable créée avec succès",
    error_creating_variable: "Échec de la création de la variable",
    creating_variable: "Création en cours...",
    page_layout: "Mise en page",
    layout: "Disposition",
    select_page_layout: "Choisir la mise en page",
    tip: "Astuce",
    variable_autocomplete_help: "Tapez {{ dans l'éditeur pour ouvrir l'autocomplétion des variables. Choisissez une variable existante ou créez-en une nouvelle.",
    template_content: "Contenu du modèle",
    template_content_desc: "Utilisez l'éditeur de texte enrichi pour composer votre document. Insérez des variables pour personnaliser le contenu.",
    enter_template_content: "Entrez le contenu du modèle",
    variables_management_desc: "Gérer les variables disponibles pour les modèles",
    create_variable: "Créer une variable",
    create_first_variable: "Créez votre première variable pour commencer",
    no_variables_found: "Aucune variable trouvée",
    invalid_key_format: "Format de clé invalide",
    key_format_help: "Format: entité.propriété (ex: client.nom)",
    
    // Template Generation Page
    template_preview: "Aperçu du modèle",
    template_preview_desc: "Prévisualisation du modèle de document",
    preview: "Aperçu",
    fill_document_data: "Remplir les données",
    fill_document_data_desc: "Complétez le formulaire ci-dessous pour générer votre document",
    generate_document_info: "Cliquez sur le bouton pour créer votre document PDF",
    generate_pdf: "Générer PDF",
    generating: "Génération",
    opening_pdf: "Ouverture du PDF dans un nouvel onglet...",
    enter: "Entrer",
    
    // Word Document Import
    template_engine: "Moteur de modèle",
    html_editor: "Éditeur HTML",
    word_document: "Document Word (.docx)",
    html_editor_desc: "Créer un modèle avec l'éditeur visuel",
    word_document_desc: "Téléverser un document Word avec {{variables}}",
    upload_word_document: "Téléverser document Word",
    upload_word_desc: "Téléversez un fichier .docx avec des variables au format {{variable.nom}}",
    select_file: "Sélectionner un fichier",
    change_file: "Changer de fichier",
    validating_document: "Validation du document...",
    validation_passed: "Validation réussie",
    found_variables: "Variables trouvées",
    invalid_variables: "Variables invalides",
    validation_success: "Validation réussie",
    invalid_file_type: "Veuillez choisir un fichier .docx",
    invalid_variables_found: "Variables invalides trouvées",
    validation_error: "Erreur de validation",
    failed_to_validate: "Échec de la validation du document",
    template_content_required: "Veuillez fournir le contenu du modèle",
    word_file_required: "Veuillez téléverser un document Word",
    fix_validation_errors: "Veuillez corriger les erreurs de validation avant d'envoyer",
    creating: "Création...",
    
    // Cabinet Document Template Page Specific
    back_to_templates: "Retour aux modèles",
    document_information: "Informations du document",
    fill_form_to_generate: "Remplissez le formulaire ci-dessous pour générer le document",
    select_case_context: "Choisir le dossier (optionnel)",
    failed_load_case_context: "Échec du chargement du contexte du dossier",
    search_cases: "Rechercher un dossier...",
    template_variables: "Variables du modèle",
    edit_template_variables: "Modifier les variables du modèle",
    generate_document: "Générer le document",
    
    // Template Edit (using existing keys: edit, saving)
    save_changes: "Sauvegarder les modifications",
    template_created: "Modèle créé",
    template_updated: "Modèle mis à jour avec succès",
    template_saved_successfully: "Modèle enregistré avec succès",
    error_updating_template: "Échec de la mise à jour du modèle",
    word_template_edit_info: "Le contenu d'un modèle Word ne peut pas être édité ici. Pour mettre à jour, créez un nouveau modèle en téléversant un nouveau fichier Word.",
    validation_errors: "Erreurs de validation",
    validation_failed: "Échec de la validation",
    valid_variables: "Variables valides",
    version: "Version",
    engine: "Moteur",
    all_categories: "Toutes les catégories",
    confirm_delete: "Confirmer la suppression",
    delete_template_confirmation: "Êtes-vous sûr de vouloir supprimer ce modèle ?",
    action_cannot_be_undone: "Cette action est irréversible.",
    template_deleted_successfully: "Modèle supprimé avec succès",
    error_deleting_template: "Échec de la suppression du modèle",
    template_not_found: "Modèle introuvable",
    
    // Search and Filtering
    search_variables: "Rechercher des variables...",
    search_by_key_label: "Rechercher par clé, libellé ou description",
    search_templates: "Rechercher des modèles...",
    filter_by_source: "Filtrer par source",
    filter_by_type: "Filtrer par type",
    variables_list: "Liste des variables",
    variables: "Variables",
    pdf_preview: "Aperçu PDF",
    available_variables: "Variables disponibles",
    system_variables: "Variables système",
    custom_variables: "Variables personnalisées",
    jino_variables_found: "Aucune variable trouvée",
    loading_variables: "Chargement des variables...",
    
    // Variable Types
    variable_type_string: "Texte",
    variable_type_number: "Nombre",
    variable_type_date: "Date",
    variable_type_boolean: "Oui/Non",
    
    // Pagination and Sorting
    items_per_page: "Éléments par page",
    sort_by: "Trier par",
    page_number: "Numéro de page",

    select_cases_for_report: "Sélectionner les dossiers pour le rapport",
    select_assigned_to: "Sélectionner le responsable",
    added_cases: "Dossiers ajoutés",
    unselect_all: "Tout désélectionner",
    export_as_excel: "Exporter en Excel",
    build_report: "Générer le rapport",
    no_case_selected: "Aucun dossier sélectionné",

    // Super Admin translations
    super_admin_dashboard: "Tableau de bord Super Admin",
    super_admin_dashboard_desc: "Statistiques système et gestion des cabinets",
    super_admin_dashboard_description: "Statistiques système et gestion des cabinets",
    total_cabinets: "Total des cabinets",
    active_cabinets: "Cabinets actifs",
    disabled_cabinets: "Cabinets désactivés",
    total_users: "Total utilisateurs",
    active_users: "Utilisateurs actifs",
    cabinet_admins: "Admin. de cabinets",
    super_admins: "Super administrateurs",
    total_cases: "Total dossiers",
    cases_this_month: "Dossiers ce mois",
    manage_cabinets: "Gérer les cabinets",
    system_analytics: "Analyses système",
    quick_actions: "Actions rapides",
    loading_dashboard: "Chargement du tableau de bord...",
    dashboard_error: "Erreur de chargement des données",
    
    // Cabinet management translations
    cabinets_management: "Gestion des cabinets",
    manage_system_cabinets: "Gérer les cabinets du système",
    all_cabinets: "Tous les cabinets",
    create_cabinet: "Créer un cabinet",
    create_new_cabinet: "Créer un nouveau cabinet",
    create_cabinet_description: "Créer un nouveau cabinet dans le système",
    search_cabinets: "Rechercher des cabinets...",
    no_cabinets: "Aucun cabinet",
    no_cabinets_found: "Aucun cabinet trouvé",
    try_different_search: "Essayez une autre recherche",
    get_started_create_cabinet: "Commencez par créer un nouveau cabinet",
    cabinet_detailed_information: "Informations détaillées du cabinet",
    users_statistics: "Statistiques utilisateurs",
    cases_statistics: "Statistiques dossiers",
    recent_activity: "Activité récente",
    inactive_users: "Utilisateurs inactifs",
    admin_users: "Utilisateurs admin",
    open_cases: "Dossiers ouverts",
    archived_cases: "Dossiers archivés",
    disabled: "Désactivé",
    disabled_at: "Désactivé le",
    by: "par",
    view_details: "Voir détails",
    mark_as_succeeded: "Marquer comme réussi",
    mark_as_failed: "Marquer comme échoué",
    disable: "Désactiver",
    enable: "Activer",
    disable_cabinet: "Désactiver le cabinet",
    enable_cabinet: "Activer le cabinet",
    disable_cabinet_description: "Êtes-vous sûr de vouloir désactiver ce cabinet ?",
    enable_cabinet_description: "Êtes-vous sûr de vouloir activer ce cabinet ?",
    reason: "Motif",
    optional: "Optionnel",
    enter_reason: "Entrez le motif...",
    delete_cabinet: "Supprimer le cabinet",
    delete_cabinet_warning: "Cette action supprimera le cabinet",
    
    // Users management translations (avoiding duplicates)
    users_management: "Gestion des utilisateurs",
    manage_system_users: "Gérer les utilisateurs système",
    search_users: "Rechercher des utilisateurs...",
    system_users: "Utilisateurs système",
    no_users: "Aucun utilisateur",
    no_users_found: "Aucun utilisateur trouvé",
    no_users_available: "Aucun utilisateur disponible",
    no_users_yet: "Aucun utilisateur pour le moment",
    create_first_user_to_get_started: "Créez un premier utilisateur pour commencer",
    try_different_search_terms: "Essayez d'autres termes de recherche",
    user_detailed_information: "Informations détaillées de l'utilisateur",
    basic_information: "Informations de base",
    status_and_permissions: "État et permissions",
    permissions: "Permissions",
    cabinet_and_activity: "Cabinet et activité",
    super_admin: "Super Admin",
    inactive: "Inactif",
    never: "Jamais",
    last_login: "Dernière connexion",
    yes: "Oui",
    no: "Non",
    remove_admin: "Retirer Admin",
    deactivate: "Désactiver",
    activate: "Activer",
    password_reset_successfully: "Mot de passe réinitialisé avec succès",
    reset_password_for: "Réinitialiser mot de passe pour",
    remove_admin_privileges: "Retirer privilèges admin",
    grant_admin_privileges: "Accorder privilèges admin",
    remove_admin_privileges_description: "Êtes-vous sûr de vouloir retirer les privilèges d'administrateur ?",
    grant_admin_privileges_description: "Êtes-vous sûr de vouloir accorder les privilèges d'administrateur ?",
    deactivate_user: "Désactiver l'utilisateur",
    activate_user: "Activer l'utilisateur",
    deactivate_user_description: "Êtes-vous sûr de vouloir désactiver cet utilisateur ?",
    activate_user_description: "Êtes-vous sûr de vouloir activer cet utilisateur ?",
    user_created_successfully: "Utilisateur créé avec succès",
    please_fill_required_fields: "Veuillez remplir les champs requis",
    no_email: "Aucun e-mail",
    no_cabinet: "Aucun cabinet",
    no_role: "Aucun rôle",
    
    // Cabinet users translations
    back_to_cabinets: "Retour aux cabinets",
    manage_cabinet_users: "Gérer les utilisateurs du cabinet",
    cabinet_information: "Informations du cabinet",
    cabinet_users: "Utilisateurs du cabinet",
    no_users_in_cabinet: "Aucun utilisateur dans ce cabinet",
    no_users_available_in_cabinet: "Aucun utilisateur disponible dans ce cabinet",
    
    // Dashboard specific translations
    total_registered_cabinets: "Total cabinets inscrits",
    currently_active_cabinets: "Cabinets actuellement actifs",
    temporarily_disabled_cabinets: "Cabinets temporairement désactivés",
    all_system_users: "Tous les utilisateurs système",
    currently_active_users: "Utilisateurs actifs actuellement",
    cabinet_administrators: "Administrateurs de cabinets",
    system_super_administrators: "Super administrateurs système",
    all_cases_in_system: "Tous les dossiers dans le système",
    new_cases_current_month: "Nouveaux dossiers ce mois",
    create_enable_disable_cabinets: "Créer, activer et désactiver des cabinets",
    view_manage_system_users: "Voir et gérer les utilisateurs système",
    view_detailed_system_analytics: "Voir les analyses détaillées du système",
    
    // Cabinet details enhancements
    registered_users: "Utilisateurs inscrits",
    all_cases: "Tous les dossiers",
    cabinet_id: "ID Cabinet",
    unique_identifier: "Identifiant unique",
    user_activity_rate: "Taux d'activité utilisateurs",
    active_cases_rate: "Taux de dossiers actifs",
    no_recent_activity: "Aucune activité récente",
    cabinet_disabled_info: "Infos de désactivation du cabinet",
    disabled_by: "Désactivé par",
    disabled_cabinet: "Cabinet désactivé",
    user_activity: "Activité utilisateurs",
    details: "Détails",
    recent_cases: "Dossiers récents",
    recent_updates: "Mises à jour récentes",
    
    // File storage translations
    file_storage_statistics: "Statistiques de stockage de fichiers",
    total_files: "Total fichiers",
    storage_size: "Taille de stockage",
    recent_files_30_days: "Fichiers récents (30 jours)",
    file_types: "Types de fichiers",
    edit_name: "Modifier le nom",

    // Case Jurisprudence
    case_jurisprudence: "Jurisprudence",
    case_jurisprudence_desc: "Gérer les notes de jurisprudence pour ce dossier",
    add_jurisprudence: "Ajouter jurisprudence",
    no_jurisprudence_found: "Aucune jurisprudence trouvée",
    no_jurisprudence_desc: "Aucune note de jurisprudence n'a encore été ajoutée à ce dossier.",
    add_first_jurisprudence: "Ajouter la première jurisprudence",
    download_pdf: "Télécharger PDF",
    jurisprudence_added: "Jurisprudence ajoutée",
    jurisprudence_updated: "Jurisprudence mise à jour",
    jurisprudence_deleted: "Jurisprudence supprimée",
    edit_jurisprudence: "Modifier la jurisprudence",
    delete_jurisprudence: "Supprimer la jurisprudence",
    delete_jurisprudence_confirm: "Êtes-vous sûr de vouloir supprimer cette note de jurisprudence ?",
    jurisprudence_title_placeholder: "Entrez le titre",
    jurisprudence_content_placeholder: "Entrez le contenu",



    
    // Missing navigation translations
    super_admin_cabinets: "Cabinets",
    super_admin_users: "Utilisateurs",
    // Public listing requests ("référencez-moi")
    // Super-admin "work waiting" section
    sa_to_process: "À traiter",
    sa_pending_cabinets: "Inscriptions en attente",
    sa_pending_listing_requests: "Demandes de référencement",
    sa_nothing_pending: "Rien en attente",
    sa_review_cabinets: "Traiter les demandes",
    sa_review_listing_requests: "Traiter les demandes",
    sa_last_7d: "sur 7 jours",
    lr_page_title: "Demandes de référencement",
    lr_page_desc: "Demandes d'avocats souhaitant figurer dans l'annuaire public, envoyées depuis la landing page",
    lr_status: "Statut",
    lr_status_pending: "En attente",
    lr_status_approved: "Approuvée",
    lr_status_rejected: "Rejetée",
    lr_contact: "Contact",
    lr_submitted_at: "Reçue le",
    lr_approve: "Approuver",
    lr_reject: "Rejeter",
    lr_approve_title: "Approuver la demande",
    lr_approve_desc: "Le profil sera publié dans l'annuaire public :",
    lr_reject_title: "Rejeter la demande",
    lr_reject_desc: "Le profil restera non publié :",
    lr_rejection_reason: "Motif du rejet (interne)",
    lr_rejection_reason_placeholder: "Ex. inscription au barreau non vérifiable",
    lr_send_review_link: "Envoyer le lien de gestion à l'avocat",
    lr_send_review_link_hint: "Permet à l'avocat de confirmer ou corriger ses informations après publication.",
    lr_approved: "Demande approuvée, profil publié",
    lr_rejected: "Demande rejetée",
    lr_review_email_failed: "Profil publié, mais l'email de gestion n'a pas pu être envoyé.",
    lr_recent_submitted: "Nouvelles ({{days}} j)",
    lr_oldest_pending: "La plus ancienne demande attend depuis {{days}} jour(s).",
    lr_export_csv: "Exporter CSV",
    lp_export_csv: "Exporter CSV",
    lp_export_done: "{{count}} avocats exportés",
    lr_empty: "Aucune demande de référencement ne correspond.",
    lp_page_title: "Profils Avocats",
    lp_page_desc: "Gérer les profils publics des avocats et envoyer les liens de réclamation",
    lp_add_profile: "Ajouter un profil",
    lp_add_profile_desc: "Ajouter un nouveau profil avocat sur la plateforme",
    lp_full_name: "Nom complet",
    lp_full_name_fr: "Nom en français",
    lp_cabinet: "Cabinet",
    lp_verified: "Vérifié",
    lp_unverified: "Non vérifié",
    lp_published: "Publié",
    lp_published_yes: "Publié",
    lp_published_no: "Non publié",
    lp_filter_published: "Statut publication",
    lp_unclaimed: "Non réclamé",
    lp_claimed: "Réclamé",
    lp_all: "Tous",
    lp_yes: "Oui",
    lp_no: "Non",
    lp_city: "Ville",
    lp_send_claim: "Envoyer le lien de réclamation",
    lp_view_details: "Voir les détails",
    lp_claim_link_title: "Lien de réclamation",
    lp_claim_url: "Lien",
    lp_email_sent: "Lien envoyé par e-mail",
    lp_email_not_sent: "Pas d'e-mail disponible — partagez le lien manuellement",
    lp_delete_title: "Supprimer le profil",
    lp_created: "Profil créé avec succès",
    lp_deleted: "Profil supprimé avec succès",
    lp_no_profiles: "Aucun profil",
    lp_search_name: "Rechercher par nom",
    lp_filter_claim_status: "Statut réclamation",
    lp_filter_verified: "Statut vérification",
    chatbot_configuration: "Configuration Chatbot",
    chatbot: "Chatbot",
    chatbot_coming_soon: "Chatbot bientôt disponible",
    super_admin_feedback: "Retours Chatbot",
    search_feedback: "Rechercher dans les retours",
    sent_message: "Message envoyé",
    received_message: "Message reçu",
    feedback_type: "Type de retour",
    no_feedback_found: "Aucun retour trouvé",
    super_admin_logs: "Journaux du Chatbot",
    
    // Audit Logs translations
    audit_logs: "Journaux d'audit",
    audit_logs_description: "Voir et gérer les journaux d'activité du système",
    audit_log_details: "Détails du journal d'audit",
    no_audit_logs_found: "Aucun journal d'audit trouvé",
    timestamp: "Horodatage",
    model: "Modèle",
    object: "Objet",
    object_id: "ID de l'objet",
    object_representation: "Représentation de l'objet",
    changes: "Changements",
    search_user: "Rechercher un utilisateur",
    search_by_user_name: "Rechercher par nom d'utilisateur",
    date_from: "Date de début",
    date_to: "Date de fin",
    
    // Logs Statistics Dashboard translations
    logs_statistics_dashboard: "Tableau de bord des statistiques des journaux",
    statistics: "Statistiques",
    logs_list: "Liste des journaux",
    date_filter: "Filtrer par date",
    all_time: "Tout le temps",
    last_day: "Dernier jour",
    custom_range: "Période personnalisée",
    period: "Période",
    beginning: "Début",
    loading_stats: "Chargement des stats",
    failed_to_load_stats: "Échec du chargement des stats",
    
    // Stats metrics translations
    total_logs: "Total journaux",
    total_messages_logged: "Total messages enregistrés",
    total_tokens: "Total tokens",
    total_tokens_consumed: "Total tokens consommés",
    success_rate: "Taux de succès",
    successful: "Réussi",
    errors: "Erreurs",
    avg_tokens_per_message: "Moy. tokens par message",
    average_token_usage: "Utilisation moyenne de tokens",
    avg_llm_response_time: "Temps de réponse moyen LLM",
    llm_processing_time: "Temps de traitement LLM",
    avg_processing_time: "Temps de traitement moyen",
    total_processing_time: "Temps de traitement total",
    avg_tool_calls: "Moy. appels d'outils",
    avg_tools_per_message: "Moy. outils par message",
    top_models: "Meilleurs modèles",
    top_tools: "Meilleurs outils",
    no_data_available: "Aucune donnée disponible",
    
    // Missing user management translations
    create_user: "Créer un utilisateur",
    user_details: "Détails de l'utilisateur",
    username: "Nom d'utilisateur",
    
    // Missing form field translations
    enter_name: "Entrer le nom",
    enter_username: "Entrer le nom d'utilisateur",
    enter_email: "Entrer l'e-mail",
    select_cabinet: "Sélectionner le cabinet",
    
    // Missing password-related translations
    password: "Mot de passe",
    enter_password: "Entrer le mot de passe",
    enter_new_password: "Entrer le nouveau mot de passe",
    confirm_new_password: "Confirmer le nouveau mot de passe",
    
    // Missing cabinet and role translations
    cabinet: "Cabinet",
    active_user: "Utilisateur actif",
    
    // Missing dialog descriptions
    create_new_user_description: "Créer un nouvel utilisateur dans le système",
    

    all_registered_cabinets: "Tous les cabinets inscrits",
    usage_analytics: "Analyses d'utilisation",
    view_all_alerts: "Voir toutes les alertes",
    system_settings: "Paramètres système",    
    // Credit System translations
    credit_management: "Gestion des crédits",
    credit_usage: "Utilisation des crédits",
    monthly_credit_limit: "Limite de crédit mensuelle",
    credits_used: "Crédits utilisés",
    credits_remaining: "Crédits restants",
    resets_on: "Réinitialisation le",
    credit_configuration: "Configuration des crédits",
    input_token_cost: "Coût des tokens d'entrée",
    output_token_cost: "Coût des tokens de sortie",
    credit_config_description: "Paramètres de coût des tokens IA",
    tokens_per_credit: "Tokens par crédit",
    update_configuration: "Mettre à jour la config",
    configuration_updated: "Configuration mise à jour avec succès",
    total_messages_credit: "Total messages",
    total_tokens_credit: "Total tokens",
    total_credits_used: "Total crédits utilisés",
    input_tokens_credit: "Tokens d'entrée",
    output_tokens_credit: "Tokens de sortie",
    average_tokens_per_message: "Moy. tokens par message",
    average_credits_per_message: "Moy. crédits par message",
    credit_stats: "Stats crédits",
    usage_details: "Détails d'utilisation",
    update_credit_limit: "Mettre à jour limite crédit",
    manage_cabinet_quotas_and_usage_limits: "Gérer quotas cabinet et limites d'utilisation",
    monthly_limit: "Limite mensuelle",
    current_month: "Mois en cours",
    is_exceeded: "Dépassé",
    failed_to_update: "Échec de la mise à jour",

    //Blog section
    add_blog:"Nouvel article",
    blog_management: "Gestion du blog",
    search_blogs: "Rechercher des articles",
    no_blogs_yet: "Aucun article pour le moment",
    no_blogs_found: "Aucun article trouvé",
    create_first_blog_to_get_started: "Créez votre premier article pour commencer",
    blog_status: "Statut du blog",
    create_blog: "Créer un article",
    blog_title: "Titre de l’article",
    blog_summary: "Description",
    content: "Contenu",
    new_category: "Créer une catégorie",
    new_tag: "Créer un tag",
    category_b:"Catégorie",
    tags:"tags",
    select_category_b: "Sélectionner une catégorie",
    Arabe:"Arabe",
    Français:"Français",
    Back_to_blog_menu:"Retour au menu",
    Publish:"Publier",
    Delete:"Supprimer",
    published:"publié",
    draft:"brouillon",
    edit_blog:"Modifier",
    Unpublish:"Dépublier",
    create_b:"Créer",
    create_t:"Créer",

    //CRM
    Create_contact:"Créer un contact",
    Contacts_List:"Liste des contacts",
    Search_crm:"Rechercher par nom / Télephone / email / linkedin / tags",
    Total:"Total des lignes",
    New_tag_name:"Créer un nouveau Tag",
    Add:"Ajouter",
    Import_CSV_XLSX :"Importer un fichier CSV/XLSX",
    Create_missing_tags:"Créer les Tags manquants",
    Nom_complet:"Nom complet",
    Telephone:"Téléphone",
    Email:"Email",
    LinkedIn:"LinkedIn",
    Tags:"Tags",
    Status:"Status",
    Actions: "Actions",
    Voir:"Voir",
    Tags_a: "Création des tags",
    Page_a:"Page",
    sur_a:"sur",
    page_of: "الصفحة {current} من {total}",
    Import: "Importer",
    Importing: "Importation en cours...",
      chatbotInterface: {
        title: "Conseiller AvocatPro",
        subtitle: "Assistant juridique intelligent",
        typing: "Écrit...",
        close: "Fermer",
        deleteConversation: "Supprimer la conversation",
        suggestionsTitle: "Suggestions pour commencer :",
        welcomeTitle: "Comment puis-je vous aider ?",
        welcomeSubtitle: "Posez une question juridique ou choisissez une suggestion",
        connectionError: "Désolé, impossible de se connecter au serveur pour le moment. Veuillez réessayer plus tard.",
        conversationDeleted: "Conversation supprimée. Comment puis-je vous aider ?",
        deleteError: "Une erreur s'est produite lors de la suppression de la conversation.",
        serviceUnavailable: "Le service est actuellement indisponible. Veuillez réessayer plus tard.",
        serviceNotActive: "Le service d'assistance intelligente n'est pas activé pour votre compte.",
        aiAccessDisabled: "L'accès à l'IA n'est pas activé pour votre compte.",
        quotaExhausted: "Crédits mensuels épuisés. Limite mensuelle : {{limit}}. Renouvellement le : {{reset}}.",
        messageTooLong: "Message trop long. Le maximum est de {{maxLength}} caractères.",
        responseError: "Désolé, une erreur s'est produite lors de la réponse.",
        networkError: "Erreur de connexion réseau. Veuillez vérifier votre connexion internet et réessayer.",
        timeoutError: "Délai de connexion dépassé. Veuillez réessayer.",
        dailyQuotaExhausted: "Votre quota quotidien de messages est épuisé.",
        generalError: "Désolé, une erreur s'est produite. Veuillez réessayer.",
        noInternet: "Pas de connexion internet. Veuillez vérifier votre connexion et réessayer.",
        audioMessage: "🎤 Message vocal",
        transcribedText: "**Texte transcrit :** ",
        audioSendError: "Erreur lors de l'envoi de l'audio : ",
        // File Upload translations
        attachFile: "Joindre un fichier",
        uploadingFile: "Téléchargement en cours...",
        fileUploaded: "Le fichier \"{{filename}}\" a été téléchargé et est prêt pour l'analyse.",
        fileSizeError: "Le fichier est trop volumineux. Maximum 10 Mo.",
        fileTypeError: "Type de fichier non supporté. Types autorisés : PDF, DOCX, TXT, PNG, JPEG",
        maxFilesError: "Maximum 5 fichiers. Veuillez supprimer un fichier avant d'en ajouter un nouveau.",
        deleteFile: "Supprimer le fichier",
        attachedFiles: "Fichiers joints",
        fileReady: "Prêt",
        fileProcessing: "En cours",
        fileError: "Erreur",
        fileExpired: "Expiré",
        fileUploadError: "Échec du téléchargement. Veuillez réessayer.",
        fileDeleteError: "Échec de la suppression. Veuillez réessayer."
      },
    chatbotConfig: {
      title: "Configuration du Chatbot",
      description: "Gérer les paramètres du chatbot système",
      loading: "Chargement des paramètres...",
      saving: "Enregistrement des paramètres...",
      resetting: "Réinitialisation des paramètres...",
      refreshing: "Actualisation des paramètres...",
      
      // Status and Actions
      status: "État",
      active: "Actif",
      default: "Défaut",
      activeDescription: "Activer ou désactiver le chatbot",
      defaultDescription: "Définir comme configuration par défaut",
      resetToDefaults: "Réinitialiser aux valeurs par défaut",
      resetConfirmation: "Êtes-vous sûr de vouloir réinitialiser tous les paramètres aux valeurs par défaut ?",
      unsavedChanges: "Modifications non enregistrées",
      
      // Model Configuration
      modelConfiguration: "Configuration du modèle",
      modelName: "Nom du modèle",
      modelNameDescription: "Choisir le modèle IA à utiliser",
      temperature: "Température",
      temperatureDescription: "Contrôle la créativité des réponses (0.0 = conservateur, 1.0 = créatif)",
      maxTokens: "Max Tokens",
      maxTokensDescription: "Nombre maximum de tokens dans la réponse",
      maxIterations: "Max Itérations",
      maxIterationsDescription: "Nombre maximum d'essais pour une réponse",
      
      // System Prompt
      systemPrompt: "Prompt système",
      systemPromptDescription: "Instructions de base pour le chatbot",
      systemPromptPlaceholder: "Entrez les instructions système...",
      
      // Default Message
        defaultMessage: "Message par défaut",
        defaultMessageDescription: "Message vu par l'utilisateur au début de la conversation",
        defaultMessagePlaceholder: "Entrez le message par défaut...",
        
        // Conversation Settings
        conversationSettings: "Paramètres de conversation",
        maxConversationHistory: "Historique max de conversation",
        maxConversationHistoryDescription: "Nombre max de messages gardés en historique",
        conversationTimeoutHours: "Expiration conversation (heures)",
        conversationTimeoutHoursDescription: "Heures avant l'expiration de la conversation",
        maxMessageLength: "Longueur max message",
        maxMessageLengthDescription: "Nombre max de caractères par message (50-5000)",
        maxAudioDuration: "Durée audio max",
        maxAudioDurationDescription: "Durée max du message audio en secondes (0-600)",
      
      // Status Settings
      statusSettings: "Paramètres d'état",
      
      // Actions
      save: "Enregistrer",
      reset: "Réinitialiser",
      refresh: "Actualiser",
      cancel: "Annuler",
      
      // Success messages
      saveSuccess: "Paramètres enregistrés avec succès",
      resetSuccess: "Paramètres réinitialisés avec succès",
      refreshSuccess: "Paramètres actualisés avec succès",
      
      // Error messages
      saveError: "Échec de l'enregistrement",
      loadError: "Échec du chargement",
      resetError: "Échec de la réinitialisation",
      refreshError: "Échec de l'actualisation"
    },
    
    // Additional missing keys
    lastUpdated: "Dernière mise à jour",
    reset: "Réinitialiser",
    
    // Chatbot Logs translations
    search_logs: "Rechercher dans les journaux",
    no_logs_found: "Aucun journal trouvé",
    log_details: "Détails du journal",
    user_message: "Message utilisateur",
    response_status: "État de la réponse",
    input_tokens: "Tokens d'entrée",
    output_tokens: "Tokens de sortie",
    full_prompt: "Prompt complet",
    success: "Succès",
    timeout: "Délai dépassé",
    partial: "Partiel",
    ordering: "Tri",
    default_order: "Tri par défaut",
    newest_first: "Plus récents d'abord",
    oldest_first: "Plus anciens d'abord",
    longest_processing: "Traitement le plus long",
    shortest_processing: "Traitement le plus court",
    
    chatFeedback: {
      helpful: "Utile",
      not_helpful: "Inutile",
      submitting: "Envoi en cours...",
      feedback_submitted: "✓ Retour envoyé",
      add_details_title: "Ajouter des détails",
      add_details_prompt_positive: "Merci pour votre retour positif ! Voulez-vous ajouter des détails ?",
      add_details_prompt_negative: "Merci pour votre retour. Voulez-vous ajouter des détails ?",
      details_placeholder: "Veuillez partager des détails spécifiques sur la réponse...",
      characters_count: "{{count}}/500 caractères",
      skip: "Passer",
      add_details: "Ajouter détails",
      share_feedback_title: "Partagez votre avis",
      your_question: "Votre question",
      ai_response: "Réponse IA",
      rate_response_question: "Comment évaluez-vous cette réponse ?",
      positive_desc: "La réponse était utile et précise",
      negative_desc: "La réponse était inutile ou imprécise",
      additional_comments_optional: "Commentaires supplémentaires (optionnel)",
      submit_feedback: "Envoyer le retour",
      cancel: "Annuler"
    },
    chatbotSuggestions: {
      myAppointments: "Quels sont mes rendez-vous ?",
      searchClient: "Rechercher un client",
      viewCases: "Voir mes dossiers",
      generalHelp: "Aide générale"
    },
    chatbotDocAnalysis: {
      title: "Configuration de l'analyse de documents",
      description: "Analyser de longs documents et extraire des informations avec précision",
      modelName: "Nom du modèle d'analyse",
      modelNameDescription: "Choisir le modèle pour l'analyse de documents",
      temperature: "Température d'analyse",
      temperatureDescription: "Contrôle la créativité de l'analyse (0.0 = conservateur, 1.0 = créatif)",
      maxTokens: "Max Tokens d'analyse",
      maxTokensDescription: "Nombre max de tokens utilisés pour l'analyse",
      maxTextLength: "Longueur max du texte",
      maxTextLengthDescription: "Nombre max de caractères autorisés dans le document",
      systemPrompt: "Prompt système d'analyse",
      systemPromptDescription: "Instructions personnalisées pour l'analyse de documents",
      systemPromptPlaceholder: "Entrez les instructions système pour l'analyse..."
    },
    // Template Requests
    all: "Tous",
    error_updating_request: "Échec de la mise à jour de la demande",
    template_requests: "Demandes de modèles",
    my_template_requests: "Mes demandes",
    my_template_requests_desc: "Suivez l'état de vos demandes de modèles.",
    new_request: "Nouvelle demande",
    request_template: "Demander un modèle",
    upload_template_request: "Déposer une demande",
    upload_template_subtitle: "Traitement par notre équipe",
    upload_template_desc: "Ce formulaire permet de soumettre un modèle Word afin qu'il soit transformé en modèle intelligent avec variables automatiques (client, affaire, juridiction, etc.).",
    choose_file: "Choisir un fichier",
    file_format_note: "Formats acceptés : Word modifiable (sans scan).",
    no_file_selected: "Aucun fichier sélectionné",
    please_select_file: "Veuillez sélectionner un fichier",
    description_label: "Description (facultatif)",
    description_placeholder: "Expliquez brièvement l'usage du document (type de procédure, juridiction, informations à automatiser…)",
    reassuring_message: "Votre demande sera analysée par notre équipe. Vous serez notifié dès qu'elle sera prise en charge.",
    filename: "Nom du fichier",
    file: "Fichier",

    individual: "Personne Physique",
    corporate: "Personne Morale",
    general_info: "Informations générales",
    specific_info: "Informations spécifiques",
    id_type: "Type d'identité",
    cin: "CIN",
    id_number: "N° d'identité",
    passport: "Passeport",
    residence_card: "Carte de séjour",
    birth_date: "Date de naissance",
    nationality: "Nationalité",
    profession: "Profession",
    legal_form: "Forme juridique",
    rc_number: "Numéro RC",
    rc_city: "Ville du RC",
    if_number: "Identifiant Fiscal",
    activity_sector: "Secteur d'activité",
    legal_representative: "Représentant légal",
    representative_role: "Fonction du représentant",
    company_creation_date: "Date de création",
    internal_notes: "Notes internes",
    city: "Ville",
    country: "Pays",
    address: "Adresse",
    address_placeholder: "Adresse complète",
    ice_invalid: "L'ICE doit être composé de 15 chiffres",
    ice_placeholder: "123456789012345",
    notes: "Notes",
    status_pending: "En attente",
    status_done: "Terminé",
    status_refused: "Refusé",
    no_requests_found: "Aucune demande trouvée.",
    error_fetching_requests: "Erreur lors du chargement des demandes",
    request_submitted: "Votre demande a bien été envoyée et est en attente de traitement.",
    request_approved: "Demande approuvée",
    request_rejected: "Demande refusée",
    reject_request: "Refuser la demande",
    reject_reason_desc: "Veuillez indiquer la raison du refus.",
    reason_placeholder: "Raison du refus...",
    filter_status: "Filtrer par statut",
    search_placeholder: "Rechercher par cabinet ou fichier...",
    approve: "Approuver",
    reject: "Rejeter",
    my_requests: "Mes demandes",
    request_new_template: "Demander un modèle",
    adversaries: "Adversaires",
    adversaries_desc: "Gérer les adversaires du dossier",
    add_adversary: "Ajouter un adversaire",
    add_adversary_desc: "Ajouter un nouvel adversaire à ce dossier",
    adversary_name: "Nom de l'adversaire",
    search_adversaries: "Rechercher des adversaires...",
    adversary_added: "Adversaire {{name}} ajouté",
    adversary_removed: "Adversaire {{name}} supprimé",
    delete_adversary: "Supprimer l'adversaire",
    edit_adversary: "Modifier l'adversaire",
    edit_adversary_desc: "Modifier les détails de l'adversaire",
    adversary_updated: "Adversaire {{name}} mis à jour",
    no_adversaries: "Aucun adversaire",
    add_first_adversary: "Ajouter le premier adversaire",
    add_adversary_to_case: "Ajouter un adversaire au dossier",
    select_existing_adversary: "Sélectionner un adversaire existant",
    create_new_adversary: "Créer un nouvel adversaire",
    adversary_added_to_case: "Adversaire {{name}} ajouté au dossier",
    adversary_removed_from_case: "Adversaire {{name}} retiré du dossier",
    no_adversaries_in_case: "Aucun adversaire dans ce dossier",
    no_profession_specified: "Aucune profession spécifiée",
    legal_info: "Informations légales",
    cases_as_client: "Dossiers en tant que client",
    cases_as_adversary: "Dossiers en tant qu'adversaire",
    latest_cases_as_client: "Derniers dossiers en tant que client",
    latest_cases_as_adversary: "Derniers dossiers en tant qu'adversaire",
    all_cases_as_client_desc: "Liste de tous les dossiers où cette partie est client.",
    all_cases_as_adversary_desc: "Liste de tous les dossiers où cette partie est adversaire.",
    no_cases_found: "Aucun dossier trouvé",
    party: "Partie",
    party_not_found: "Partie non trouvée",
    Blog: "Blog",
    user_name: "Nom d'utilisateur",
    case_details: "Détails du dossier",
    no_notes_click_to_add: "Aucune note. Cliquez pour ajouter...",
    add_notes_placeholder: "Ajouter des notes privées sur cette partie...",
    ai_case_analysis: "Analyse IA du dossier",
    priority: "Priorité",
    only_priority: "Priorité uniquement",
    add_to_favorites: "Ajouter aux favoris",
    remove_from_favorites: "Retirer des favoris",
    case_marked_as_favorite: "Le dossier a été marqué comme prioritaire",
    case_unmarked_as_favorite: "Le dossier n'est plus prioritaire",
    failed_to_update_favorite: "Échec de la mise à jour du statut prioritaire",
    added_to_favorites: "Ajouté aux favoris",
    removed_from_favorites: "Retiré des favoris",
    ai_analysis: "Analyse IA",
    ai_case_analysis_desc: "Analyse intelligente du dossier",
    generate_analysis: "Générer l'analyse",
    regenerate_analysis: "Régénérer l'analyse",
    generating_analysis: "Génération de l'analyse...",
    ai_analysis_complete: "Analyse terminée",
    ai_analysis_success_desc: "Le résumé du dossier a été généré avec succès.",
    error_generating_summary: "Une erreur est survenue lors de l'analyse.",
    quick_summary: "Résumé rapide",
    quick_analysis_wait_msg: "Génération d'un aperçu rapide...",
    select_status: "Sélectionner le statut",
    status_overview: "Aperçu du statut",
    current_stage: "Étape actuelle",
    last_proceeding: "Dernière procédure",
    parties: "Parties",
    financial_summary: "Résumé financier",

    total_deposits: "Total des paiements",
    remaining: "Reste à payer",
    next_steps: "Prochaines étapes",
    key_dates: "Dates clés",
    required_actions: "Actions requises",
    deep_analysis: "Analyse approfondie",
    deep_analysis_wait_msg: "Génération d'une analyse détaillée (peut prendre 30s)...",
    executive_summary: "Résumé exécutif",
    proceedings_analysis: "Analyse des procédures",
    total_hearings: "Total des audiences",
    total_postponements: "Nombre de reports",
    pattern_detected: "Motif détecté",
    legal_strategy: "Stratégie juridique",
    strengths: "Points forts",
    risks: "Risques",
    recommendations: "Recommandations",
    audience_preparation: "Préparation de l'audience",
    next_hearing: "Prochaine audience",
    required_documents: "Documents requis",
    anticipated_questions: "Questions anticipées",
    timeline: "Chronologie",
    ready_to_analyze: "Prêt à analyser",
    ai_analysis_intro: "Utilisez l'IA pour obtenir des informations instantanées sur ce dossier.",
    type_needed: "Type requis",
    
      // New AI Analysis Fields
      checklist: "Liste de contrôle",
      key_arguments: "Arguments clés",
      financial_analysis: "Analyse financière",
      fee_structure: "Structure des honoraires",
      deposits_timeline: "Historique des dépôts",
      outstanding_balance: "Solde restant",
      parties_analysis: "Analyse des parties",
      client_profile: "Profil du client",
      adversary_profiles: "Profils des adversaires",
      document_analysis: "Analyse documentaire",
      key_findings: "Principales conclusions",
      documents_analyzed: "Documents analysés",
      no_documents_analyzed: "Aucun document analysé",

    // Honoraires Page
    honoraires: "Honoraires",
    guides_resources: "Guides et ressources",
    honoraires_desc: "Gérez les honoraires des dossiers et suivez les paiements",
    honoraires_total: "Total des honoraires",
    honoraires_paid: "Payé",
    honoraires_remaining: "Restant",
    honoraires_for_period: "Pour la période sélectionnée",
    honoraires_collected: "Collecté",
    honoraires_outstanding: "En attente",
    honoraires_search: "Rechercher par n° dossier ou nom du client...",
    honoraires_status_all: "Tous",
    honoraires_status_paid: "Payé",
    honoraires_status_partial: "Partiel",
    honoraires_status_unpaid: "Impayé",
    honoraires_status_pending: "En attente",
    honoraires_col_case_number: "N° du dossier",
    honoraires_col_client: "Client",
    honoraires_col_tribunal: "Tribunal",
    honoraires_col_total_fee: "Total",
    honoraires_col_amount_paid: "Payé",
    honoraires_col_amount_remaining: "Restant",
    honoraires_col_status: "Statut",
    honoraires_loading: "Chargement...",
    honoraires_page_of: "Page {{current}} sur {{total}}",
    honoraires_deposits_received: "Provisions libres (non imputées à une facture)",
    honoraires_formally_paid: "Paiements formels (via facture)",
    honoraires_total_invoiced: "Total facturé formellement (HT)",
    honoraires_prov_abbr: "Prov.",
    honoraires_formal_abbr: "Fact.",
    honoraires_invoiced_abbr: "Facturé",
    honoraires_gap_warning: "{{amount}} non facturé",
    honoraires_credit_note_warning: "Trop-perçu — avoir à émettre",
    deposit_applied_to_invoice: "Imputée à la facture",
    inv_create_from_honoraire: "Facturer l'honoraire",
    inv_from_honoraire_desc: "Une facture brouillon sera créée à partir des honoraires de ce dossier.",
    inv_from_honoraire_deposits_desc: "{{count}} provision(s) libre(s) de {{total}} seront imputées automatiquement comme paiements sur cette facture. Continuer ?",
    inv_from_honoraire_success: "Facture créée avec succès",
    inv_from_honoraire_error: "Échec de la création de la facture",
    inv_no_client_error: "Ce dossier n'a pas de client assigné",
    inv_gap_fully_invoiced: "Honoraire entièrement facturé",
    inv_gap_update_draft: "Mettre à jour le brouillon",
    inv_gap_cancel_reissue: "Annuler et refacturer",
    inv_gap_complement: "Facture complémentaire {{amount}}",
    inv_gap_complement_error: "Échec de la facture complémentaire",
    inv_gap_credit_note: "Trop-perçu : {{amount}}",

    // Facturation (Client Invoices) Page
    facturation: "Facturation",
    facturation_desc: "Créez et gérez les factures clients",
    inv_create: "Nouvelle facture",
    inv_col_number: "N° facture",
    inv_col_client: "Client",
    inv_col_issue_date: "Date d'émission",
    inv_col_due_date: "Date d'échéance",
    inv_col_total_ttc: "Total TTC",
    inv_col_net: "Net à payer",
    inv_col_reste: "Reste à payer",
    inv_col_status: "Statut",
    inv_status_draft: "Brouillon",
    inv_status_sent: "Envoyée",
    inv_status_partial: "Partiel",
    inv_status_paid: "Payée",
    inv_status_cancelled: "Annulée",
    inv_action_send: "Envoyer la facture",
    inv_action_pdf: "Télécharger PDF",
    inv_action_edit: "Modifier",
    inv_action_delete: "Supprimer",
    inv_action_add_payment: "Enregistrer un paiement",
    inv_total_ttc: "Total TTC",
    inv_total_paid: "Montant encaissé",
    inv_reste: "Reste à payer",
    inv_for_page: "Pour les résultats affichés",
    inv_paid_desc: "Paiements reçus",
    inv_reste_desc: "Soldes en attente",
    inv_detail_client: "Client",
    inv_detail_case: "Dossier",
    inv_detail_issue_date: "Date d'émission",
    inv_detail_due_date: "Date d'échéance",
    inv_detail_notes: "Notes",
    inv_lines_title: "Lignes de facturation",
    inv_line_description: "Description",
    inv_line_qty: "Qté",
    inv_line_unit_price: "P.U. HT",
    inv_line_tva: "TVA",
    inv_line_total_ht: "Total HT",
    inv_line_total_ttc: "Total TTC",
    inv_totals_ht: "Total HT",
    inv_totals_tva: "TVA",
    inv_totals_ttc: "Total TTC",
    inv_totals_ras_tva: "RAS TVA",
    inv_totals_ras_ir: "RAS IR",
    inv_totals_net: "Net à payer",
    inv_payments_title: "Paiements",
    inv_payment_date: "Date",
    inv_payment_method: "Méthode",
    inv_payment_amount: "Montant",
    inv_payment_reference: "Référence",
    inv_payment_notes: "Notes",
    inv_payment_method_cash: "Espèces",
    inv_payment_method_check: "Chèque",
    inv_payment_method_wire: "Virement",
    inv_payment_method_mobile: "Mobile",
    inv_payment_method_other: "Autre",
    inv_add_payment: "Ajouter un paiement",
    inv_delete_payment_confirm: "Supprimer ce paiement ?",
    inv_send_confirm: "Envoyer la facture",
    inv_send_confirm_desc: "Un PDF sera généré et le statut passera à 'Envoyée'.",
    inv_delete_confirm: "Supprimer la facture",
    inv_delete_confirm_desc: "Cette action est irréversible.",
    inv_form_client: "Client",
    inv_form_case: "Dossier (optionnel)",
    inv_form_issue_date: "Date d'émission",
    inv_form_due_date: "Date d'échéance (optionnelle)",
    inv_form_notes: "Notes",
    inv_form_ras_tva: "RAS TVA",
    inv_form_ras_tva_rate: "Taux RAS TVA (%)",
    inv_form_ras_ir: "RAS IR",
    inv_form_ras_ir_rate: "Taux RAS IR (%)",
    inv_form_lines: "Lignes",
    inv_form_add_line: "Ajouter une ligne",
    inv_form_remove_line: "Retirer",
    inv_form_submit: "Créer la facture",
    inv_form_update: "Mettre à jour",
    inv_no_lines: "Ajoutez au moins une ligne",
    inv_total_preview: "Aperçu des totaux",
    inv_settings_title: "Paramètres de facturation",
    inv_settings_desc: "Coordonnées du cabinet affichées sur le PDF",
    inv_settings_identity: "Identité du cabinet",
    inv_settings_legal: "Identifiants légaux",
    inv_settings_tva: "TVA",
    inv_settings_numbering: "Numérotation des factures",
    inv_settings_bank: "Informations bancaires",
    inv_settings_other: "Autres paramètres",
    inv_settings_saved: "Paramètres enregistrés avec succès",
    inv_settings_address: "Adresse",
    inv_settings_phone: "Téléphone",
    inv_settings_email: "E-mail",
    inv_settings_ice: "ICE",
    inv_settings_if: "IF (Identifiant Fiscal)",
    inv_settings_rc: "RC (Registre de Commerce)",
    inv_settings_patente: "Patente",
    inv_settings_cnss: "CNSS",
    inv_settings_tva_enabled: "Activer la TVA sur les factures",
    inv_settings_tva_number: "Numéro TVA",
    inv_settings_tva_rate: "Taux TVA par défaut (%)",
    inv_settings_prefix: "Préfixe du numéro de facture",
    inv_settings_next_number: "Prochain numéro (automatique)",
    inv_settings_bank_name: "Nom de la banque",
    inv_settings_bank_rib: "RIB",
    inv_settings_bank_iban: "IBAN",
    inv_settings_payment_terms: "Délai de paiement par défaut (jours)",
    inv_settings_footer: "Pied de page des factures",
    inv_settings_save: "Enregistrer les paramètres",

    // Dépenses (Expenses module)
    depenses: "Dépenses",
    depenses_desc: "Gérer les débours et frais du cabinet",
    exp_create: "Nouvelle dépense",
    exp_kpi_total: "Total dépenses",
    exp_kpi_billed: "Dont refacturées",
    exp_kpi_cabinet: "Frais cabinet",
    exp_kpi_dossier: "Débours dossiers",
    exp_col_date: "Date",
    exp_col_description: "Description",
    exp_col_case: "Dossier",
    exp_col_category: "Catégorie",
    exp_col_amount: "Montant",
    exp_col_status: "Statut",
    exp_col_vendor: "Prestataire",
    exp_col_billable: "Refacturable",
    exp_type_cabinet: "Cabinet",
    exp_type_dossier: "Dossier",
    exp_cat_frais_justice: "Frais de justice",
    exp_cat_deplacement: "Déplacement",
    exp_cat_expertise: "Expertise",
    exp_cat_honoraires_confrere: "Honoraires confrère",
    exp_cat_fournitures: "Fournitures",
    exp_cat_communication: "Communication",
    exp_cat_other: "Autre",
    exp_status_refacturee: "Refacturée",
    exp_status_a_refacturer: "À refacturer",
    exp_status_non_facturable: "Non facturable",
    exp_tab_all: "Toutes",
    exp_tab_a_refacturer: "À refacturer",
    exp_tab_refacturee: "Refacturées",
    exp_tab_non_facturable: "Non facturables",
    exp_filter_type: "Type",
    exp_filter_category: "Catégorie",
    exp_create_title: "Nouvelle dépense",
    exp_create_desc: "Ajoutez un frais cabinet ou un débours dossier",
    exp_edit_title: "Modifier la dépense",
    exp_edit_desc: "Modifier les informations de la dépense",
    exp_field_type: "Type de dépense",
    exp_field_case: "Dossier",
    exp_field_category: "Catégorie",
    exp_field_description: "Description",
    exp_field_amount: "Montant",
    exp_field_currency: "Devise",
    exp_field_date: "Date",
    exp_field_billable: "Refacturable au client",
    exp_field_assigned_to: "Assigné à",
    exp_field_assigned_to_placeholder: "Choisir un avocat (optionnel)",
    exp_case_tab_title: "Débours & Frais",
    exp_case_tab_desc: "Dépenses rattachées à ce dossier",
    exp_add_case: "Ajouter un débours",
    exp_cannot_delete_billed: "Impossible de supprimer une dépense déjà refacturée. Annulez la refacturation d'abord.",
    exp_cannot_edit_billed: "Impossible de modifier une dépense déjà refacturée. Annulez la refacturation d'abord.",
    exp_delete_success: "Dépense supprimée",
    exp_save_success: "Dépense enregistrée",
    exp_delete_error: "Erreur lors de la suppression",
    exp_save_error: "Erreur lors de l'enregistrement",
    exp_action_bill: "Facturer au client",
    exp_action_unbill: "Annuler la facturation",
    exp_bill_dialog_title: "Ajouter à une facture",
    exp_bill_no_invoices: "Aucune facture ouverte pour ce dossier.",
    exp_bill_confirm: "Facturer",
    exp_bill_success: "Dépense facturée avec succès",
    exp_unbill_success: "Facturation annulée",

    // Affectation des avocats
    affectation: "Affectation des avocats",
    affectation_desc: "Gérer les profils de préférences d'affectation de chaque avocat",
    aff_add_profile: "Ajouter un profil",
    aff_edit_profile: "Modifier le profil",
    aff_delete_profile: "Supprimer le profil",
    aff_delete_profile_desc: "Êtes-vous sûr de vouloir supprimer le profil de cet avocat ? Cette action est irréversible.",
    aff_col_lawyer: "Avocat",
    aff_col_villes: "Villes",
    aff_col_tribunal_types: "Juridictions",
    aff_col_case_types: "Types de procédure",
    aff_col_status: "Statut",
    aff_active: "Actif",
    aff_inactive: "Inactif",
    aff_any: "Toutes",
    aff_select_lawyer: "Sélectionner un avocat",
    aff_search_villes: "Rechercher une ville...",
    aff_search_tribunals: "Rechercher une juridiction...",
    aff_search_case_types: "Rechercher un type de procédure...",
    aff_profile_created: "Profil créé avec succès",
    aff_profile_updated: "Profil mis à jour avec succès",
    aff_profile_deleted: "Profil supprimé",
    aff_no_profiles: "Aucun profil d'affectation. Ajoutez un profil pour commencer.",
    aff_history: "Historique des affectations",
    aff_history_lawyer: "Avocat",
    aff_history_context: "Contexte",
    aff_history_date: "Date",
    aff_history_by: "Affecté par",
    aff_context_case: "Dossier",
    aff_context_rendezvous: "Audience",
    aff_score: "Score",
    aff_recommended: "Recommandé",

    // External Lawyers
    external_lawyers: "Avocats externes",
    external_lawyers_desc: "Gérer les avocats externes associés au cabinet",
    ext_add: "Ajouter un avocat externe",
    ext_edit: "Modifier l'avocat externe",
    ext_delete: "Supprimer l'avocat externe",
    ext_delete_desc: "Êtes-vous sûr de vouloir supprimer cet avocat externe ? Cette action est irréversible.",
    ext_col_name: "Nom",
    ext_col_email: "Email",
    ext_col_created: "Ajouté le",
    ext_name_placeholder: "Ex : Maître Dupont",
    ext_email_placeholder: "email@cabinet.ma",
    ext_created: "Avocat externe ajouté avec succès",
    ext_updated: "Avocat externe mis à jour",
    ext_deleted: "Avocat externe supprimé",
    ext_no_data: "Aucun avocat externe. Ajoutez-en un pour commencer.",
    ext_name_required: "Le nom est requis",
    ext_badge: "Externe",

    // Generic column names for visibility options
    tribunal_name: "Tribunal",
    total_fee: "Montant total",
    total_paid: "Montant payé",
    
    // Export and filter translations
    export: "Exporter",
    export_excel: "Exporter en Excel",
    export_pdf: "Exporter en PDF",
    export_success: "Exportation réussie",
    export_success_desc: "Le fichier a été téléchargé avec succès",
    export_error: "Erreur lors de l'exportation",
    export_error_desc: "Une erreur s'est produite lors de l'exportation du fichier",
    exporting: "Exportation en cours...",
    

    apply: "Appliquer",

    // Documents Page
    documents: "Documents",
    documents_desc: "Consultez et recherchez tous les fichiers du cabinet",
    doc_search_placeholder: "Rechercher par nom de fichier ou dossier...",
    doc_col_filename: "Nom du fichier",
    doc_col_type: "Type",
    doc_col_size: "Taille",
    doc_col_case: "Dossier",
    doc_col_uploaded_by: "Ajouté par",
    doc_col_date: "Date",
    full_text_search: "Recherche plein texte",
    full_text_search_desc: "Recherche dans le contenu des fichiers via OCR",
    full_text_search_placeholder: "Recherchez dans le contenu des fichiers...",
    search_snippet: "Contexte",
    no_match_context: "Pas de contexte",

    // Lawyer Profile — French
    lawyer_profile: "Page Avocat",
    lawyer_profile_desc: "Gérez votre page publique visible par les visiteurs",
    publish_profile: "Publier la page",
    publish_profile_desc: "Quand activé, votre page sera visible publiquement",
    show_section: "Afficher la section",
    identity: "Identité",
    identity_desc: "Vos informations personnelles et professionnelles",
    full_name: "Nom complet en Arabe",
    bar_number: "Numéro d'inscription au barreau",
    bar_city: "Barreau de rattachement",
    bio: "Biographie",
    bio_ar: "Biographie en arabe",
    bio_fr: "Biographie en français",
    contact: "Coordonnées",
    whatsapp: "WhatsApp",
    email_public: "Email public",
    website: "Site web",
    linkedin: "LinkedIn",
    cabinet_location: "Adresse du cabinet",
    cabinet_address: "Adresse",
    specializations: "Spécialisations",
    experience: "Expérience",
    years_of_experience: "Années d'expérience",
    education: "Formation",
    degree: "Diplôme",
    institution: "Établissement",
    add_education: "Ajouter une formation",
    certifications: "Certifications",
    certification_title: "Intitulé",
    issuer: "Organisme",
    add_certification: "Ajouter une certification",
    languages_spoken: "Langues",
    save_profile: "Enregistrer la page",
    profile_deleted: "Page supprimée",
    delete_profile: "Supprimer la page avocat",
    saved_successfully: "Enregistré avec succès",
    photo_profile: "Photo de profil",
    upload_photo: "Télécharger une photo",
    change_photo: "Changer la photo",
    remove_photo: "Supprimer la photo",
    full_name_fr: "Nom Complet en Français",
    rattachement_year: "Année d'inscription au barreau",
    since: "depuis",
    barreau_de: "Barreau de",
    google_maps_url: "Lien Google Maps",
    view_on_maps: "Voir sur la carte",
    select_city: "Choisir une ville",
    years: "ans",
    experience_requires_rattachement_year: "Veuillez renseigner l'année d'inscription au barreau",
    career: "Parcours professionnel",
    from_month: "Mois (de)",
    from_year: "Année (de)",
    to_month: "Mois (à)",
    to_year: "Année (à)",
    no_month: "Sans mois",
    current_position: "Poste actuel",
    present: "Aujourd'hui",
    add_career: "Ajouter un poste",
    upload_photo_hint: "JPG ou PNG — max 10 Mo",
    preview_mode: "Mode aperçu",
    close_preview: "Fermer l'aperçu",
    back_to_edit: "Retour à l'édition",
    no_name: "Aucun nom",
    publish: "Publier",
    unpublish: "Dépublier",
    confirm_publish_title: "Publier la page avocat",
    confirm_publish_desc: "Votre page sera visible publiquement. Les visiteurs pourront consulter vos informations. Voulez-vous continuer ?",
    confirm_unpublish_title: "Dépublier la page",
    confirm_unpublish_desc: "Votre page ne sera plus visible publiquement. Voulez-vous continuer ?",
     
    // Validation errors — French
    error_name_min: "Le nom doit contenir au moins 2 caractères",
    error_name_max: "Le nom ne doit pas dépasser 80 caractères",
    error_name_chars: "Le nom ne doit contenir que des lettres",
    error_title_max: "Le titre ne doit pas dépasser 50 caractères",
    error_bio_max: "La biographie ne doit pas dépasser 500 caractères",
    error_phone_format: "Numéro de téléphone invalide. Ex: +212600000000 ou 0600000000",
    error_email_format: "Adresse email invalide",
    error_url_https: "Le lien doit commencer par https://",
    error_career_dates: "La date de début doit être antérieure à la date de fin",
    error_form_invalid: "Le formulaire contient des erreurs, veuillez les corriger",
    // Onboarding Tour
    onboarding: {
      case_summary: {
          title: "Bienvenue dans l'analyse IA !",
          content: "Découvrez comment l'IA peut vous aider à analyser vos dossiers rapidement et avec précision.",
          mode_title: "Choisissez le type d'analyse",
          mode_content: "Basculez entre 'Résumé rapide' pour un aperçu, ou 'Analyse approfondie' pour tous les détails.",
          generate_title: "Lancer l'analyse",
          generate_content: "Cliquez ici pour générer une nouvelle analyse ou mettre à jour l'existante.",
          result_title: "Voir les résultats",
          result_content: "Les résultats apparaîtront ici : dates clés, résumé financier et recommandations.",
          key_dates_hint: "Retrouvez ici la chronologie des événements clés du dossier.",
      },
      skip: "Passer",
      next: "Suivant",
      next_with_step: "Suivant ({{current}} sur {{total}})",
      back: "Retour",
      done: "Terminer",
      welcome_video: {
        badge: "🚀 Visite guidée • 90 secondes",
        title: "Bienvenue sur AvocatPro !",
        subtitle: "Un guide rapide de 90 secondes pour découvrir comment gérer efficacement vos dossiers, audiences, rendez-vous et factures.",
        feature_cases_title: "Gestion des dossiers & affaires",
        feature_cases_desc: "Suivi centralisé des procédures, pièces jointes et historique judiciaire.",
        feature_agenda_title: "Agenda & Audiences",
        feature_agenda_desc: "Planification des rendez-vous et rappel des audiences clés.",
        feature_billing_title: "Facturation & Dépenses",
        feature_billing_desc: "Génération facile des factures d'honoraires et suivi des paiements.",
        cta_start: "Commencer à utiliser la plateforme",
        cta_skip: "Passer pour l'instant",
        dont_show_again: "Ne plus afficher cette vidéo automatiquement",
        replay_button: "Guide vidéo (90s)",
        replay_tooltip: "Revoir la vidéo explicative de la plateforme (90 secondes)",
        video_load_error: "Impossible de charger la vidéo, veuillez vérifier votre connexion ou réessayer plus tard."
      },
    }
  },
},
};

i18n
  .use(ChainedBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: "ar", // fallback language
    lng: localStorage.getItem('language') || "ar",
    supportedLngs: ["ar", "fr"], 
    debug: true, 
    interpolation: {
      escapeValue: false,
    },
    backend: {
      backends: [resourcesToBackend(local_resources)],
    },
  }).then(() => {
    const currentLanguage = i18n.language;
    document.documentElement.dir = currentLanguage === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = currentLanguage;
  });

// Function to change language and persist selection
export const changeLanguage = async (lng: 'ar' | 'fr', updateBackend: boolean = false) => {
  i18n.changeLanguage(lng);
  localStorage.setItem('language', lng);
  // Update document direction based on language
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
  
  // Update backend if requested
  if (updateBackend) {
    try {
      const { set_user_language } = await import('@/api/user');
      await set_user_language(lng);
    } catch (error) {
      console.error('Failed to update language in backend:', error);
    }
  }
};

// Function to load language preference from backend
export const loadLanguageFromBackend = async (): Promise<void> => {
  try {
    const { get_user_language } = await import('@/api/user');
    const { language } = await get_user_language();
    
    if (language && (language === 'ar' || language === 'fr')) {
      // Update language without sending to backend (avoid circular call)
      await changeLanguage(language, false);
    }
  } catch (error) {
    console.error('Failed to load language from backend:', error);
    // Fall back to localStorage or default
  }
};

// Function to refresh only cabinet case types
export const refreshCabinetCaseTypes = async (): Promise<void> => {
  const accessToken = localStorage.getItem('accessToken');
  if (!accessToken) {
    return;
  }

  try {
    const caseTypesResponse = await fetch(`${BASE_URL}/api/v1/case/type/list`, {
      headers: {
        'Authorization': `Bearer ${accessToken}`,
      },
    });
    
    if (caseTypesResponse.ok) {
      const data = await caseTypesResponse.json();
      cabinet_case_type = data;
      
      // Update translation resources
      local_resources.ar.translation.case_type_name = ["غير معروف"];
      cabinet_case_type.forEach((element) => {
        if (!local_resources.ar.translation.case_type_name.includes(element.name)) {
          local_resources.ar.translation.case_type_name.push(element.name);
        }
      });
      
      // Reload i18n resources to reflect changes
      await i18n.reloadResources();
    }
  } catch (error) {
    console.error('Error refreshing cabinet case types:', error);
  }
};

export const loadAuthenticatedTranslations = async (): Promise<void> => {
  const accessToken = localStorage.getItem('accessToken');
  if (!accessToken) {
    return;
  }

  cabinet_case_type = [];
  cabinet_role = [];
  local_resources.ar.translation.case_type_name = ["غير معروف"];
  local_resources.ar.translation.role_name = ["غير معروف"];

  try {
    const caseTypesResponse = await fetch(`${BASE_URL}/api/v1/case/type/list`, {
      headers: {
        'Authorization': `Bearer ${accessToken}`,
      },
    });
    
    if (caseTypesResponse.ok) {
      const data = await caseTypesResponse.json();
      cabinet_case_type = data;
      cabinet_case_type.forEach((element) => {
        if (!local_resources.ar.translation.case_type_name.includes(element.name)) {
          local_resources.ar.translation.case_type_name.push(element.name);
        }
      });
    }
  } catch {
    // Pass
  }
  try {
    const rolesResponse = await fetch(`${BASE_URL}/api/v1/user/role/list`, {
      headers: {
        'Authorization': `Bearer ${accessToken}`,
      },
    });
    
    if (rolesResponse.ok) {
      const data = await rolesResponse.json();
      cabinet_role = data;
      cabinet_role.forEach((element) => {
        if (!local_resources.ar.translation.role_name.includes(element.name)) {
          local_resources.ar.translation.role_name.push(element.name);
        }
      });
    }
  } catch {
    // Pass
  }

  await i18n.reloadResources();
  return;
};

export default i18n;
